(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var APIHelper = /*#__PURE__*/function () {
  function APIHelper() {
    _classCallCheck(this, APIHelper);
    this.isFetchingToken = false;
    this.tokenPromiseQueue = [];
  }
  return _createClass(APIHelper, [{
    key: "GetAccessTokenAsync",
    value: function GetAccessTokenAsync() {
      var myThis = this;
      return new Promise(function (resolve) {
        var token = localStorage.getItem('cbf-access-token');
        if (!token) {
          myThis.QueueTokenRequest(resolve);
        } else {
          try {
            var body = token.split('.')[1];
            var jsonStr = atob(body);
            var json = JSON.parse(jsonStr);
            var date = new Date((json.exp - 200) * 1000);
            if (date <= new Date()) {
              localStorage.removeItem('cbf-access-token');
              myThis.QueueTokenRequest(resolve);
            } else {
              resolve(token);
            }
          } catch (error) {
            myThis.QueueTokenRequest(resolve);
            console.error("Error retrieving token", error);
          }
        }
      });
    }
  }, {
    key: "QueueTokenRequest",
    value: function QueueTokenRequest(resolve) {
      var myThis = this;
      if (myThis.isFetchingToken) {
        myThis.tokenPromiseQueue.push(resolve);
      } else {
        this.isFetchingToken = true;
        myThis.RetrieveTokenAsync().then(function (res) {
          localStorage.setItem('cbf-access-token', res.token);
          myThis.isFetchingToken = false;
          resolve(res.token);
          while (myThis.tokenPromiseQueue.length > 0) {
            var nextResolve = myThis.tokenPromiseQueue.shift();
            nextResolve(res.token);
          }
        })["catch"](function (error) {
          myThis.isFetchingToken = false;
          console.error('Error retrieving token:', error);
        });
      }
    }
  }, {
    key: "RetrieveTokenAsync",
    value: function RetrieveTokenAsync() {
      return $.ajax({
        url: '/api/account/generate-token',
        type: "POST"
      });
    }
  }, {
    key: "SafeServiceAPICall",
    value: function SafeServiceAPICall(ajaxRequest) {
      var myThis = this;
      return new Promise(function (resolve, reject) {
        myThis.GetAccessTokenAsync().then(function (token) {
          if (!ajaxRequest.headers) {
            ajaxRequest.headers = {};
          }
          ajaxRequest.headers.Authorization = 'Bearer ' + token;
          $.ajax(ajaxRequest).then(function (res) {
            resolve(res);
          })["catch"](function (error) {
            reject(error);
          });
        })["catch"](function (error) {
          reject(error);
        });
      });
    }
  }]);
}();
var _default = exports["default"] = APIHelper;

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Turnstile = _interopRequireDefault(require("./Turnstile.js"));
var _TencentCaptcha = _interopRequireDefault(require("./TencentCaptcha.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
document.getElementById("Password-login").addEventListener("keypress", function (event) {
  if (event.key === "Enter") {
    window.Access.LoginSubmit();
  }
});
var Access = /*#__PURE__*/function () {
  function Access(cookie) {
    _classCallCheck(this, Access);
    this.Cookie = cookie;
    this.turnstile = new _Turnstile["default"]();
    this.tencentCaptcha = window.tencentCaptchaAppId ? new _TencentCaptcha["default"]() : null;

    // Pre-load Turnstile script on page load so it's ready when modal opens.
    // Skip if Tencent is active — no need to load Turnstile for Tencent portals.
    if (!this.tencentCaptcha && window.turnstileSiteKey) {
      this.turnstile.LoadTurnstile()["catch"](function (err) {
        console.warn('Failed to pre-load Turnstile:', err);
      });
    }
  }
  return _createClass(Access, [{
    key: "LoadTurnstile",
    value: function LoadTurnstile() {
      return this.turnstile.LoadTurnstile();
    }
  }, {
    key: "LoadRecaptcha",
    value: function LoadRecaptcha() {
      return new Promise(function (resolve, reject) {
        if ($('#recptcha-script').length) {
          var scriptToRemove = document.getElementById("recptcha-script");
          if (scriptToRemove) {
            $(scriptToRemove).remove();
          }
        }
        var script = document.createElement('script');
        script.id = "recptcha-script";
        script.src = "https://www.recaptcha.net/recaptcha/api.js?render=" + window.CAPTCHA_KEY;
        document.getElementsByTagName('head')[0].appendChild(script);
        resolve(true);
      });
    }
  }, {
    key: "Login",
    value: function Login(tab, companyRep) {
      if (tab == undefined) {
        tab = "login";
      }
      window.Tabs.SwitchSignUpTabs(tab, companyRep);
      $('#loginModal').modal('show');
      $('#login-screen-progress').addClass('hide');
      $('#login-error-summary').remove();
    }
  }, {
    key: "LoginForDestination",
    value: function LoginForDestination(url) {
      window.Tabs.SwitchSignUpTabs('login');
      $('#login-screen-progress').addClass('hide');
      $('#loginModal').data('GoToUrl', url);
      $('#loginModal').modal('show');
    }
  }, {
    key: "LoginWithPurpose",
    value: function LoginWithPurpose(purpose, message, tab, task, data, namespace) {
      window.Tabs.SwitchSignUpTabs(tab);
      $('#login-screen-progress').addClass('hide');
      if (purpose != undefined) {
        $('#loginModal').data('callback', purpose);
      }
      if (namespace != undefined) {
        $('#loginModal').data('namespace', namespace);
      }
      if (task != undefined) {
        $('#loginModal').data('task-name', task);
        $('#loginModal').data('task-data', data);
      } else {
        $('#loginModal').data('task-name', undefined);
        $('#loginModal').data('task-data', undefined);
      }
      if (message != undefined) {
        $('#login-error-summary').html(message);
        $('#login-error-summary').show();
      } else {
        $('#login-error-summary').remove();
      }
      $('#loginModal').modal('show');
    }
  }, {
    key: "LoginHideModal",
    value: function LoginHideModal() {
      $('#loginModal').data('callback', undefined);
      $('#loginModal').modal('hide');
      $('#login-error-summary').hide();
      $('#login-screen-progress').addClass('hide');
    }
  }, {
    key: "LoginSubmit",
    value: function LoginSubmit() {
      var _this = this;
      $('#login-screen-progress').removeClass('hide');
      $('#login-error-summary').hide();
      $('#login-error-message').addClass('hide');
      var postData = {};
      postData.Email = $('#Email-Address').val();
      postData.Password = $('#Password-login').val();
      postData.RememberMe = $('#RememberMe-login').is(':checked');
      postData.DeviceId = localStorage.getItem('cbf-device-id');
      var goToUrl = $('#loginModal').data('GoToUrl');
      $('#loginModal').data('GoToUrl', undefined);
      if (goToUrl !== undefined) {
        postData.GoToUrl = goToUrl;
      }
      if ($('#GoToUrl').length) {
        postData.GoToUrl = $('#GoToUrl').val();
      }
      if (this.tencentCaptcha) {
        var result = this.tencentCaptcha.GetResult();
        if (!result) {
          $('#login-screen-progress').addClass('hide');
          return;
        }
        postData.TencentTicket = result.ticket;
        postData.TencentRandstr = result.randstr;
        this._LoginAjax(postData);
        return;
      }
      var token = this.turnstile.GetToken();
      if (!token) {
        $('#login-screen-progress').addClass('hide');
        this.turnstile.LoadTurnstile().then(function () {
          _this.turnstile.Render('#login-turnstile-container', function (token) {
            console.log('Turnstile verified');
          });
        });
        return;
      }
      postData.TurnstileToken = token;
      this._LoginAjax(postData);
    }
  }, {
    key: "_LoginAjax",
    value: function _LoginAjax(postData) {
      var _this2 = this;
      $.ajax({
        url: window.loginUrl,
        type: 'POST',
        data: postData,
        cache: false,
        success: function success(result) {
          _this2.turnstile.Reset();
          $('#login-screen-progress').addClass('hide');
          localStorage.removeItem('cbf-access-token');
          if (result.isError) {
            if (result.lockedout || result.failure || result.unknownError) {
              //$('#loginModal').modal("hide");
              //$('#login-screen-progress').addClass('hide');
              //$("#account-lockedout-message-dialog").modal('show');
              $('#login-error-message').text(result.errorMessage);
              $('#login-error-message').removeClass('hide');
            } else if (result.portalmasq) {
              $('#loginModal').modal("hide");
              $('#login-screen-progress').addClass('hide');
              document.location.href = "/";
            } else {
              $('#login-payload').html(result.pageView);
            }
          } else if (result.lockedout) {
            $('#login-error-message').text(result.errorMessage);
            $('#login-error-message').removeClass('hide');
            $('#login-screen-progress').addClass('hide');
            $("#account-lockedout-message-dialog").modal('show');
          } else if (result.deviceAuth) {
            $('#User-Id').val(result.userId);
            $('#login-input-box-area').hide();
            if (result.totpRequired) {
              $('#device-totp-require-section').show();
              if (_this2.tencentCaptcha) {
                _this2.tencentCaptcha.Render('auth-device-totp-tencent-container');
              }
            } else {
              $('#device-code-require-section').show();
              if (_this2.tencentCaptcha) {
                _this2.tencentCaptcha.Render('auth-device-tencent-container');
              }
              setTimeout(function () {
                $("#resend-device-auth-code-button").removeClass("hide");
              }, 150000);
            }
          } else {
            var cook = _this2.Cookie.GetCookie("FrnHOST");
            var cookieValues = {};
            if (cook !== "") {
              cookieValues = JSON.parse(_this2.Cookie.GetValue("state", cook));
            }
            cookieValues.logged = "1";
            cookieValues.letter = result.letter;
            var roleA = "";
            if (result.roles != undefined) {
              roleA = result.roles.replace(/[\x00-\x1F\x7F-\x9F]/g, "");
            }
            cookieValues.roles = roleA;
            _this2.Cookie.SetCookie("FrnHOST", "state=" + JSON.stringify(cookieValues), 1);
            var callback = $('#loginModal').data('callback');
            $('#loginModal').data('callback', undefined);
            $('#client-profile-id').val(result.clientId);
            localStorage.setItem("client-profile-id", result.clientId);
            $("#client-verified").val(result.verified ? "1" : "0");
            window.userIsOnline = true;
            $('#loginModal').modal("hide");
            $('#login-screen-progress').addClass('hide');
            if (callback == undefined) {
              if (result.GoToUrl === "" || result.GoToUrl == undefined) {
                location.reload();
              } else {
                document.location.href = result.GoToUrl;
              }
            } else {
              var namespace = $('#loginModal').data('namespace');
              $('#loginModal').data('namespace', undefined);
              if (namespace == undefined) {
                window[callback]();
              } else {
                if (namespace == "window.SocialProfile") {
                  window.SocialProfile[callback]();
                }
              }
              window.userIsOnline = true;
              window.CacheBuster.Refresh();
            }
          }
        },
        error: function error(result) {
          $('#login-screen-progress').addClass('hide');
          alert("there was an error");
        }
      });

      //grecaptcha.ready(() => {
      //    grecaptcha.execute(window.captchaKey, { action: 'LoginSubmit' })
      //        .then((token) => {
      //            // Set `token` in a hidden form input.
      //            postData.CaptchaKey = token;
      //            console.log("Generated reCAPTCHA token:", token);

      //            console.log("Hostname:", window.location.hostname);

      //        });
      //});
    }
  }, {
    key: "ResendDeviceAuthCode",
    value: function ResendDeviceAuthCode() {
      var postData = {};
      postData.UserId = $('#User-Id').val();
      postData.DeviceId = localStorage.getItem('cbf-device-id');
      $.ajax({
        url: "/api/client/resend-auth-device",
        type: 'POST',
        data: postData,
        cache: false,
        success: function success() {
          window.toastr.success("Code is sent successfully!");
          $("#resend-device-auth-code-button").addClass("hide");
          setTimeout(function () {
            $("#resend-device-auth-code-button").removeClass("hide");
          }, 150000);
        },
        error: function error(result) {
          window.toastr.error("Failed to send code!");
        }
      });
    }
  }, {
    key: "DeviceAuthSubmit",
    value: function DeviceAuthSubmit() {
      var _this3 = this;
      $('#login-screen-progress').removeClass('hide');
      $('#login-error-summary').hide();
      var postData = {};
      postData.UserId = $('#User-Id').val();
      var isTotpMode = $('#device-totp-require-section').is(':visible');
      postData.IsTotp = isTotpMode;
      postData.Code = isTotpMode ? $('#Device-Totp-Code').val() : $('#Device-Authorization-Code').val();
      postData.RememberMe = $('#RememberMe-login').is(':checked');
      postData.DeviceId = localStorage.getItem('cbf-device-id');
      var goToUrl = $('#loginModal').data('GoToUrl');
      $('#loginModal').data('GoToUrl', undefined);
      if (goToUrl !== undefined) {
        postData.GoToUrl = goToUrl;
      }
      if ($('#GoToUrl').length) {
        postData.GoToUrl = $('#GoToUrl').val();
      }
      if (this.tencentCaptcha) {
        var result = this.tencentCaptcha.GetResult();
        if (!result) {
          $('#login-screen-progress').addClass('hide');
          return;
        }
        postData.TencentTicket = result.ticket;
        postData.TencentRandstr = result.randstr;
        this._DeviceAuthAjax(postData);
        return;
      }
      var token = this.turnstile.GetToken();
      if (!token) {
        $('#login-screen-progress').addClass('hide');
        var turnstileContainer = isTotpMode ? '#auth-device-totp-turnstile-container' : '#auth-device-turnstile-container';
        this.turnstile.LoadTurnstile().then(function () {
          _this3.turnstile.Render(turnstileContainer, function (token) {
            console.log('Turnstile verified');
          });
        });
        return;
      }
      postData.TurnstileToken = token;
      this._DeviceAuthAjax(postData);
    }
  }, {
    key: "_DeviceAuthAjax",
    value: function _DeviceAuthAjax(postData) {
      var _this4 = this;
      $.ajax({
        url: "/api/client/auth-device",
        type: 'POST',
        data: postData,
        cache: false,
        success: function success(result) {
          _this4.turnstile.Reset();
          localStorage.removeItem('cbf-access-token');
          if (result.isError) {
            if (result.lockedout) {
              $('#loginModal').modal("hide");
              $('#login-screen-progress').addClass('hide');
              $("#account-lockedout-message-dialog").modal('show');
            } else {
              alert("there was an error");
            }
          } else {
            var cook = _this4.Cookie.GetCookie("FrnHOST");
            var cookieValues = {};
            if (cook !== "") {
              cookieValues = JSON.parse(_this4.Cookie.GetValue("state", cook));
            }
            cookieValues.logged = "1";
            cookieValues.letter = result.letter;
            var roleA = "";
            if (result.roles != undefined) {
              roleA = result.roles.replace(/[\x00-\x1F\x7F-\x9F]/g, "");
            }
            cookieValues.roles = roleA;
            _this4.Cookie.SetCookie("FrnHOST", "state=" + JSON.stringify(cookieValues), 1);
            var callback = $('#loginModal').data('callback');
            $('#loginModal').data('callback', undefined);
            $('#client-profile-id').val(result.clientId);
            localStorage.setItem("client-profile-id", result.clientId);
            $("#client-verified").val(result.verified ? "1" : "0");
            window.userIsOnline = true;
            $('#loginModal').modal("hide");
            $('#login-screen-progress').addClass('hide');
            if (callback == undefined) {
              if (result.GoToUrl === "" || result.GoToUrl == undefined) {
                location.reload();
              } else {
                document.location.href = result.GoToUrl;
              }
            } else {
              window[callback]();
              window.userIsOnline = true;
              window.CacheBuster.Refresh();
            }
          }
        },
        error: function error(result) {
          _this4.turnstile.Reset();
          $('#login-screen-progress').addClass('hide');
          $('#Device-Authorization-Code').val('');
          alert("there was an error");
        }
      });

      //grecaptcha.ready(() => {
      //    grecaptcha.execute(window.captchaKey, { action: 'DeviceAuthSubmit' })
      //        .then((token) => {
      //            // Set `token` in a hidden form input.
      //            postData.CaptchaKey = token;
      //            console.log("Generated reCAPTCHA token:", token);

      //            console.log("Hostname:", window.location.hostname);

      //        });
      //});
    }
  }, {
    key: "LogoutSubmit",
    value: function LogoutSubmit() {
      var cook = this.Cookie.GetCookie("FrnHOST");
      var cookieValues = {};
      if (cook !== "") {
        cookieValues = JSON.parse(this.Cookie.GetValue("state", cook));
      }
      cookieValues.logged = "0";
      cookieValues.roles = "[\"Guest\"]";
      this.Cookie.SetCookie("FrnHOST", "state=" + JSON.stringify(cookieValues), 1);
      if ($('#promoheader').length) {
        $('#promoheader').hide();
        var promoCookie = this.Cookie.GetCookie("cbfxv");
        if (promoCookie !== undefined) {
          this.Cookie.DeleteCookie("cbfxv");
        }
      }
      if ($('#signup-header').length) {
        $('#signup-header').show();
      }
      this.ClearCache();
      localStorage.removeItem('masqueradeLoginTime');
      document.getElementById('logoutForm').submit();
    }
  }, {
    key: "LogoutFromAllDevice",
    value: function LogoutFromAllDevice() {
      $('#settings-progress').removeClass('hide');
      var myThis = this;
      $.ajax({
        url: "/api/client/logout-from-all-devices",
        type: 'POST',
        cache: false,
        success: function success() {
          myThis.LogoutSubmit();
        },
        error: function error(result) {
          $('#settings-progress').addClass('hide');
          window.toastr.error("Failed to logout from all devices!");
        }
      });
    }
  }, {
    key: "ForgottenPasswordSubmit",
    value: function ForgottenPasswordSubmit() {
      var _this5 = this;
      $('#login-screen-progress').removeClass('hide');
      var postData = {};
      $('#login-error-summary').hide();
      postData.__RequestVerificationToken = $('#Registration-Form :hidden:first').val();
      postData.Email = $('#Email-Address-Forgot').val();
      if (this.tencentCaptcha) {
        var result = this.tencentCaptcha.GetResult();
        if (!result) {
          $('#login-screen-progress').addClass('hide');
          return;
        }
        postData.TencentTicket = result.ticket;
        postData.TencentRandstr = result.randstr;
        this._ForgottenPasswordAjax(postData);
        return;
      }
      var token = this.turnstile.GetToken();
      if (!token) {
        $('#login-screen-progress').addClass('hide');
        this.turnstile.LoadTurnstile().then(function () {
          _this5.turnstile.Render('#forgotten-turnstile-container', function (token) {
            console.log('Turnstile verified');
          });
        });
        return;
      }
      postData.TurnstileToken = token;
      this._ForgottenPasswordAjax(postData);
    }
  }, {
    key: "_ForgottenPasswordAjax",
    value: function _ForgottenPasswordAjax(postData) {
      var _this6 = this;
      $.ajax({
        url: window.forgottenPasswordUrl,
        type: 'POST',
        data: postData,
        cache: false,
        success: function success(result) {
          _this6.turnstile.Reset();
          if (result.isError) {
            $('#forgotten-payload').html(result.pageView);
            $('#login-screen-progress').addClass('hide');
          } else {
            if (window.DEFAULT_LANG === window.CURRENT_LANG) window.location.href = "/";else window.location.href = "/" + window.CURRENT_LANG;
          }
        },
        error: function error(result) {
          _this6.turnstile.Reset();
          $('#login-screen-progress').addClass('hide');
          alert("there was an error");
        }
      });

      //grecaptcha.ready(() => {
      //    grecaptcha.execute(window.captchaKey, { action: 'ForgottenPasswordSubmit' })
      //        .then((token) => {
      //            // Set `token` in a hidden form input.
      //            postData.CaptchaKey = token;
      //        });
      //});
    }
  }, {
    key: "SignUpSubmit",
    value: function SignUpSubmit() {
      var _this7 = this;
      $('#login-error-summary').hide();
      $('#login-screen-progress').removeClass('hide');
      var postData = {};
      postData.__RequestVerificationToken = $('#Registration-Form :hidden:first').val();
      postData.PublicName = $('#PublicName-Sign-Up').val();
      postData.DisplayName = $('#FullName-Sign-Up').val();
      postData.Email = $('#Email-Address-Sign-Up').val();
      postData.PromoCode = $('#PromoCode').val();
      postData.Password = $('#Password-Sign-Up').val();
      postData.Newsletter = $('#Newsletter-Sign-Up').is(':checked');
      postData.ContestNotification = $("#ContestNotification-Sign-Up").is(":checked");
      postData.DeviceId = localStorage.getItem('cbf-device-id');
      postData.SignUpAsCompanyRep = $("#sign-up-as-companyrep").is(":checked");
      postData.RawUrl = window.location.href;
      //postData.Timezone = window.moment.tz.guess();

      if (window.bypassReCaptcha) {
        this.SignUpSubmitWorker(postData);
      } else if (this.tencentCaptcha) {
        var result = this.tencentCaptcha.GetResult();
        if (!result) {
          $('#login-screen-progress').addClass('hide');
          return;
        }
        postData.TencentTicket = result.ticket;
        postData.TencentRandstr = result.randstr;
        this.SignUpSubmitWorker(postData);
      } else {
        var token = this.turnstile.GetToken();
        if (!token) {
          $('#login-error-message').text('Please complete the verification');
          $('#login-error-message').removeClass('hide');
          $('#login-screen-progress').addClass('hide');
          this.turnstile.LoadTurnstile().then(function () {
            _this7.turnstile.Render('#signup-turnstile-container', function (token) {
              console.log('Turnstile verified');
            });
          });
          return;
        }
        postData.TurnstileToken = token;
        this.SignUpSubmitWorker(postData);

        //grecaptcha.ready(() => {
        //    grecaptcha.execute(window.captchaKey, { action: 'SignupSubmit' })
        //        .then((token) => {
        //            // Set `token` in a hidden form input.
        //            postData.CaptchaKey = token;

        //            this.SignUpSubmitWorker(postData);

        //        });
        //});
      }
    }
  }, {
    key: "SignUpSubmitWorker",
    value: function SignUpSubmitWorker(postData) {
      var _this8 = this;
      if (window.affiliate != undefined) {
        // Check for Affiliate / Banner / Campaign ID cookies
        var aidCookie = this.Cookie.GetCookie("affiliateID");
        // if yes, assign aid value
        if (window.affiliate.IsNumeric(aidCookie)) {
          postData.AffiliateId = aidCookie;
        }
        var cidCookie = this.Cookie.GetCookie("affiliateCampaignId");
        // if yes, assign cid value
        if (window.affiliate.IsNumeric(cidCookie)) {
          postData.AffiliateCampaignId = cidCookie;
        }
        var bidCookie = this.Cookie.GetCookie("bannerId");
        // if yes, assign cid value
        if (window.affiliate.IsNumeric(bidCookie)) {
          postData.BannerId = bidCookie;
        }
      }
      var taskname = $('#loginModal').data('task-name');
      if (taskname !== undefined) {
        var taskdata = $('#loginModal').data('task-data');
        postData.TaskData = taskdata;
        postData.TaskName = taskname;
        $('#loginModal').data('task-data', undefined);
        $('#loginModal').data('task-name', undefined);
      }
      $.ajax({
        url: window.signUpUrl,
        type: 'POST',
        data: postData,
        cache: false,
        success: function success(result) {
          _this8.turnstile.Reset();
          if (result.isError) {
            $('#signup-payload').html(result.pageView);
            $('#login-screen-progress').addClass('hide');
          } else {
            $('#loginModal').data('task-data', undefined);
            $('#loginModal').data('task-name', undefined);
            var cook = _this8.Cookie.GetCookie("FrnHOST");
            var cookieValues = {};
            if (cook !== "") {
              cookieValues = JSON.parse(_this8.Cookie.GetValue("state", cook));
            }
            cookieValues.logged = "1";
            cookieValues.letter = result.letter;
            var roleA = "";
            if (result.roles != undefined) {
              roleA = result.roles.replace(/[\x00-\x1F\x7F-\x9F]/g, "");
            }
            cookieValues.roles = roleA;
            _this8.Cookie.SetCookie("FrnHOST", "state=" + JSON.stringify(cookieValues), 1);
            var callback = $('#loginModal').data('callback');
            $('#loginModal').data('callback', undefined);
            $('#client-profile-id').val(result.clientId);
            localStorage.setItem("client-profile-id", result.clientId);
            $("#client-verified").val(result.verified ? "1" : "0");
            var defaultRedirectUrl = "/dashboard/settings";
            if (result.companyRep) {
              defaultRedirectUrl = "/account/company-reps/onboarding";
            }
            if (callback == undefined) {
              if (result.GoToUrl === "" || result.GoToUrl == undefined) {
                if (window.DEFAULT_LANG === window.CURRENT_LANG) window.location.href = defaultRedirectUrl;else window.location.href = "/" + window.CURRENT_LANG + defaultRedirectUrl;
              } else {
                document.location.href = result.GoToUrl;
              }
            } else {
              window[callback]();
              window.userIsOnline = true;
              window.CacheBuster.Refresh();
            }
          }
        },
        error: function error(result) {
          _this8.turnstile.Reset();
          $('#login-screen-progress').addClass('hide');
          alert("there was an error");
        }
      });
    }
  }, {
    key: "SubmitLogin",
    value: function SubmitLogin(provider) {
      $('#login-screen-progress').removeClass('hide');

      // Disable Remote Login - to enable remote login, please comment out.
      //if (provider === "CBF" || provider === "RKFX") {
      //    var postData = {};
      //    postData.provider = provider;
      //    $.ajax({
      //        url: window.familyLoginUrl,
      //        type: 'POST',
      //        data: postData,
      //        cache: false,
      //        success: (result) => {

      //            if (result.isError) {
      //                warning(result.message);
      //                $('#login-screen-progress').addClass('hide');
      //            } else {

      //                this.CreateFamilyLoginResult(result.destination, result.token);
      //            }
      //        }
      //    });

      //} else {

      //    $('#provider_id').val(provider);
      //    $('#ExternalLogin').submit();
      //}
      $('#provider_id').val(provider);
      $('#signupFullUrl').val(window.location.href);
      $('#ExternalLogin').submit();
    }
  }, {
    key: "CreateFamilyLoginResult",
    value: function CreateFamilyLoginResult(destination, token) {
      var windowName = 'w_' + Date.now() + Math.floor(Math.random() * 100000).toString();
      var form = document.createElement("form");
      form.setAttribute("method", "post");
      form.setAttribute("action", destination + '/' + window.CURRENT_LANG + "/authorisation");
      form.setAttribute("target", windowName);
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", "token");
      hiddenField.setAttribute("value", token);
      form.appendChild(hiddenField);
      document.body.appendChild(form);
      var openedWindow = window.open('', windowName, 'width=500,height=490');
      openedWindow.realOpener = window;
      window.addEventListener("message", function (event) {
        console.log(event);
        console.log(event.data);

        // Do we trust the sender of this message?  (might be
        // different from what we originally opened, for example).
        if (event.origin !== destination) return;
        openedWindow.close();
        $.ajax({
          url: window.familyLoginReturnUrl,
          type: 'POST',
          data: {
            data: event.data
          },
          cache: false,
          success: function success(result) {
            console.log("Result:", result);
            if (result.isError) {
              window.toastr.warning(result.message);
              $('#login-screen-progress').addClass('hide');
            } else {
              var callback = $('#loginModal').data('callback');
              console.log("CallBack:", callback);
              $('#loginModal').data('callback', undefined);
              if (callback == undefined) {
                if (result.GoToUrl === "" || result.GoToUrl == undefined) {
                  document.location.reload();
                } else {
                  document.location.href = result.GoToUrl;
                }
              } else {
                $('#loginModal').modal('hide');
                var pathArray = callback.split(".");
                console.log("PATHARRAY:", pathArray);
                var index = 0;
                var c = window;
                while (index < pathArray.length) {
                  if (index + 1 == pathArray.length) {
                    c[pathArray[index]]();
                  } else {
                    c = c[pathArray[index]];
                  }
                  index++;
                }
                console.log("C:", c);
                window.CacheBuster.Refresh();
              }
            }
          }
        });

        // event.source is popup
        // event.data is "hi there yourself!  the secret response is: rheeeeet!"
      }, false);
      form.submit();
    }
  }, {
    key: "ChangePasswordSubmit",
    value: function ChangePasswordSubmit() {
      var _this9 = this;
      if (window.bypassReCaptcha) {
        $('#ResetPassword-progress').removeClass('hide');
        $('#ResetPasswordForm').submit();
      } else {
        if ($('#ResetPasswordForm').length) {
          if (this.tencentCaptcha) {
            this.tencentCaptcha.Show('reset-password-tencent-container', function (ticket, randstr) {
              $('#TencentTicket').val(ticket);
              $('#TencentRandstr').val(randstr);
              $('#ResetPassword-progress').removeClass('hide');
              $('#ResetPasswordForm').submit();
            }, function () {
              $('#ResetPassword-progress').addClass('hide');
            });
            return;
          }
          var token = this.turnstile.GetToken();
          if (!token) {
            $('#ResetPassword-progress').addClass('hide');
            this.turnstile.LoadTurnstile().then(function () {
              _this9.turnstile.Render('#reset-password-turnstile-container', function (token) {
                console.log('Turnstile verified');
              });
            });
            return;
          }
          $('#TurnstileToken').val(token);
          $('#ResetPasswordForm').submit();
          //grecaptcha.ready(() => {
          //    grecaptcha.execute(window.captchaKey, { action: 'ChangePasswordSubmit' })
          //        .then((token) => {
          //            // Set `token` in a hidden form input.
          //            $('#CaptchaKey').val(token);
          //            $('#ResetPassword-progress').removeClass('hide');
          //            $('#ResetPasswordForm').submit()
          //        });
          //});
        }
      }
    }
  }, {
    key: "SubmitSettingsForm",
    value: function () {
      var _SubmitSettingsForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _document$getElementB, _document$getElementB2, _document$getElementB3, _document$getElementB4, _document$getElementB5, _document$getElementB6, _document$getElementB7, _document$getElementB8, _document$getElementB9, _document$getElementB0;
        var postData, response, result, outcomeMessageHtml, container, existing, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              $('#settings-progress').removeClass('hide');
              postData = {
                ClientProfileId: parseInt(((_document$getElementB = document.getElementById('ClientProfileId')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.value) || '0', 10),
                SocialProfileId: parseInt(((_document$getElementB2 = document.getElementById('SocialProfileId')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.value) || '0', 10),
                Fullname: ((_document$getElementB3 = document.getElementById('Fullname')) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.value) || '',
                ForumHandle: ((_document$getElementB4 = document.getElementById('ForumHandle')) === null || _document$getElementB4 === void 0 ? void 0 : _document$getElementB4.value) || '',
                Timezone: ((_document$getElementB5 = document.getElementById('Timezone')) === null || _document$getElementB5 === void 0 ? void 0 : _document$getElementB5.value) || '',
                PublicName: ((_document$getElementB6 = document.getElementById('PublicName')) === null || _document$getElementB6 === void 0 ? void 0 : _document$getElementB6.value) || '',
                DefaultCultureId: parseInt(((_document$getElementB7 = document.getElementById('DefaultCultureId')) === null || _document$getElementB7 === void 0 ? void 0 : _document$getElementB7.value) || '0', 10),
                CompanyPosition: ((_document$getElementB8 = document.getElementById('CompanyPosition')) === null || _document$getElementB8 === void 0 ? void 0 : _document$getElementB8.value) || '',
                CountryOfResidenceCode: ((_document$getElementB9 = document.getElementById('CountryOfResidenceCode')) === null || _document$getElementB9 === void 0 ? void 0 : _document$getElementB9.value) || '',
                Bio: ((_document$getElementB0 = document.getElementById('Bio')) === null || _document$getElementB0 === void 0 ? void 0 : _document$getElementB0.value) || ''
              };
              _context.p = 1;
              _context.n = 2;
              return fetch(window.clientSettingsUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(postData)
              });
            case 2:
              response = _context.v;
              _context.n = 3;
              return response.json();
            case 3:
              result = _context.v;
              $('#settings-progress').addClass('hide');
              if (!result.isError) {
                window.toastr.success('Settings updated successfully!');
              } else {
                outcomeMessageHtml = '';
                if (result.outcomeMessage) {
                  outcomeMessageHtml = '<div class="outcome-message text-danger font-13">' + window.escapeHtmlAttr(result.outcomeMessage) + '</div>';
                }
                container = document.getElementById('settings-form-inputs');
                if (container && outcomeMessageHtml) {
                  existing = container.querySelector('.outcome-message');
                  if (existing) existing.outerHTML = outcomeMessageHtml;else container.insertAdjacentHTML('afterbegin', outcomeMessageHtml);
                }
              }
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              $('#settings-progress').addClass('hide');
              console.error('SubmitSettingsForm failed:', _t);
              window.toastr.error('An unexpected error occurred. Please try again.');
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 4]]);
      }));
      function SubmitSettingsForm() {
        return _SubmitSettingsForm.apply(this, arguments);
      }
      return SubmitSettingsForm;
    }()
  }, {
    key: "SubmitSocialMediaSettingsForm",
    value: function () {
      var _SubmitSocialMediaSettingsForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _document$getElementB1, _document$getElementB10, _document$getElementB11, _document$getElementB12, _document$getElementB13, _document$getElementB14, _document$getElementB15, _document$getElementB16, _document$getElementB17;
        var postData, response, result, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              $('#social-media-settings-progress').removeClass('hide');
              postData = {
                SocialProfileId: parseInt(((_document$getElementB1 = document.getElementById('SocialProfileId')) === null || _document$getElementB1 === void 0 ? void 0 : _document$getElementB1.value) || '0', 10),
                Website: ((_document$getElementB10 = document.getElementById('Website')) === null || _document$getElementB10 === void 0 ? void 0 : _document$getElementB10.value) || '',
                TiktokUsername: ((_document$getElementB11 = document.getElementById('TiktokUsername')) === null || _document$getElementB11 === void 0 ? void 0 : _document$getElementB11.value) || '',
                LinkedIn: ((_document$getElementB12 = document.getElementById('LinkedIn')) === null || _document$getElementB12 === void 0 ? void 0 : _document$getElementB12.value) || '',
                PublicName: ((_document$getElementB13 = document.getElementById('FullName')) === null || _document$getElementB13 === void 0 ? void 0 : _document$getElementB13.value) || '',
                FacebookProfileUrl: ((_document$getElementB14 = document.getElementById('FacebookProfileUrl')) === null || _document$getElementB14 === void 0 ? void 0 : _document$getElementB14.value) || '',
                InstagramUsername: ((_document$getElementB15 = document.getElementById('InstagramUsername')) === null || _document$getElementB15 === void 0 ? void 0 : _document$getElementB15.value) || '',
                Twitter: ((_document$getElementB16 = document.getElementById('Twitter')) === null || _document$getElementB16 === void 0 ? void 0 : _document$getElementB16.value) || '',
                BlueSkyUrl: ((_document$getElementB17 = document.getElementById('BlueSkyUrl')) === null || _document$getElementB17 === void 0 ? void 0 : _document$getElementB17.value) || ''
              };
              _context2.p = 1;
              _context2.n = 2;
              return fetch(window.clientMediaSettingsUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(postData)
              });
            case 2:
              response = _context2.v;
              _context2.n = 3;
              return response.json();
            case 3:
              result = _context2.v;
              $('#social-media-settings-progress').addClass('hide');
              if (!result.isError) {
                window.toastr.success('Settings updated successfully!');
              } else {
                window.toastr.error(result.outcomeMessage || 'Failed to save social media settings.');
              }
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              $('#social-media-settings-progress').addClass('hide');
              console.error('SubmitSocialMediaSettingsForm failed:', _t2);
              window.toastr.error('An unexpected error occurred. Please try again.');
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 4]]);
      }));
      function SubmitSocialMediaSettingsForm() {
        return _SubmitSocialMediaSettingsForm.apply(this, arguments);
      }
      return SubmitSocialMediaSettingsForm;
    }()
  }, {
    key: "SubmitPasswordSettingsForm",
    value: function () {
      var _SubmitPasswordSettingsForm = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _document$getElementB18, _document$getElementB19, _document$getElementB20, _document$getElementB21;
        var progressBar, postData, response, result, outcomeMessageHtml, securityHtml, container, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              progressBar = document.getElementById('password-settings-progress');
              if (progressBar) progressBar.classList.remove('hide');
              postData = {
                Password: ((_document$getElementB18 = document.getElementById('Password')) === null || _document$getElementB18 === void 0 ? void 0 : _document$getElementB18.value) || '',
                ConfirmPassword: ((_document$getElementB19 = document.getElementById('ConfirmPassword')) === null || _document$getElementB19 === void 0 ? void 0 : _document$getElementB19.value) || '',
                CurrentPassword: ((_document$getElementB20 = document.getElementById('CurrentPassword')) === null || _document$getElementB20 === void 0 ? void 0 : _document$getElementB20.value) || '',
                SocialProfileId: parseInt(((_document$getElementB21 = document.getElementById('SocialProfileId')) === null || _document$getElementB21 === void 0 ? void 0 : _document$getElementB21.value) || '0', 10)
              };
              _context3.p = 1;
              _context3.n = 2;
              return fetch(window.clientSecuritySettingsUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(postData)
              });
            case 2:
              response = _context3.v;
              _context3.n = 3;
              return response.json();
            case 3:
              result = _context3.v;
              if (!result.isError) {
                window.toastr.success('Password updated successfully');
              }
              outcomeMessageHtml = '';
              if (result.outcomeMessage) {
                outcomeMessageHtml = '<div class="outcome-message text-danger font-13">' + window.escapeHtmlAttr(result.outcomeMessage) + '</div>';
              }
              _context3.n = 4;
              return window.loadTemplate('settings-security');
            case 4:
              securityHtml = _context3.v;
              securityHtml = securityHtml.replace(/\{\{OutcomeMessage\}\}/g, outcomeMessageHtml);
              container = document.getElementById('settings-password-form-inputs');
              if (container) container.innerHTML = securityHtml;
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t3 = _context3.v;
              console.error('SubmitPasswordSettingsForm failed:', _t3);
              window.toastr.error('An unexpected error occurred. Please try again.');
            case 6:
              _context3.p = 6;
              if (progressBar) progressBar.classList.add('hide');
              return _context3.f(6);
            case 7:
              return _context3.a(2);
          }
        }, _callee3, null, [[1, 5, 6, 7]]);
      }));
      function SubmitPasswordSettingsForm() {
        return _SubmitPasswordSettingsForm.apply(this, arguments);
      }
      return SubmitPasswordSettingsForm;
    }() // ── 2FA / Security tab methods ────────────────────────────────────────────
    /** Returns the ASP.NET anti-forgery token value injected in the page layout. */
  }, {
    key: "_getCsrfToken",
    value: function _getCsrfToken() {
      var _document$querySelect;
      return ((_document$querySelect = document.querySelector('#logoutForm input[name=__RequestVerificationToken]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.value) || '';
    }

    /**
     * Re-renders the 2FA card contents inside #settings-tfa-form-inputs
     * after any action (verify, disable, etc.).
     */
  }, {
    key: "_refreshTfaCard",
    value: (function () {
      var _refreshTfaCard2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var resp, result, html, emailSel, totpSel, totpEnabled, emailBadge, totpBadge, totpBtn, container, _t4;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return fetch(window.client2FASettingsUrl, {
                credentials: 'same-origin'
              });
            case 1:
              resp = _context4.v;
              _context4.n = 2;
              return resp.json();
            case 2:
              result = _context4.v;
              if (!result.isError) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2);
            case 3:
              _context4.n = 4;
              return window.loadTemplate('settings-tfa');
            case 4:
              html = _context4.v;
              emailSel = !result.preferredMethod || result.preferredMethod === 'Email' ? 'selected' : '';
              totpSel = result.preferredMethod === 'Authenticator' ? 'selected' : '';
              totpEnabled = result.totpEnabled; // Enabled badge tracks the active preferred method, not just whether it exists
              emailBadge = result.preferredMethod === 'Email' || !result.preferredMethod ? "<span class=\"tfa-badge tfa-badge-enabled\">".concat(window.tfaStr.badgeEnabled, "</span>") : '';
              totpBadge = totpEnabled && result.preferredMethod === 'Authenticator' ? "<span class=\"tfa-badge tfa-badge-enabled\">".concat(window.tfaStr.badgeEnabled, "</span>") : '';
              totpBtn = totpEnabled ? "<a href=\"javascript:void(0)\" onclick=\"window.Access.Disable2FATOTP()\" role=\"button\" class=\"tfa-action-btn\">".concat(window.tfaStr.disable, "</a>") : "<a href=\"javascript:void(0)\" onclick=\"window.Access.Setup2FAEmailSend()\" role=\"button\" class=\"tfa-action-btn\">".concat(window.tfaStr.setUp, "</a>");
              html = html.replace(/\{\{EmailSelected\}\}/g, emailSel).replace(/\{\{TotpSelected\}\}/g, totpSel).replace(/\{\{EmailCardBadge\}\}/g, emailBadge).replace(/\{\{TotpCardBadge\}\}/g, totpBadge).replace(/\{\{TotpCardButton\}\}/g, totpBtn);
              container = document.getElementById('settings-tfa-form-inputs');
              if (container) {
                container.innerHTML = html;
                $(container).find('[data-toggle="tooltip"]').tooltip({
                  boundary: 'window'
                });
              }
              _context4.n = 6;
              break;
            case 5:
              _context4.p = 5;
              _t4 = _context4.v;
              console.error('_refreshTfaCard failed:', _t4);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, null, [[0, 5]]);
      }));
      function _refreshTfaCard() {
        return _refreshTfaCard2.apply(this, arguments);
      }
      return _refreshTfaCard;
    }()
    /**
     * Saves the preferred 2FA method when the dropdown changes.
     */
    )
  }, {
    key: "Submit2FAMethod",
    value: (function () {
      var _Submit2FAMethod = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _document$getElementB22;
        var progressBar, method, check, status, resp, result, _t5, _t6;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              progressBar = document.getElementById('tfa-method-progress');
              if (progressBar) progressBar.classList.remove('hide');
              method = ((_document$getElementB22 = document.getElementById('PreferredTfaMethod')) === null || _document$getElementB22 === void 0 ? void 0 : _document$getElementB22.value) || 'Email'; // Guard: block selecting Authenticator if TOTP is not yet set up
              if (!(method === 'Authenticator')) {
                _context5.n = 7;
                break;
              }
              _context5.p = 1;
              _context5.n = 2;
              return fetch(window.client2FASettingsUrl, {
                credentials: 'same-origin'
              });
            case 2:
              check = _context5.v;
              _context5.n = 3;
              return check.json();
            case 3:
              status = _context5.v;
              if (status.totpEnabled) {
                _context5.n = 5;
                break;
              }
              if (progressBar) progressBar.classList.add('hide');
              window.toastr.warning(window.tfaStr.setUpAuthenticatorFirst);
              _context5.n = 4;
              return this._refreshTfaCard();
            case 4:
              return _context5.a(2);
            case 5:
              _context5.n = 7;
              break;
            case 6:
              _context5.p = 6;
              _t5 = _context5.v;
              if (progressBar) progressBar.classList.add('hide');
              console.error('Submit2FAMethod guard check failed:', _t5);
              return _context5.a(2);
            case 7:
              _context5.p = 7;
              _context5.n = 8;
              return fetch(window.client2FAMethodUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                  'RequestVerificationToken': this._getCsrfToken()
                },
                body: JSON.stringify({
                  PreferredMethod: method
                }),
                credentials: 'same-origin'
              });
            case 8:
              resp = _context5.v;
              _context5.n = 9;
              return resp.json();
            case 9:
              result = _context5.v;
              if (result.isError) {
                _context5.n = 11;
                break;
              }
              window.toastr.success(window.tfaStr.preferredMethodUpdated);
              _context5.n = 10;
              return this._refreshTfaCard();
            case 10:
              _context5.n = 12;
              break;
            case 11:
              window.toastr.error(result.outcomeMessage || window.tfaStr.failedToUpdatePreferredMethod);
              _context5.n = 12;
              return this._refreshTfaCard();
            case 12:
              _context5.n = 14;
              break;
            case 13:
              _context5.p = 13;
              _t6 = _context5.v;
              console.error('Submit2FAMethod failed:', _t6);
              window.toastr.error(window.tfaStr.unexpectedError);
            case 14:
              _context5.p = 14;
              if (progressBar) progressBar.classList.add('hide');
              return _context5.f(14);
            case 15:
              return _context5.a(2);
          }
        }, _callee5, this, [[7, 13, 14, 15], [1, 6]]);
      }));
      function Submit2FAMethod() {
        return _Submit2FAMethod.apply(this, arguments);
      }
      return Submit2FAMethod;
    }()
    /**
     * Step 1 – Sends an email OTP then opens the "Confirm With Email" dialog.
     */
    )
  }, {
    key: "Setup2FAEmailSend",
    value: (function () {
      var _Setup2FAEmailSend = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var progress, resp, result, codeInput, errDiv, _t7;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              progress = document.getElementById('tfa-sms-progress');
              if (progress) progress.classList.remove('hide');
              _context6.p = 1;
              _context6.n = 2;
              return fetch(window.client2FAEmailSendUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                  'RequestVerificationToken': this._getCsrfToken()
                },
                credentials: 'same-origin'
              });
            case 2:
              resp = _context6.v;
              _context6.n = 3;
              return resp.json();
            case 3:
              result = _context6.v;
              if (!result.isError) {
                // Clear previous state
                codeInput = document.getElementById('tfa-email-code');
                errDiv = document.getElementById('tfa-email-error');
                if (codeInput) codeInput.value = '';
                if (errDiv) {
                  errDiv.style.display = 'none';
                  errDiv.textContent = '';
                }
                $('#tfa-confirm-email-dialog').modal('show');
              } else {
                window.toastr.error(result.outcomeMessage || window.tfaStr.failedToSendEmailCode);
              }
              _context6.n = 5;
              break;
            case 4:
              _context6.p = 4;
              _t7 = _context6.v;
              console.error('Setup2FAEmailSend failed:', _t7);
              window.toastr.error(window.tfaStr.unexpectedError);
            case 5:
              _context6.p = 5;
              if (progress) progress.classList.add('hide');
              return _context6.f(5);
            case 6:
              return _context6.a(2);
          }
        }, _callee6, this, [[1, 4, 5, 6]]);
      }));
      function Setup2FAEmailSend() {
        return _Setup2FAEmailSend.apply(this, arguments);
      }
      return Setup2FAEmailSend;
    }()
    /**
     * Step 2 – Verifies the email OTP; on success closes dialog 1 and opens dialog 2.
     */
    )
  }, {
    key: "Setup2FAEmailVerify",
    value: (function () {
      var _Setup2FAEmailVerify = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _document$getElementB23;
        var code, errDiv, progress, resp, result, totpErr, totpCode, _t8;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              code = ((_document$getElementB23 = document.getElementById('tfa-email-code')) === null || _document$getElementB23 === void 0 || (_document$getElementB23 = _document$getElementB23.value) === null || _document$getElementB23 === void 0 ? void 0 : _document$getElementB23.trim()) || '';
              errDiv = document.getElementById('tfa-email-error');
              progress = document.getElementById('tfa-email-dialog-progress');
              if (code) {
                _context7.n = 1;
                break;
              }
              if (errDiv) {
                errDiv.textContent = window.tfaStr.enterVerificationCode;
                errDiv.style.display = 'block';
              }
              return _context7.a(2);
            case 1:
              if (progress) progress.classList.remove('hide');
              _context7.p = 2;
              _context7.n = 3;
              return fetch(window.client2FAEmailVerifyUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                  'RequestVerificationToken': this._getCsrfToken()
                },
                body: JSON.stringify({
                  Code: code
                }),
                credentials: 'same-origin'
              });
            case 3:
              resp = _context7.v;
              _context7.n = 4;
              return resp.json();
            case 4:
              result = _context7.v;
              if (!result.isError) {
                $('#tfa-confirm-email-dialog').modal('hide');
                // Reset TOTP dialog state
                totpErr = document.getElementById('tfa-totp-error');
                totpCode = document.getElementById('tfa-totp-code');
                if (totpErr) {
                  totpErr.style.display = 'none';
                  totpErr.textContent = '';
                }
                if (totpCode) totpCode.value = '';
                // Request QR code from server then open dialog
                window.Access.Setup2FATotpGetQr();
              } else {
                if (errDiv) {
                  errDiv.textContent = result.outcomeMessage || 'Invalid code.';
                  errDiv.style.display = 'block';
                }
              }
              _context7.n = 6;
              break;
            case 5:
              _context7.p = 5;
              _t8 = _context7.v;
              console.error('Setup2FAEmailVerify failed:', _t8);
              if (errDiv) {
                errDiv.textContent = window.tfaStr.unexpectedError;
                errDiv.style.display = 'block';
              }
            case 6:
              _context7.p = 6;
              if (progress) progress.classList.add('hide');
              return _context7.f(6);
            case 7:
              return _context7.a(2);
          }
        }, _callee7, this, [[2, 5, 6, 7]]);
      }));
      function Setup2FAEmailVerify() {
        return _Setup2FAEmailVerify.apply(this, arguments);
      }
      return Setup2FAEmailVerify;
    }()
    /**
     * Step 3 – Requests a TOTP secret + QR URI from the server, renders the QR, then opens Dialog 2.
     */
    )
  }, {
    key: "Setup2FATotpGetQr",
    value: (function () {
      var _Setup2FATotpGetQr = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var resp, result, qrContainer, manualKey, _t9;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              _context8.p = 0;
              _context8.n = 1;
              return fetch(window.client2FATotpSetupUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                  'RequestVerificationToken': this._getCsrfToken()
                },
                credentials: 'same-origin'
              });
            case 1:
              resp = _context8.v;
              _context8.n = 2;
              return resp.json();
            case 2:
              result = _context8.v;
              if (!result.isError) {
                // Store secret for later submission
                window._totpPendingSecret = result.secret;

                // Render QR code
                qrContainer = document.getElementById('tfa-totp-qr');
                if (qrContainer) {
                  qrContainer.innerHTML = '';
                  new QRCode(qrContainer, {
                    text: result.otpauthUri,
                    width: 180,
                    height: 180,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.M
                  });
                }

                // Show manual key
                manualKey = document.getElementById('tfa-totp-manual-key');
                if (manualKey) manualKey.textContent = result.secret;
                $('#tfa-setup-totp-dialog').modal('show');
              } else {
                window.toastr.error(result.outcomeMessage || window.tfaStr.failedToGenerateSetup);
              }
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t9 = _context8.v;
              console.error('Setup2FATotpGetQr failed:', _t9);
              window.toastr.error(window.tfaStr.unexpectedError);
            case 4:
              return _context8.a(2);
          }
        }, _callee8, this, [[0, 3]]);
      }));
      function Setup2FATotpGetQr() {
        return _Setup2FATotpGetQr.apply(this, arguments);
      }
      return Setup2FATotpGetQr;
    }()
    /**
     * Step 4 – Verifies the first TOTP code; on success closes the dialog and refreshes the card.
     */
    )
  }, {
    key: "Verify2FATotpActivate",
    value: (function () {
      var _Verify2FATotpActivate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var _document$getElementB24;
        var code, errDiv, progress, secret, resp, result, _t0;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              code = ((_document$getElementB24 = document.getElementById('tfa-totp-code')) === null || _document$getElementB24 === void 0 || (_document$getElementB24 = _document$getElementB24.value) === null || _document$getElementB24 === void 0 ? void 0 : _document$getElementB24.trim()) || '';
              errDiv = document.getElementById('tfa-totp-error');
              progress = document.getElementById('tfa-totp-dialog-progress');
              secret = window._totpPendingSecret || '';
              if (code) {
                _context9.n = 1;
                break;
              }
              if (errDiv) {
                errDiv.textContent = window.tfaStr.enterTotpCode;
                errDiv.style.display = 'block';
              }
              return _context9.a(2);
            case 1:
              if (progress) progress.classList.remove('hide');
              _context9.p = 2;
              _context9.n = 3;
              return fetch(window.client2FATotpVerifyUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                  'RequestVerificationToken': this._getCsrfToken()
                },
                body: JSON.stringify({
                  Secret: secret,
                  Code: code
                }),
                credentials: 'same-origin'
              });
            case 3:
              resp = _context9.v;
              _context9.n = 4;
              return resp.json();
            case 4:
              result = _context9.v;
              if (result.isError) {
                _context9.n = 6;
                break;
              }
              window._totpPendingSecret = null;
              $('#tfa-setup-totp-dialog').modal('hide');
              window.toastr.success(window.tfaStr.authenticatorEnabled);
              _context9.n = 5;
              return this._refreshTfaCard();
            case 5:
              _context9.n = 7;
              break;
            case 6:
              if (errDiv) {
                errDiv.textContent = result.outcomeMessage || 'Invalid code.';
                errDiv.style.display = 'block';
              }
            case 7:
              _context9.n = 9;
              break;
            case 8:
              _context9.p = 8;
              _t0 = _context9.v;
              console.error('Verify2FATotpActivate failed:', _t0);
              if (errDiv) {
                errDiv.textContent = window.tfaStr.unexpectedError;
                errDiv.style.display = 'block';
              }
            case 9:
              _context9.p = 9;
              if (progress) progress.classList.add('hide');
              return _context9.f(9);
            case 10:
              return _context9.a(2);
          }
        }, _callee9, this, [[2, 8, 9, 10]]);
      }));
      function Verify2FATotpActivate() {
        return _Verify2FATotpActivate.apply(this, arguments);
      }
      return Verify2FATotpActivate;
    }()
    /**
     * Disables Authenticator App 2FA and reverts the card to the "Set Up" state.
     */
    )
  }, {
    key: "Disable2FATOTP",
    value: (function () {
      var _Disable2FATOTP = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var progress, resp, result, _t1;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              progress = document.getElementById('tfa-totp-progress');
              if (progress) progress.classList.remove('hide');
              _context0.p = 1;
              _context0.n = 2;
              return fetch(window.client2FATotpDisableUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                  'RequestVerificationToken': this._getCsrfToken()
                },
                credentials: 'same-origin'
              });
            case 2:
              resp = _context0.v;
              _context0.n = 3;
              return resp.json();
            case 3:
              result = _context0.v;
              if (result.isError) {
                _context0.n = 5;
                break;
              }
              window.toastr.success(window.tfaStr.authenticatorDisabled);
              _context0.n = 4;
              return this._refreshTfaCard();
            case 4:
              _context0.n = 6;
              break;
            case 5:
              window.toastr.error(result.outcomeMessage || window.tfaStr.failedToDisable);
            case 6:
              _context0.n = 8;
              break;
            case 7:
              _context0.p = 7;
              _t1 = _context0.v;
              console.error('Disable2FATOTP failed:', _t1);
              window.toastr.error(window.tfaStr.unexpectedError);
            case 8:
              _context0.p = 8;
              if (progress) progress.classList.add('hide');
              return _context0.f(8);
            case 9:
              return _context0.a(2);
          }
        }, _callee0, this, [[1, 7, 8, 9]]);
      }));
      function Disable2FATOTP() {
        return _Disable2FATOTP.apply(this, arguments);
      }
      return Disable2FATOTP;
    }() // ── End 2FA methods ───────────────────────────────────────────────────────
    )
  }, {
    key: "SubmitEmailSettingsForm",
    value: function SubmitEmailSettingsForm() {
      $('#email-settings-progress').removeClass('hide');
      var postData = {};
      postData.Email = $('#Email').val();
      postData.SocialProfileId = $('#SocialProfileId').val();
      $.ajax({
        type: "POST",
        cache: false,
        url: window.clientEmailSettingsUrl,
        dataType: "json",
        data: postData,
        async: true,
        success: function () {
          var _success = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(result) {
            var promptText, buildEmailPrompt, emailHtml, outcomeMessageHtml, parts, needsPrompt, _emailHtml, pendingEmailCardHtml, effectiveEmail, _needsPrompt;
            return _regenerator().w(function (_context1) {
              while (1) switch (_context1.n) {
                case 0:
                  promptText = result.emailPromptMessage || '';
                  buildEmailPrompt = function buildEmailPrompt(needsPrompt) {
                    if (!needsPrompt || !promptText) {
                      return '';
                    }
                    return '<div class="pending-email-card font-13">' + window.escapeHtmlAttr(promptText) + '</div>';
                  };
                  if (!result.isError) {
                    _context1.n = 2;
                    break;
                  }
                  $('#email-settings-progress').addClass('hide');
                  // Re-render the email template with the error message
                  _context1.n = 1;
                  return window.loadTemplate('settings-email');
                case 1:
                  emailHtml = _context1.v;
                  outcomeMessageHtml = '';
                  if (result.outcomeMessage) {
                    parts = result.outcomeMessage.split(':');
                    outcomeMessageHtml = '<span class="field-validation-valid text-danger font-13 validate-email" data-valmsg-for="Email" data-valmsg-replace="true">' + window.escapeHtmlAttr(parts[0]) + '</span>';
                    if (parts.length > 1) {
                      outcomeMessageHtml += '<span class="field-validation-valid text-danger font-13 validate-email" style="display:block">' + window.escapeHtmlAttr(parts[1]) + '</span>';
                    }
                  }
                  needsPrompt = result.needsEmailAddressPrompt === true || !postData.Email;
                  emailHtml = emailHtml.replace(/\{\{Email\}\}/g, window.escapeHtmlAttr(postData.Email || '')).replace(/\{\{OutcomeMessage\}\}/g, outcomeMessageHtml).replace(/\{\{EmailPrompt\}\}/g, buildEmailPrompt(needsPrompt)).replace(/\{\{PendingEmailCard\}\}/g, '');
                  $('#settings-email-form-inputs').html(emailHtml);
                  _context1.n = 4;
                  break;
                case 2:
                  if (result.updates) {
                    window.toastr.success('Email update has been initiated');
                  }
                  // Re-render the email template with updated data (may include pending email card)
                  _context1.n = 3;
                  return window.loadTemplate('settings-email');
                case 3:
                  _emailHtml = _context1.v;
                  pendingEmailCardHtml = '';
                  if (result.pendingEmail) {
                    pendingEmailCardHtml = '<div class="pending-email-card font-13">Email change pending&nbsp;<span class="email">' + window.escapeHtmlAttr(result.pendingEmail) + '</span>.&nbsp;&nbsp;<a href="javascript:void(0)" onclick="window.Access.CancelPendingEmail()">Cancel</a></div>';
                  }
                  effectiveEmail = result.email || postData.Email || '';
                  _needsPrompt = result.needsEmailAddressPrompt === true || !effectiveEmail;
                  _emailHtml = _emailHtml.replace(/\{\{Email\}\}/g, window.escapeHtmlAttr(effectiveEmail)).replace(/\{\{OutcomeMessage\}\}/g, '').replace(/\{\{EmailPrompt\}\}/g, buildEmailPrompt(_needsPrompt)).replace(/\{\{PendingEmailCard\}\}/g, pendingEmailCardHtml);
                  $('#settings-email-form-inputs').html(_emailHtml);
                  $('#email-settings-progress').addClass('hide');
                case 4:
                  return _context1.a(2);
              }
            }, _callee1);
          }));
          function success(_x) {
            return _success.apply(this, arguments);
          }
          return success;
        }(),
        error: function error(result) {
          $('#email-settings-progress').addClass('hide');
        }
      });
    }
  }, {
    key: "CancelPendingEmail",
    value: function () {
      var _CancelPendingEmail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var _document$getElementB25;
        var postData, response, result, emailHtml, needsPrompt, emailPromptHtml, _t10;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              $('#email-settings-progress').removeClass('hide');
              postData = {
                SocialProfileId: parseInt(((_document$getElementB25 = document.getElementById('SocialProfileId')) === null || _document$getElementB25 === void 0 ? void 0 : _document$getElementB25.value) || '0', 10)
              };
              _context10.p = 1;
              _context10.n = 2;
              return fetch(window.clientCancelPendingEmailUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(postData)
              });
            case 2:
              response = _context10.v;
              _context10.n = 3;
              return response.json();
            case 3:
              result = _context10.v;
              if (!result.isError) {
                _context10.n = 4;
                break;
              }
              window.toastr.error(result.outcomeMessage || 'Failed to cancel pending email change.');
              _context10.n = 6;
              break;
            case 4:
              window.toastr.success('Email change cancelled');
              // Re-render the email template with the current confirmed email and no pending card
              _context10.n = 5;
              return window.loadTemplate('settings-email');
            case 5:
              emailHtml = _context10.v;
              needsPrompt = result.needsEmailAddressPrompt === true || !result.email;
              emailPromptHtml = needsPrompt && result.emailPromptMessage ? '<div class="pending-email-card font-13">' + window.escapeHtmlAttr(result.emailPromptMessage) + '</div>' : '';
              emailHtml = emailHtml.replace(/\{\{Email\}\}/g, window.escapeHtmlAttr(result.email || '')).replace(/\{\{OutcomeMessage\}\}/g, '').replace(/\{\{EmailPrompt\}\}/g, emailPromptHtml).replace(/\{\{PendingEmailCard\}\}/g, '');
              $('#settings-email-form-inputs').html(emailHtml);
            case 6:
              _context10.n = 8;
              break;
            case 7:
              _context10.p = 7;
              _t10 = _context10.v;
              console.error('CancelPendingEmail failed:', _t10);
              window.toastr.error('An unexpected error occurred. Please try again.');
            case 8:
              _context10.p = 8;
              $('#email-settings-progress').addClass('hide');
              return _context10.f(8);
            case 9:
              return _context10.a(2);
          }
        }, _callee10, null, [[1, 7, 8, 9]]);
      }));
      function CancelPendingEmail() {
        return _CancelPendingEmail.apply(this, arguments);
      }
      return CancelPendingEmail;
    }()
  }, {
    key: "ResendEmailForm",
    value: function ResendEmailForm() {
      $('#resend-progress').removeClass('hide');
      var postData = {};
      $.ajax({
        type: "POST",
        cache: false,
        url: window.clientResendEmailUrl,
        dataType: "json",
        data: postData,
        async: true,
        success: function success(result) {
          $('#resend-progress').addClass('hide');
          if (result.isError) {} else {
            window.CacheBuster.CheckForMessage();
          }
        },
        error: function error(result) {
          $('#resend-progress').addClass('hide');
        }
      });
    }
  }, {
    key: "SignUpAsCompanyRep",
    value: function SignUpAsCompanyRep() {
      if (window.userIsOnline) {
        window.location.href = '/account/company-reps/onboarding';
      } else {
        $("#sign-up-as-company-rep-aggrement").modal('show');
      }
    }
  }, {
    key: "ToggleSignUpAsCompanyRep",
    value: function ToggleSignUpAsCompanyRep() {
      var companyRep = $("#sign-up-as-companyrep").is(':checked');
      if (!companyRep) {
        $("#socialLoginList").show();
        $("#socialLoginList~.or-wrap").show();
      } else {
        this.SignUpAsCompanyRep();
      }
    }
  }, {
    key: "SaveAffilateWebhook",
    value: function SaveAffilateWebhook() {
      var postData = {};
      postData.affiliateWebhookUrl = $('#affiliate-webhook').val();
      postData.webhookAdditionalParam = window.location.href;
      var btn = $("#save-affiliate-webhook-btn");
      btn.prop('disabled', true).text('Saving...');
      $.ajax({
        url: window.saveAffiliateWebhookUrl,
        //api/settings/save-affiliate-webhook 
        type: 'POST',
        dataType: "json",
        data: postData,
        success: function success(response) {
          btn.prop('disabled', false).text('Save Webhook');
          window.toastr.success("Code is sent successfully!");
        },
        error: function error(xhr, status, _error) {
          btn.prop('disabled', false).text('Save Webhook');
          window.toastr.error("Error saving webhook: " + _error);
        }
      });
    }
  }, {
    key: "ClearCache",
    value: function ClearCache() {
      localStorage.removeItem('cbf-access-token');
      localStorage.removeItem('ntvc-watchlist');
      localStorage.removeItem('ntvc-watchlists');
    }
  }]);
}();
var _default = exports["default"] = Access;

},{"./TencentCaptcha.js":15,"./Turnstile.js":18}],18:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Turnstile = /*#__PURE__*/function () {
  function Turnstile() {
    _classCallCheck(this, Turnstile);
    this.widgetId = null;
    this.siteKey = window.turnstileSiteKey;
  }
  return _createClass(Turnstile, [{
    key: "LoadTurnstile",
    value: function LoadTurnstile(callback) {
      return new Promise(function (resolve, reject) {
        // If Turnstile is already loaded, resolve immediately
        if (window.turnstile) {
          if (callback) callback();
          resolve(true);
          return;
        }
        if ($('#turnstile-script').length) {
          var scriptToRemove = document.getElementById("turnstile-script");
          if (scriptToRemove) {
            $(scriptToRemove).remove();
          }
        }
        var script = document.createElement('script');
        script.id = "turnstile-script";
        script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
        script.async = true;
        script.defer = true;
        script.onload = function () {
          if (callback) callback();
          resolve(true);
        };
        script.onerror = function (e) {
          console.error('Turnstile script failed to load:', e);
          reject(e);
        };
        document.getElementsByTagName('head')[0].appendChild(script);
      });
    }
  }, {
    key: "Render",
    value: function Render(container, _callback) {
      if (!window.turnstile) {
        console.error('Turnstile not loaded');
        return;
      }

      // Remove any existing widget first
      this.Remove();
      this.widgetId = window.turnstile.render(container, {
        sitekey: this.siteKey,
        callback: function callback(token) {
          if (_callback) _callback(token);
        },
        'error-callback': function errorCallback() {
          console.error('Turnstile error');
        }
      });
    }
  }, {
    key: "Execute",
    value: function Execute() {
      var _this = this;
      return new Promise(function (resolve, reject) {
        if (!window.turnstile || _this.widgetId === null) {
          reject(new Error('Turnstile not initialized'));
          return;
        }
        window.turnstile.execute(_this.widgetId);

        // Turnstile doesn't have a direct promise-based execute
        // You'll need to rely on the callback passed to Render
        resolve();
      });
    }
  }, {
    key: "Reset",
    value: function Reset() {
      if (window.turnstile && this.widgetId !== null) {
        window.turnstile.reset(this.widgetId);
      }
    }
  }, {
    key: "Remove",
    value: function Remove() {
      if (window.turnstile && this.widgetId !== null) {
        try {
          window.turnstile.remove(this.widgetId);
          this.widgetId = null;
        } catch (e) {
          console.warn('Failed to remove Turnstile:', e);
        }
      }
    }
  }, {
    key: "GetToken",
    value: function GetToken() {
      if (window.turnstile && this.widgetId !== null) {
        return window.turnstile.getResponse(this.widgetId);
      }
      return null;
    }
  }]);
}();
var _default = exports["default"] = Turnstile;

},{}],15:[function(require,module,exports){
'use strict';

// CDN URL for Tencent Captcha JS
// Production (China mainland): https://turing.captcha.qcloud.com/TJCaptcha.js
// Dev/Localhost (global CDN, less strict whitelist): https://ca.turing.captcha.qcloud.com/TJNCaptcha-global.js
// const _TENCENT_CAPTCHA_CDN_URL = window.tencentCaptchaCdnUrl || 'https://turing.captcha.qcloud.com/TJCaptcha.js';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _TENCENT_CAPTCHA_CDN_URL = 'https://ca.turing.captcha.qcloud.com/TJNCaptcha-global.js';
function _resolveTencentLang() {
  if (window.CURRENT_LANG == 'zh') return 'zh-cn';else return 'en';
}
var TencentCaptchaWidget = /*#__PURE__*/function () {
  function TencentCaptchaWidget() {
    _classCallCheck(this, TencentCaptchaWidget);
    this.appId = window.tencentCaptchaAppId;
    this._scriptLoaded = false;
    this._instance = null;
    this._containerId = null;
    this._renderSeq = 0;
  }
  return _createClass(TencentCaptchaWidget, [{
    key: "_destroyCurrentInstance",
    value: function _destroyCurrentInstance() {
      if (this._instance && typeof this._instance.destroy === 'function') {
        try {
          this._instance.destroy();
        } catch (e) {
          // Ignore destroy errors and continue cleanup.
        }
      }
      this._instance = null;
    }
  }, {
    key: "_clearContainer",
    value: function _clearContainer(containerId) {
      if (!containerId) return;
      var container = document.getElementById(containerId);
      if (container) {
        container.innerHTML = '';
      }
    }
  }, {
    key: "_prepareContainer",
    value: function _prepareContainer(containerId) {
      this._destroyCurrentInstance();
      if (this._containerId) {
        this._clearContainer(this._containerId);
      }
      this._clearContainer(containerId);
      this._containerId = containerId || null;
    }
  }, {
    key: "LoadScript",
    value: function LoadScript() {
      return new Promise(function (resolve, reject) {
        if (window.TencentCaptcha) {
          resolve(true);
          return;
        }
        if (document.getElementById('tencent-captcha-script')) {
          // Script tag exists but may still be loading — poll briefly
          var attempts = 0;
          var poll = setInterval(function () {
            if (window.TencentCaptcha) {
              clearInterval(poll);
              resolve(true);
            } else if (++attempts > 50) {
              clearInterval(poll);
              reject(new Error('TencentCaptcha script load timeout'));
            }
          }, 100);
          return;
        }
        var script = document.createElement('script');
        script.id = 'tencent-captcha-script';
        script.src = _TENCENT_CAPTCHA_CDN_URL;
        script.async = true;
        script.onload = function () {
          return resolve(true);
        };
        script.onerror = function () {
          return reject(new Error('TencentCaptcha script failed to load'));
        };
        document.head.appendChild(script);
      });
    }

    // Pre-render the widget in containerId so the user can verify before submitting.
    // Stores the ticket/randstr internally; retrieve with GetResult().
  }, {
    key: "Render",
    value: function Render(containerId) {
      var _this = this;
      this.Reset();
      var renderSeq = ++this._renderSeq;
      this._prepareContainer(containerId);
      var container = document.getElementById(containerId);
      if (!container) return;
      var appId = this.appId;
      var callback = function callback(res) {
        if (res.ret === 0) {
          _this._ticket = res.ticket;
          _this._randstr = res.randstr;
        }
      };
      this.LoadScript().then(function () {
        if (renderSeq !== _this._renderSeq) return;
        try {
          var lang = _resolveTencentLang();
          var captcha = new window.TencentCaptcha(container, appId, callback, {
            userLanguage: lang,
            type: 'embed'
          });
          captcha.show();
          _this._instance = captcha;
          _this._containerId = containerId;
        } catch (e) {
          console.warn('TencentCaptcha init failed', e);
        }
      })["catch"](function (e) {
        console.warn('TencentCaptcha script load failed', e);
      });
    }

    // Returns { ticket, randstr } if the user has already verified, otherwise null.
  }, {
    key: "GetResult",
    value: function GetResult() {
      return this._ticket && this._randstr ? {
        ticket: this._ticket,
        randstr: this._randstr
      } : null;
    }

    // Clears any stored verification result and current widget instance.
  }, {
    key: "Reset",
    value: function Reset() {
      this._ticket = null;
      this._randstr = null;
      this._destroyCurrentInstance();
      if (this._containerId) {
        this._clearContainer(this._containerId);
        this._containerId = null;
      }
    }

    // containerId — id of the DOM element to embed the widget into
    // onSuccess(ticket, randstr) — called when captcha is verified
    // onError(res) — optional, called on failure or dismiss
  }, {
    key: "Show",
    value: function Show(containerId, onSuccess, onError) {
      var _this2 = this;
      var renderSeq = ++this._renderSeq;
      this._prepareContainer(containerId);
      var appId = this.appId;
      var container = containerId ? document.getElementById(containerId) : null;
      var captchaCallback = function captchaCallback(res) {
        if (res.ret === 0) {
          onSuccess(res.ticket, res.randstr);
        } else {
          if (onError) onError(res);
        }
      };
      this.LoadScript().then(function () {
        if (renderSeq !== _this2._renderSeq) return;
        try {
          var lang = _resolveTencentLang();
          // Embedded mode: render widget inside the provided container element
          // Popup mode: no container, widget floats centered
          var captcha = container ? new window.TencentCaptcha(container, appId, captchaCallback, {
            userLanguage: lang,
            type: 'embed'
          }) : new window.TencentCaptcha(appId, captchaCallback, {
            userLanguage: lang
          });
          captcha.show();
          _this2._instance = captcha;
          _this2._containerId = containerId || null;
        } catch (e) {
          console.warn('TencentCaptcha init failed', e);
          if (onError) onError({
            ret: -1,
            error: e
          });
        }
      })["catch"](function (e) {
        console.warn('TencentCaptcha script load failed', e);
        if (onError) onError({
          ret: -1,
          error: e
        });
      });
    }
  }]);
}();
var _default = exports["default"] = TencentCaptchaWidget;

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Ads = /*#__PURE__*/function () {
  function Ads(cookie) {
    _classCallCheck(this, Ads);
    this.PopUpDesktopDiv = window.PopUpDesktopDiv;
    this.PopUpMobileDiv = window.PopUpMobileDiv;
    this.WallerpaperDiv = window.WallerpaperDiv;
    this.LeaderBoardDiv = window.LeaderBoardDiv;
    this.Cookie = cookie;
    this.windowWidth = document.body && document.body !== null ? document.body.clientWidth : window.screen.availWidth;
    this.promoOffset = 0;
    this.ActivePage = window.ActivePage;
    this.PageFormat = '';
    this.Large = 1449;
    this.MenuShow = 1199;
    this.Medium = 979;
    this.rendered = [];
    this.menuHeight = 63;
    this.popped = false;
    this.SlotMessage = "";
    this.SlotSponsor = "";
    this.SlotLeaderboard = "";
    this.SlotMobileLeaderboard = "";
    this.SlotWallpaper = "";
    this.SlotMobileFooter = "";
    this.SplashGap = 4;
  }
  return _createClass(Ads, [{
    key: "DismissPopAd",
    value: function DismissPopAd() {
      $('#popup-overlay').hide();
      window.InitGoogleTag('pop');
    }
  }, {
    key: "WallpaperPosition",
    value: function WallpaperPosition() {
      var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'scroll';
      if ($('#page-wrap').is(":visible")) {
        var totalVisibleHeight = 0;
        $('.top-tier').each(function () {
          var $element = $(this);
          var elementTop = $element.offset().top;
          var elementBottom = elementTop + $element.outerHeight();
          var windowHeight = $(window).height();
          var scrollTop = $(window).scrollTop();

          // Check if the element is partially or fully visible within the viewport
          if (elementTop >= scrollTop && elementTop < scrollTop + windowHeight || elementBottom > scrollTop && elementBottom <= scrollTop + windowHeight || elementTop <= scrollTop && elementBottom >= scrollTop + windowHeight) {
            // Calculate the visible height of the element
            var visibleHeight = Math.min(elementBottom, scrollTop + windowHeight) - Math.max(elementTop, scrollTop);
            totalVisibleHeight += visibleHeight;
          }
        });
        var offset = window.pageYOffset; // + 'px';

        if (offset < totalVisibleHeight) {
          var newY = totalVisibleHeight - offset;
          $('#page-wrap').css('margin-top', newY + 'px');
        } else {
          $('#page-wrap').css('margin-top', +totalVisibleHeight + 'px');
        }
      }
    }
  }, {
    key: "SetPageFormat",
    value: function SetPageFormat(format) {
      this.PageFormat = format;
    }
  }, {
    key: "SetPromoOffset",
    value: function SetPromoOffset(o) {
      this.promoOffset = o;
    }
  }, {
    key: "SetWindowWidth",
    value: function SetWindowWidth(w) {
      this.windowWidth = w;
    }
  }, {
    key: "AugmentMenuHeight",
    value: function AugmentMenuHeight(h) {
      var height = h + this.menuHeight;
      this.SetMenuHeight(height);
    }
  }, {
    key: "SetMenuHeight",
    value: function SetMenuHeight(h) {
      this.menuHeight = h;
    }
  }, {
    key: "HideBurgerOnLarge",
    value: function HideBurgerOnLarge() {
      return this.windowWidth > this.MenuShow;
    }
  }, {
    key: "PlaceAds",
    value: function PlaceAds() {
      var _this = this;
      if (!window.googletag) return;
      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();
      window.googletag.pubads().addEventListener('slotOnload', function (event) {
        var slot = event.slot;
        if (slot.getSlotElementId() === _this.PopUpDesktopDiv) {
          var cook = _this.Cookie.GetCookie("splash");
          if (cook === "") {
            _this.Cookie.SetCookieToExpireInHours("splash", 1, _this.SplashGap);
          }
          if ($('#popup-overlay').not(":visible") && !_this.popped) {
            $('#popup-overlay').show();
            _this.popped = true;
          }
        }
      });
      if (this.windowWidth > this.Large) {
        this.WallPaper();
        this.Leader();
        this.PopUp();
        this.PageFormat = "Large";
      } else if (this.windowWidth > this.Medium) {
        this.Leader();
        this.PopUp();
        this.PageFormat = "Medium";
      } else {
        this.Mobile();
        this.PageFormat = "Mobile";
      }
    }
  }, {
    key: "WallPaper",
    value: function WallPaper() {
      var _this2 = this;
      if (window.WallerpaperSlot != undefined && window.WallerpaperSlot != null && window.WallerpaperSlot != "") {
        var slotName = window.WallerpaperSlot;
        if (!this.rendered.includes(slotName) && !$('body').hasClass('full-width')) {
          this.rendered.push(slotName);
          if ($('#promoheader').is(":visible")) {
            this.promoOffset = document.getElementById("promoheader").offsetHeight;
          }
          $('.page-wrap').show();
          window.googletag.cmd.push(function () {
            _this2.SlotWallpaper = googletag.defineSlot(slotName, [2310, 1190], window.WallerpaperDiv).addService(window.googletag.pubads());
          });
          window.googletag.cmd.push(function () {
            window.googletag.display(window.WallerpaperDiv);
          });
          window.addEventListener('scroll', window.Promotion.WallpaperPosition);
          this.WallpaperPosition('internal');
        }
      }
    }
  }, {
    key: "Leader",
    value: function Leader() {
      var _this3 = this;
      if (!window.googletag) return;
      var slotName = window.LeaderBoardSlot;
      if (!this.rendered.includes(slotName)) {
        this.rendered.push(slotName);
        window.googletag.cmd.push(function () {
          _this3.SlotLeaderboard = window.googletag.defineSlot(slotName, [970, 90], _this3.LeaderBoardDiv).addService(window.googletag.pubads());
        });
        window.googletag.cmd.push(function () {
          window.googletag.display(this.LeaderBoardDiv);
        });
      }
    }
  }, {
    key: "GetSplashCookie",
    value: function GetSplashCookie() {
      if (this.Cookie.GetCookie("splash") == 1) {
        return 1;
      }
      ;
      return 0;
    }
  }, {
    key: "PopUp",
    value: function PopUp() {
      var _this4 = this;
      if (!window.googletag) return;
      var cook = this.Cookie.GetCookie("splash");
      var slotName = window.PopUpDesktopSlot;
      if (cook !== "") {
        // cookie is set so an ad has been served, but we need to check if the ad is showing, in this case we may just need to resize
        if (!this.rendered.includes(slotName)) {
          if ($('#popup-overlay').is(":visible")) {
            this.rendered.push(slotName);
            window.googletag.cmd.push(function () {
              window.googletag.defineSlot(slotName, [1024, 425], _this4.PopUpDesktopDiv).addService(window.googletag.pubads());
            });
            window.googletag.cmd.push(function () {
              window.googletag.display(_this4.PopUpDesktopDiv);
            });
          }
        }
      } else {
        this.Cookie.SetCookieToExpireInHours("splash", 1, this.SplashGap);
        if (!this.rendered.includes(slotName)) {
          this.rendered.push(slotName);
          window.googletag.cmd.push(function () {
            window.googletag.defineSlot(slotName, [1024, 425], _this4.PopUpDesktopDiv).addService(window.googletag.pubads());
          });
          window.googletag.cmd.push(function () {
            window.googletag.display(_this4.PopUpDesktopDiv);
          });
        }
      }
    }
  }, {
    key: "Mobile",
    value: function Mobile() {
      var _this5 = this;
      if (!window.googletag) return;
      var FooterMobileSlot = window.FooterMobileSlot;
      var LeaderBoardMobileSlot = window.LeaderBoardMobileSlot;
      var popSlotName = window.PopUpMobileSlot;
      var SquareMobileSlot = window.SquareMobileSlot;
      var hasSquareMobileSlot = $('#mobile-mid-table').length;
      var FooterMobileDiv = window.FooterMobileDiv;
      if (!this.rendered.includes(FooterMobileSlot)) {
        if (document.getElementById(FooterMobileDiv)) {
          this.rendered.push(FooterMobileSlot);
          window.googletag.cmd.push(function () {
            _this5.SlotMobileFooter = window.googletag.defineSlot(FooterMobileSlot, [320, 100], FooterMobileDiv).addService(window.googletag.pubads());
          });
          window.googletag.cmd.push(function () {
            window.googletag.display(FooterMobileDiv);
          });
        } else {
          console.error("FooterMobileDiv element not found in DOM");
        }
      }
      if (!this.rendered.includes(window.SquareMobileSlot) && hasSquareMobileSlot) {
        if (!$('#mobile-mid-table').hasClass('show')) {
          $('#mobile-mid-table').addClass('show');
        }
        this.rendered.push(window.SquareMobileSlot);
        window.googletag.cmd.push(function () {
          _this5.SlotMobileSquare = window.googletag.defineSlot(SquareMobileSlot, [300, 250], window.SquareMobileDiv).addService(window.googletag.pubads());
        });
        window.googletag.cmd.push(function () {
          window.googletag.display(window.SquareMobileDiv);
        });
      }
      if (!this.rendered.includes(LeaderBoardMobileSlot)) {
        if (document.getElementById(window.LeaderBoardMobileDiv)) {
          this.rendered.push(LeaderBoardMobileSlot);
          window.googletag.cmd.push(function () {
            _this5.SlotMobileLeaderboard = window.googletag.defineSlot(LeaderBoardMobileSlot, [320, 100], window.LeaderBoardMobileDiv).addService(window.googletag.pubads());
          });
          window.googletag.cmd.push(function () {
            window.googletag.display(window.LeaderBoardMobileDiv);
          });
        } else {
          console.error("LeaderBoardMobileDiv element not found in DOM");
        }
      }
      var cook = this.Cookie.GetCookie("splash");
      if (cook !== "") {
        // cookie is set so an ad has been served, but we need to check if the ad is showing, in this case we may just need to resize
        if (!this.rendered.includes(popSlotName)) {
          if ($('#popup-overlay').is(":visible")) {
            this.rendered.push(popSlotName);
            window.googletag.cmd.push(function () {
              window.googletag.defineSlot(popSlotName, [320, 480], _this5.PopUpMobileDiv).addService(window.googletag.pubads());
            });
            window.googletag.cmd.push(function () {
              window.googletag.display(_this5.PopUpMobileDiv);
            });
          }
        }
      } else {
        // no cookie set, ok to serve ad
        this.Cookie.SetCookieToExpireInHours("splash", 1, this.SplashGap);
        if (!this.rendered.includes(popSlotName)) {
          if ($('#popup-overlay').not(":visible") && !this.popped) {
            $('#popup-overlay').show();
            this.popped = true;
          }
          this.rendered.push(popSlotName);
          window.googletag.cmd.push(function () {
            window.googletag.defineSlot(popSlotName, [320, 480], _this5.PopUpMobileDiv).addService(window.googletag.pubads());
          });
          window.googletag.cmd.push(function () {
            window.googletag.display(_this5.PopUpMobileDiv);
          });
        }
      }
    }
  }, {
    key: "IsElementInViewport",
    value: function IsElementInViewport(el) {
      // Special bonus for those using jQuery
      if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
      }
      var rect = el.getBoundingClientRect();
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */;
    }
  }]);
}();
var _default = exports["default"] = Ads;

},{}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CacheBuster = /*#__PURE__*/function () {
  function CacheBuster(cookie) {
    _classCallCheck(this, CacheBuster);
    this.Cookie = cookie;
  }
  return _createClass(CacheBuster, [{
    key: "CheckForMessage",
    value: function CheckForMessage() {
      var message = this.Cookie.GetCookie("SiteMessage");
      if (message !== "") {
        var messageType = this.Cookie.GetValue("messageType", message);
        var displayAs = this.Cookie.GetValue("displayAs", message);
        var messageString = this.Cookie.GetValue("message", message);
        if (displayAs === "modal") {
          var titleString = this.Cookie.GetValue("title", message);
          if (titleString) $('#site-message-modal .message-title').html(titleString);
          $('#site-message-modal .message-body').html(messageString);
          $('#site-message-modal').modal("show");
        } else if (displayAs === "header") {
          $('#messageheader-message').html(messageString);
          $('#messageheader').show();
          var menuPad = 0;
          var fixed = document.getElementById('fix-wrap');
          if (fixed != null) {
            menuPad = parseInt(fixed.offsetHeight, 10);
          }
          window.Promotion.WallpaperPosition('CacheBuster Maintenance message');
          var stat = document.getElementById('tier-three');
          if (stat) {
            stat.style.marginTop = menuPad + 'px';
          }
        } else {
          var displayedToast = null;
          if (messageType === "success") {
            displayedToast = window.toastr.success(messageString);
          }
          if (messageType === "error") {
            displayedToast = window.toastr.error(messageString);
          }
          if (messageType === "warning") {
            displayedToast = window.toastr.warning(messageString);
          }
          if (displayedToast) {
            var ga4EventName = this.Cookie.GetValue("ga4EventName", message);
            var ga4Element = this.Cookie.GetValue("ga4Element", message);
            if (ga4Element && ga4EventName) {
              displayedToast.attr('data-ga4event-clk-name', ga4EventName);
              displayedToast.attr('data-ga4event-element', ga4Element);
            }
          }
        }
        this.Cookie.DeleteCookie("SiteMessage");
      }
    }
  }, {
    key: "CheckIfTransferredFromOtherPortal",
    value: function CheckIfTransferredFromOtherPortal() {
      // Check if url has "ref" query parameter
      var urlParams = new URLSearchParams(window.location.search);
      var refParam = urlParams.get('ref');
      if (refParam) {
        var portalName = refParam === 'cbfx' ? 'CBFX' : 'RebateKingFX';
        $('#site-message-modal .message-title').html('');
        $('#site-message-modal .message-body').html("You have been redirected from " + portalName + " to fxverify.com, our verified reviews platform with the same features plus extra tools.<br />If you weren’t logged in automatically, please log in or register and consider supporting our community by submitting a broker review.<br/>Thank you!");
        $('#site-message-modal').modal("show");

        // Update the URL to remove the ref parameter without reloading the page
        urlParams["delete"]('ref');
        if (urlParams.toString() === "") {
          window.history.replaceState({}, document.title, window.location.pathname);
        } else {
          window.history.replaceState({}, document.title, window.location.pathname + '?' + urlParams.toString());
        }
      }
    }
  }, {
    key: "Refresh",
    value: function Refresh() {
      var _this = this;
      this.CheckIfTransferredFromOtherPortal();
      this.CheckForMessage();
      var data = {};
      if ($('#brokerCacheId').length) {
        data.BrokerId = $('#brokerCacheId').val();
      }
      if ($('.user-name-required').length) {
        data.UsernameRequired = true;
      }
      if ($('.user-clientId-required').length) {
        data.ClientIdRequired = true;
      }
      if ($('.user-email-required').length) {
        data.EmailRequired = true;
      }
      if ($('.select-timezone-required').length) {
        data.TimezoneRequired = true;
      }
      if ($('.user-country-required').length) {
        data.CountryRequired = true;
      }
      if ($('#article-id').length) {
        data.ArticleId = $('#article-id').val();
      }
      if (localStorage.getItem('cbf-device-id')) {
        data.DeviceId = localStorage.getItem('cbf-device-id');
      }
      if ($('.count-tracker').length) {
        var entityDictionary = {};
        $('.count-tracker').each(function (i, e) {
          var entityType = $(e).data('entitytype');
          var entityId = $(e).data('entityid');
          entityDictionary[entityType] = parseInt(entityId);
        });
        data.EntityTracking = entityDictionary;
      }
      var formattedData = $.param(data);
      $.ajax({
        url: window.cacheBust,
        type: 'POST',
        cache: false,
        data: formattedData,
        async: true,
        success: function success(result) {
          if (result.banned) {
            window.Access.LogoutSubmit();
          }
          if (result.needReload) {
            window.location.reload();
          }

          // Set values for state cookie
          var setCook = {};
          var cookieValues = {};
          var cook = _this.Cookie.GetCookie("FrnHOST");
          if (result.deviceId != null && result.deviceId != undefined) {
            localStorage.setItem('cbf-device-id', result.deviceId);
          }
          if (result.client_profile_id != null && result.client_profile_id != undefined) {
            localStorage.setItem("client-profile-id", result.client_profile_id);
            $('#client-profile-id').val(result.client_profile_id);
          } else {
            $('#client-profile-id').val("0");
            localStorage.removeItem("client-profile-id");
          }
          if (result.socialProfileId !== undefined && result.socialProfileId !== null && parseInt(result.socialProfileId, 10) > 0) {
            $('#social-profile-id').val(result.socialProfileId);
          } else {
            $('#social-profile-id').val("0");
          }
          if (result.client_verified == "1") {
            $('#client-verified').val("1");
          } else {
            $('#client-verified').val("0");
          }
          if (result.countryCode) {
            localStorage.setItem("visitor_country_code", result.countryCode);
          }

          /*
          // Un-comment this to enable USA redirect prompt
          if (cook === "" || cook == undefined || cook == null) {
                if (result.us_flag === "1") {
                  let targetDate = new Date();
                  targetDate.setDate(targetDate.getDate() + 7);
                  setCook.us_flag = Date.parse(targetDate);
               
                  $('#dialog-redirect-check').modal("show");
              }
          } else {
                        cookieValues = JSON.parse(this.Cookie.GetValue("state", cook));
                //cookie exists
              // check USA redirect prompt
                if ((cookieValues.us_flag === undefined
                  || cookieValues.us_flag === "") && (result.us_flag === "1")) {
                  // set expiry for this cookie
                  let targetDate = new Date();
                  targetDate.setDate(targetDate.getDate() + 7);
                  setCook.us_flag = Date.parse(targetDate);
                  $('#dialog-redirect-check').modal("show");
                } else if (cookieValues.us_flag > 0) {
                    var now = new Date();
                  let expireDate = new Date(cookieValues.us_flag);
                    if (now > expireDate) {
                        now.setDate(now.getDate() + 7);
                      setCook.us_flag = Date.parse(now);
                      $('#dialog-redirect-check').modal("show");
                    } else {
                        setCook.us_flag = cookieValues.us_flag;
                  }
              }  
          }
          */

          var letter = result.letter;
          if (letter !== undefined && letter !== "") {
            setCook.letter = letter;
            if (document.getElementById('letter-box')) {
              document.getElementById('letter-box').innerHTML = window.onlineLetterBox;
            }
            if (document.getElementById('initial-slot')) {
              document.getElementById('initial-slot').innerHTML = letter;
            }
            if (typeof InitializeHeaderDropdown === "function") InitializeHeaderDropdown();
          }
          if (result.ArticleEditHtml != null && result.ArticleEditHtml !== "") {
            $("#edit-article-link").css("display", "block");
            $("#edit-article-link").html(result.ArticleEditHtml);
          }
          if (result.displayName !== undefined && result.displayName !== "") {
            if (window.$zopim != undefined && window.$zopim.livechat != undefined) {
              window.$zopim.livechat.setName(result.displayName);
            }
            $('.user-name-required').val(result.displayName);
            $('.user-name-required').prop("readonly", true);
          }
          if (result.userEmail !== undefined && result.userEmail !== "") {
            if (window.$zopim != undefined && window.$zopim.livechat != undefined) {
              window.$zopim.livechat.setEmail(result.userEmail);
            }
            $('.user-email-required').val(result.userEmail);
            $('.user-email-required').prop("readonly", true);
          }
          if (result.clientId !== undefined && result.clientId !== "") {
            $('.user-clientId-required').val(result.clientId);
          }
          if (result.timezone !== undefined && result.timezone !== "") {
            $('.select-timezone-required').val(result.timezone);
          }
          if (result.country !== undefined && result.country !== "") {
            $('.user-country-required').val(result.country);
          }
          var logged = result.logged;
          if (logged !== undefined && logged !== "") {
            if (logged == "1") {
              if (document.getElementById('header-links')) document.getElementById('header-links').innerHTML = window.onlineMenu;
              if (document.getElementById('login-action')) document.getElementById('login-action').innerHTML = window.onlineLoginAction;
            } else {
              if (document.getElementById('letter-box')) {
                $('#letter-box').html(window.offlineLetterBox);
              }
              if (document.getElementById('header-links')) document.getElementById('header-links').innerHTML = window.offlineMenu;
              if (document.getElementById('login-action')) document.getElementById('login-action').innerHTML = window.offlineLoginAction;
            }
            setCook.logged = logged;
          }
          if (typeof window.InitializeHeaderDropdown === "function" && window.InitializeHeaderDropdown()) {
            window.InitializeHeaderDropdown();
          }
          var masq = result.masqAs;
          if (masq !== undefined && masq !== "") {
            $('#masquerading-as').html(masq);
            $('#masquerading-as').show();
          }
          var brokerSpecifics = result.BrokerSpecifics;
          if (brokerSpecifics !== undefined && brokerSpecifics !== "" && brokerSpecifics !== null) {
            var specs = JSON.parse(brokerSpecifics);
            $('a.FXVERIFY_REVIEW_LINK_PLACEHOLDER').attr("href", specs.fxvLink); // load the review link
            var al = decodeURIComponent(specs.AdminLinks);
            if (al !== undefined && al !== null && al !== "" && al !== "undefined") {
              console.log(al);
              var adminLinks = JSON.parse(al); // Parse the AdminLinks JSON string
              console.log(adminLinks);
              // Create HTML content with Edit and Delete links
              var editLinkHtml = "<a href=\"".concat(adminLinks.EditLink, "\">Edit</a>");
              var deleteLinkHtml = "<a class=\"ml-3 mr-3\" href=\"".concat(adminLinks.DeleteLink, "\">Delete Cache (this portal only)</a>");

              // Combine the links into a single HTML string
              var adminLinksHtml = editLinkHtml + deleteLinkHtml;
              if (adminLinksHtml !== undefined && adminLinksHtml !== "") {
                $('.ADMIN_LINK_PLACEHOLDER').html(adminLinksHtml); //admin links
              }
            }
            var br = brokerSpecifics.replace(/[\x00-\x1F\x7F-\x9F]/g, ""); // remove control characters
            var brEnflated = JSON.parse(br);
            var specsObject = {};
            if (cookieValues.brokerSpecifics !== undefined && cookieValues.brokerSpecifics !== "" && cookieValues.brokerSpecifics !== null) {
              specsObject = JSON.parse(decodeURIComponent(cookieValues.brokerSpecifics));
              specsObject[data.BrokerId] = JSON.stringify(brEnflated);
            } else {
              specsObject[data.BrokerId] = JSON.stringify(brEnflated);
            }
            setCook.brokerSpecifics = JSON.stringify(specsObject); // set the cookie
          } else if (cookieValues.brokerSpecifics !== undefined && cookieValues.brokerSpecifics !== "" && cookieValues.brokerSpecifics !== null) {
            setCook.brokerSpecifics = cookieValues.brokerSpecifics;
          }
          var replaceStrings = function replaceStrings(str, list) {
            if (window.replaceStringList === undefined || !Array.isArray(window.replaceStringList)) return str;
            for (var i = 0; i < window.replaceStringList.length; i++) str = str.split(window.replaceStringList[i].Item1).join(window.replaceStringList[i].Item2);
            return str;
          };
          var forexBrokerList = result.BrokerList;
          if (forexBrokerList != null && forexBrokerList !== "") {
            $('.dropdown-broker-menu-list').html(replaceStrings(forexBrokerList));
            localStorage.setItem("FrnHOSTBrokerMenu", forexBrokerList);
          } else if (cookieValues.brokerList !== undefined && cookieValues.brokerList !== "" && cookieValues.brokerList !== null) {
            localStorage.setItem("FrnHOSTBrokerMenu", cookieValues.brokerList);
            $('.dropdown-broker-menu-list').html(replaceStrings(cookieValues.brokerList));
          }
          var cryptoBrokerList = result.CryptoBrokerList;
          if (cryptoBrokerList != null && cryptoBrokerList !== "") {
            $('.dropdown-broker-menu-list').html(replaceStrings(cryptoBrokerList));
            localStorage.setItem("FrnHOSTCryptoBrokerMenu", cryptoBrokerList);
          } else if (cookieValues.cryptoBrokerList !== undefined && cookieValues.cryptoBrokerList !== "" && cookieValues.cryptoBrokerList !== null) {
            localStorage.setItem("FrnHOSTCryptoBrokerMenu", cookieValues.cryptoBrokerList);
            $('.dropdown-crypto-menu-list').html(replaceStrings(cookieValues.cryptoBrokerList));
          }
          var guideList = result.GuideList;
          if (guideList != null && guideList !== "") {
            $('.dropdown-guide-menu-list').html(replaceStrings(guideList));
            localStorage.setItem("FrnHOSTGuideMenu", guideList);
          } else if (cookieValues.guideList !== undefined && cookieValues.guideList !== "" && cookieValues.guideList !== null) {
            localStorage.setItem("FrnHOSTGuideMenu", cookieValues.guideList);
            $('.dropdown-guide-menu-list').html(replaceStrings(cookieValues.guideList));
          }
          var cryptoGuideList = result.CryptoGuideList;
          if (cryptoGuideList != null && guideList !== "") {
            $('.dropdown-crypto-guide-menu-list').html(replaceStrings(cryptoGuideList));
            localStorage.setItem("FrnHOSTCryptoGuideMenu", cryptoGuideList);
          } else if (cookieValues.cryptoGuideList !== undefined && cookieValues.cryptoGuideList !== "" && cookieValues.cryptoGuideList !== null) {
            localStorage.setItem("FrnHOSTCryptoGuideMenu", cookieValues.cryptoGuideList);
            $('.dropdown-crypto-guide-menu-list').html(replaceStrings(cookieValues.cryptoGuideList));
          }
          var myCompanyList = result.MyCompaniesList;
          if (myCompanyList != null && myCompanyList !== "") {
            $(".my-companies-list-dropdown").show();
            $('.dropdown-my-companies-list').html(replaceStrings(myCompanyList));
            localStorage.setItem("FrnHOSTMyCompanyMenu", myCompanyList);
            $(".companies-dashboard-dropdown").show();
          } else {
            $(".my-companies-list-dropdown").hide();
            localStorage.removeItem("FrnHOSTMyCompanyMenu");
            $(".companies-dashboard-dropdown").hide();
          }
          if (result.roles !== undefined && result.roles !== "" && result.roles !== null) {
            var roleA = result.roles.replace(/[\x00-\x1F\x7F-\x9F]/g, "");
            setCook.roles = roleA;
            if (cookieValues.roles !== undefined && cookieValues.roles !== "" && cookieValues.roles !== result.roles) {
              _this.DynamicScripts(JSON.parse(roleA));
              _this.DynamicLinks(JSON.parse(roleA));
            } else if (cookieValues.roles === undefined || cookieValues.roles === "") {
              _this.DynamicScripts(JSON.parse(roleA));
              _this.DynamicLinks(JSON.parse(roleA));
            }
          }
          if (result.refer_link !== undefined && result.refer_link !== "" && result.refer_link !== null && $('#referral-link-holder').length) {
            $('#referral-link-holder').html(result.refer_link);
          } else {
            $('#referral-link-holder').html('');
          }
          if (!!result.client_profile_id) {
            $('[data-id="trading-performace-link"]').each(function (index, el) {
              if (window.CURRENT_LANG == 'en') $(el).attr("href", "/trading-accounts?scid=" + result.client_profile_id);else $(el).attr("href", "/" + window.CURRENT_LANG + "/trading-accounts?scid=" + result.client_profile_id);
            });
          }
          _this.Cookie.SetCookie("FrnHOST", "state=" + JSON.stringify(setCook), 1);
          if (result.fxvdomain) {
            localStorage.setItem("fxvdomain", result.fxvdomain);
            var links = $("a[data-id=social-profile-link]");
            for (var i = 0; i < links.length; i++) {
              $(links[i]).attr('href', result.fxvdomain + $(links[i]).attr('href'));
            }
          } else {
            localStorage.removeItem("fxvdomain");
            var _links = $("a[data-id=social-profile-link]");
            for (var i = 0; i < _links.length; i++) {
              $(_links[i]).remove();
            }
          }
          if (result.show_review_popup === "dash") {
            $("#dashboard-leave-review").show();
          } else if (result.show_review_popup == "popup") {
            $("#dashboard-leave-review").show();
            $("#encourage-review-popup").show();
          }
          if (window.updateRoleBasedElements) {
            window.updateRoleBasedElements();
          }
        }
      });
    }
  }, {
    key: "HtmlDecode",
    value: function HtmlDecode(input) {
      var e = document.createElement('textarea');
      e.innerHTML = input;
      return e.value;
    }
  }, {
    key: "CloseReviewPopup",
    value: function CloseReviewPopup() {
      this.Cookie.SetCookie("hide-review-popup", "1", 365);
      $("#encourage-review-popup").remove();
    }
  }, {
    key: "ShowForRoles",
    value: function ShowForRoles(roles) {
      $('.show-by-role').each(function (i, e) {
        $(e).hide();
      });
      roles.map(function (role) {
        $('.show-by-role').each(function (i, ele) {
          var element = $(ele);
          var data = element.data('show-by-role');
          if (data !== undefined && data !== null) {
            var isArray = data instanceof Array;
            if (isArray) {
              data.map(function (forRole) {
                if (forRole === role) {
                  element.show();
                }
              });
            } else {
              if (data === role) {
                element.show();
              }
            }
          }
        });
      });
    }
  }, {
    key: "DynamicScripts",
    value: function DynamicScripts(roles) {
      $('.dynamic-script').each(function (i, e) {
        $(e).prop("src", "");
      });
      roles.map(function (role) {
        $('i[data-role="' + role + '"]').each(function (i, s) {
          var scriptTemplate = $(s);
          var src = scriptTemplate.data('src');
          var id = "script-for-" + role;
          if ($('#' + id).length) {
            $('#' + id).prop('src', src);
          } else {
            var script = document.createElement('script');
            script.src = src;
            script.Id = id;
            $(script).addClass('dynamic-script');
            document.head.appendChild(script);
          }
        });
      });
    }
  }, {
    key: "DynamicLinks",
    value: function DynamicLinks(roles) {
      $('.dynamic-link').each(function (i, e) {
        $(e).prop("href", "");
      });
      roles.map(function (role) {
        if (role === "Guest") {
          $('a[data-guest-link]').each(function (i, link) {
            var linkBox = $(link);
            var url = linkBox.data('guest-link');
            $(link).prop('href', url);
          });
        }
        if (role === "Support" || role === "Client" || role === "FH") {
          $('a[data-user-link]').each(function (i, link) {
            var linkBox = $(link);
            var url = linkBox.data('user-link');
            $(link).prop('href', url);
          });
          if (role === "Support") {
            $('a[data-support-link]').each(function (i, link) {
              var linkBox = $(link);
              var url = linkBox.data('support-link');
              $(link).prop('href', url);
            });
          }
          if (role === "Client") {
            $('a[data-client-link]').each(function (i, link) {
              var linkBox = $(link);
              var url = linkBox.data('client-link');
              $(link).prop('href', url);
            });
          }
          if (role === "FH") {
            $('a[data-fh-link]').each(function (i, link) {
              var linkBox = $(link);
              var url = linkBox.data('fh-link');
              $(link).prop('href', url);
            });
          }
        }
      });
    }
  }, {
    key: "SendtoUsa",
    value: function SendtoUsa() {
      var location = $('#current-location').val();
      document.location.href = "https://www.cashbackforexusa.com" + location;
    }
  }]);
}();
var _default = exports["default"] = CacheBuster;

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Cookie = /*#__PURE__*/function () {
  function Cookie() {
    _classCallCheck(this, Cookie);
  }
  return _createClass(Cookie, [{
    key: "SetCookie",
    value: function SetCookie(CookieName, CookieValue, ExpiresInDays) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=Lax;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetCookieToExpireInHours",
    value: function SetCookieToExpireInHours(CookieName, CookieValue, ExpiresInHours) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInHours * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=Lax;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetCookieSameSiteNone",
    value: function SetCookieSameSiteNone(CookieName, CookieValue, ExpiresInDays) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=None;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetSessionCookie",
    value: function SetSessionCookie(cname, cvalue) {
      document.cookie = cname + "=" + cvalue + ";Secure;SameSite=Lax;expires=0;path=/";
    }
  }, {
    key: "GetCookie",
    value: function GetCookie(cname) {
      var name = cname + "=";
      var cookie = document.cookie;
      var ca = cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = decodeURIComponent(ca[i]);
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }, {
    key: "DeleteCookie",
    value: function DeleteCookie(name) {
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }
  }, {
    key: "GetValue",
    value: function GetValue(requestedValue, data) {
      var nameEQ = requestedValue + "=";
      var splits = data.split("&");
      for (var i = 0; i < splits.length; i++) {
        var c = splits[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
    }
  }]);
}();
var _default = exports["default"] = Cookie;

},{}],6:[function(require,module,exports){
"use strict";

$.fn.custom_autocomplete = function (options) {
  // Default options
  var defaults = {
    data: [],
    filter: function filter(item, query) {
      // Default filter function that always returns true
      return item.toLowerCase().indexOf(query.toLowerCase()) !== -1;
    },
    displayValue: function displayValue(item) {
      // Default display value function
      return item;
    },
    dataValue: function dataValue(item) {
      return item;
    }
  };

  // Get options
  options = $.extend(defaults, options);
  return this.each(function () {
    // text input
    var $input = $(this);

    // assign data from options
    var data = options.data;
    if (data.length) {
      var $autocomplete = $('<ul class="mdb-autocomplete-wrap"></ul>');
      $autocomplete.insertAfter($(this));
    }

    // Listen if key was pressed
    $input.on('keyup', function (e) {
      // get value from input
      var q = $input.val();
      $autocomplete.empty();

      // check if input isn't empty
      if (q.length) {
        data.forEach(function (item) {
          // Use the custom filter function
          if (options.filter(item, q)) {
            // Use the custom display value function
            var displayText = options.displayValue(item);
            var option = $('<li>' + displayText + '</li>');
            option.data('value', item); // Store the original value in data attribute
            $autocomplete.append(option);
          }
        });
      }
      if (e.which == 13) {
        $autocomplete.children(":first").trigger('click');
        $autocomplete.empty();
      }
      if (q.length == 0) {
        $('.mdb-autocomplete-clear').css('visibility', 'hidden');
      } else {
        $('.mdb-autocomplete-clear').css('visibility', 'visible');
      }
    });
    $autocomplete.on('click', 'li', function () {
      // Set input value after click
      var originalValue = $(this).data('value');
      $input.val(options.displayValue(originalValue));
      $input.data('data', options.dataValue(originalValue));

      // Clear autocomplete
      $autocomplete.empty();

      // Trigger change event
      $input.trigger('change');
    });
    $('.mdb-autocomplete-clear').on('click', function (e) {
      e.preventDefault();
      $input.val('');
      $input.data('data', '');
      $(this).css('visibility', 'hidden');
      $autocomplete.empty();
      $(this).parent().find('label').removeClass('active');

      // Trigger change event
      $input.trigger('change');
    });
  });
};

},{}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var DatePicker = /*#__PURE__*/function () {
  function DatePicker() {
    _classCallCheck(this, DatePicker);
  }
  return _createClass(DatePicker, [{
    key: "InitDatePickers",
    value: function InitDatePickers() {
      $('.datepicker').each(function (a, e) {
        var input = $(e);
        var format = $('#date-format').val();
        var c = input.data('datepicker-config');
        if (c == undefined) {
          c = {
            assumeNearbyYear: true,
            format: format
          };
        }
        input.pickadate(c);
      });
    }
  }, {
    key: "GetDateSpan",
    value: function GetDateSpan() {
      if ($("#date-start").length && $("#date-end").length) {
        var start = toDate('#date-start');
        var end = toDate('#date-end');
        var span = Math.round((end.getTime() - start.getTime()) / (1000 * 60 * 60));
        return span;
      }
      return null;
    }
  }, {
    key: "CheckDateSpan",
    value: function CheckDateSpan() {
      var hourlyExists = $('#hourly-button').length > 0;
      var monthlyExists = $('#monthly-button').length > 0;
      var span = GetDateSpan();
      if (span < 48) {
        $('#daily-button').addClass('disabled');
      } else {
        $('#daily-button').removeClass('disabled');
      }
      if (span > 72) {
        if (hourlyExists) {
          $('#hourly-button').addClass('disabled');
        }
        if (span > 504) {
          $('#weekly-button').removeClass('disabled');
        } else {
          $('#weekly-button').addClass('disabled');
        }
        if (span > 1500) {
          $('#daily-button').addClass('disabled');
          if (monthlyExists) {
            $('#monthly-button').removeClass('disabled');
          }
        } else {
          if (monthlyExists) {
            $('#monthly-button').addClass('disabled');
          }
        }
      } else {
        if (hourlyExists) {
          $('#hourly-button').removeClass('disabled');
        }
        $('#weekly-button').addClass('disabled');
      }
      return span;
    }
  }, {
    key: "IsDate",
    value: function IsDate(date, format) {
      if (format == undefined) {
        format = 'DD-MM-YYYY';
      }
      if (window.moment != undefined) {
        var parsedDate = window.moment(date, format, true);
        if (isNaN(date) && !isNaN(parsedDate)) {
          return false;
        }
      } else {
        if (this.ValidateDate(date)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "ToDate",
    value: function ToDate(selector) {
      if (selector != undefined && $(selector).length) {
        var from = $(selector).val().split("-");
        return new Date(from[2], from[1] - 1, from[0]);
      }
      return null;
    }
  }, {
    key: "ValidateDate",
    value: function ValidateDate(inputText) {
      var dateformat = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
      // Match the date format through regular expression
      if (inputText.match(dateformat)) {
        var lopera1 = 0;
        var lopera2 = 0;
        var pdate = [];
        //Test which seperator is used '/' or '-'
        var opera1 = inputText.split('/');
        var opera2 = inputText.split('-');
        lopera1 = opera1.length;
        lopera2 = opera2.length;
        // Extract the string into month, date and year
        if (lopera1 > 1) {
          pdate = inputText.split('/');
        } else if (lopera2 > 1) {
          pdate = inputText.split('-');
        }
        var dd = parseInt(pdate[0]);
        var mm = parseInt(pdate[1]);
        var yy = parseInt(pdate[2]);
        // Create list of days of a month [assume there is no leap year by default]
        var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (mm == 1 || mm > 2) {
          if (dd > ListofDays[mm - 1]) {
            console.log('Invalid date format!');
            return false;
          }
        }
        if (mm == 2) {
          var lyear = false;
          if (!(yy % 4) && yy % 100 || !(yy % 400)) {
            lyear = true;
          }
          if (lyear == false && dd >= 29) {
            console.log('Invalid date format!');
            return false;
          }
          if (lyear == true && dd > 29) {
            console.log('Invalid date format!');
            return false;
          }
        }
      } else {
        console.log("Invalid date format!");
        return false;
      }
    }
  }]);
}();
var _default = exports["default"] = DatePicker;

},{}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FauxSelect = /*#__PURE__*/function () {
  function FauxSelect() {
    _classCallCheck(this, FauxSelect);
  }
  return _createClass(FauxSelect, [{
    key: "Initialise",
    value: function Initialise() {
      $(document.body).on('click', 'div.selected-options button.close', this.DeleteMultiChoiceOption);
      $(document.body).on('click', '.dropdown', function (event) {
        var $selector = $($(event.target).parent());
        var menu = $selector.parent().find('div.frn-dropdown-menu');
        if ($(menu).is(":visible")) {
          // multiselect is open, close it now
          $(menu).slideUp();
          $selector.removeClass('selecting');
        } else {
          //close any open multi selects
          var container = $(".frn-dropdown-menu");
          var ignoreMenuId = $(menu).attr('aria-labelledby');
          if (container.prop('aria-labelledby') !== ignoreMenuId) {
            container.hide();
          }
          container.parent().removeClass('selecting');

          // open this multi select
          $selector.addClass('selecting');
          $(menu).slideDown();
        }
      });
      $('body.body').mouseup(function (e) {
        var container = $(".frn-dropdown-menu");
        if ($(e.target).hasClass('multi-selected-value') !== true) {
          // if the target of the click isn't the container nor a descendant of the container
          if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.parent().find('.selecting').removeClass('selecting');
            container.hide();
          }
        }
      });
      $(document.body).on('hide.bs.dropdown', '.dropdown', function (event) {
        var hide = $(this).data('closable');
        $(this).data('closable', true);
        return hide;
      });
      $(document.body).on('click', 'ul.multi-choice-select > li', function (e) {
        var $option = $(this);
        var $optionVal = $($option.find('input:checkbox'));
        if (e.target.tagName.toLowerCase() !== 'input') {
          $optionVal.is(':checked') ? $optionVal.prop('checked', false) : $optionVal.prop('checked', true);
        }
        $option.hasClass('active') ? $option.removeClass('active') : $option.addClass('active');
        var $selectorDiv = $(this).closest("div.faux-multi-select-wrap").find("div.faux-multi-select.frn-override");
        if ($selectorDiv.data("select-type") == "single") {
          var $dropdown = $(this).closest("div.faux-multi-select-wrap").find("div.frn-dropdown-menu");
          var options = $dropdown.find("ul li input:checkbox");
          for (var i = 0; i < options.length; i++) {
            if ($(options[i]).val() != $optionVal.val()) {
              $(options[i]).prop('checked', false);
              $(options[i]).parent().removeClass('active');
            }
          }
        }
        $optionVal.change();
        var selectedOptionsOutputDiv = $(this).closest("div.faux-multi-select-wrap").find("div.selected-options");
        var selectedOptionsCountDiv = $(this).closest("div.faux-multi-select-wrap").find("span.multi-num");
        var labelText = $optionVal.parent().find('label').text();
        if ($optionVal.is(':checked')) {
          if ($selectorDiv.data("select-type") == "single") {
            selectedOptionsOutputDiv.html("<div>" + labelText + "<button type='button' class='close' aria-label='Close'><span aria-hidden='true'>×</span></button ></div>");
          } else {
            selectedOptionsOutputDiv.append("<div>" + labelText + "<button type='button' class='close' aria-label='Close'><span aria-hidden='true'>×</span></button ></div>");
          }
        } else {
          selectedOptionsOutputDiv.find('div:contains("' + labelText + '")').remove();
        }
        ;
        var count = selectedOptionsOutputDiv.children().length;
        if (count > 0) {
          $selectorDiv.addClass("active");
          if (selectedOptionsCountDiv.attr('no-bracket') !== undefined) selectedOptionsCountDiv.html(count);else selectedOptionsCountDiv.html("(" + count + ")");
        } else {
          $selectorDiv.removeClass("active");
          selectedOptionsCountDiv.html("");
        }
        if ($option.data('callback') !== undefined) {
          var callback = $option.data('callback');
          $("#panel").slideToggle();
          if (typeof callback == "string") {
            window[callback]();
          }
        }
        $optionVal.removeClass('trigger-click');
      });
      $('div.faux-multi-select-wrap').append("<div class='selected-options'></div>");
      $("li.trigger-click").each(function (i, e) {
        $(e).trigger('click');
      });
    }
  }, {
    key: "DeleteMultiChoiceOption",
    value: function DeleteMultiChoiceOption() {
      var labelText = $(this).parent().text();
      var buttonText = $(this).parent().find('button').text();
      var valueText = labelText.replace(buttonText, '');
      $(this).parent().parent().parent().find('ul.multi-choice-select > li.active > label:contains("' + valueText + '")').trigger('click');
      $(this).parent().remove();
    }
  }]);
}();
var _default = exports["default"] = FauxSelect;

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Language = /*#__PURE__*/function () {
  function Language(cookie) {
    _classCallCheck(this, Language);
    this.Cookie = cookie;
  }
  return _createClass(Language, [{
    key: "Select",
    value: function Select(url, locale) {
      var currently = this.Cookie.GetCookie("locale");
      if (currently !== locale) {
        this.Cookie.SetSessionCookie("switch-locale", locale);
      }
      if ($('#dynamic-query').length) {
        var dq = $('#dynamic-query').val();
        if (dq !== "") {
          var page = url.split("?")[0];
          url = page + dq;
        }
      }
      this.Cookie.SetCookie("locale", locale, 365);
      document.location.href = url;
      return false;
    }
  }]);
}();
var _default = exports["default"] = Language;

},{}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RebateAccounts = /*#__PURE__*/function () {
  function RebateAccounts() {
    _classCallCheck(this, RebateAccounts);
    $(function () {
      $('.close-error').on('click', function () {
        $(this).closest(".error-container").addClass('hide');
      });
    });
    if ($('#ClientProfileId').length) {
      $.ajax({
        type: "POST",
        cache: false,
        url: window.clientIdUrl,
        async: true,
        success: function success(result) {
          if (result.id !== undefined && result.id > 0) {
            $('#ClientProfileId').val(result.id);
          }
          ;
        }
      });
    }
  }
  return _createClass(RebateAccounts, [{
    key: "ClearError",
    value: function ClearError(container, canvas, progress) {
      canvas.html('');
      container.addClass('hide');
    }
  }, {
    key: "BreakForError",
    value: function BreakForError(error, container, canvas, progress) {
      progress.addClass('hide');
      canvas.html(error);
      container.removeClass('hide');
      $('html, body').animate({
        scrollTop: container.offset().top
      }, 250);
    }
    // ------------------------------//
  }, {
    key: "GetCashbackRates",
    value: function GetCashbackRates(accountId) {
      var postData = {};
      postData["AccountId"] = accountId;
      $('#dialog-show-rebate-rate').modal('show');
      $.ajax({
        type: "POST",
        cache: false,
        url: window.cashbackRateUrl,
        data: postData,
        async: true,
        success: function success(result) {
          $('#show-rebate-rate-content').html(result.pageView);
          $('#show-rebate-rate-progress').hide();
        }
      });
    }
  }, {
    key: "ChangeRegistrationType",
    value: function ChangeRegistrationType(accountRegistrationType) {
      if (accountRegistrationType === window.transferRegistrationType) {
        $('#step-one').addClass('hide');
        $('.' + window.customMessageTransferAccountNumber).show();
        $('.' + window.customMessageNewAccountNumber).hide();
        if ($('#hdnAllowsAccountTransfers').val() === "True") {
          $('#steptwowithnum').addClass('hide');
          $('#steptwoasstepone').removeClass('hide');
          $('#stepthreewithnum').addClass('hide');
          $('#stepthreeassteptwo').removeClass('hide');
          $('#stepthreewithtradingplatform').addClass('hide');
          $('#stepthreeassteptwotradingplatform').removeClass('hide');
        } else {
          $('#step-three').addClass('hide');
          $('#step-two').addClass('hide');
          $('#step-unsupported').removeClass('hide');
        }
        $('.form-type-NewAccount').hide();
        $('.form-type-Transfer').show();
        $('.first-instance-only').hide();
        $('#account-number-messages-transfer.first-instance-only').show();
      } else {
        $('.' + window.customMessageTransferAccountNumber).hide();
        $('.' + window.customMessageNewAccountNumber).show();
        $('#step-one').removeClass('hide');
        $('#step-two').removeClass('hide');
        $('#step-three').removeClass('hide');
        $('#step-unsupported').addClass('hide');
        $('#steptwowithnum').removeClass('hide');
        $('#steptwoasstepone').addClass('hide');
        $('#stepthreewithnum').removeClass('hide');
        $('#stepthreeassteptwo').addClass('hide');
        $('#stepthreewithtradingplatform').removeClass('hide');
        $('#stepthreeassteptwotradingplatform').addClass('hide');
        $('.form-type-NewAccount').show();
        $('.form-type-Transfer').hide();
        $('.first-instance-only').hide();
        $('#account-number-messages-new-account.first-instance-only').show();
      }
    }
  }, {
    key: "LoadRecaptcha",
    value: function LoadRecaptcha(callback) {
      var _this2 = this;
      if (!$('#recptcha-script').length) {
        var script = document.createElement('script');
        script.id = "recptcha-script";
        script.onload = function () {
          if (callback != undefined) {
            callback(_this2);
          }
        };
        script.src = "https://www.recaptcha.net/recaptcha/api.js?render=" + window.CAPTCHA_KEY;
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        if (callback != undefined) {
          callback(this);
        }
      }
    }
  }, {
    key: "SubmitAccount",
    value: function SubmitAccount() {
      this.CompleteSubmission();
      // this.LoadRecaptcha(); 
    }
  }, {
    key: "CompleteSubmission",
    value: function CompleteSubmission(_this) {
      if (_this == undefined) {
        _this = this;
      }
      var rebateOptionRadios = false;
      // ReSharper disable InconsistentNaming
      var RebateOption;
      if ($('#rebate-radio-buttons').length) {
        rebateOptionRadios = true;
        RebateOption = $("input[name='RebateOption']:checked");
      } else {
        RebateOption = $('#hdnRebateOption');
      }
      var errorContainer = $('#broker-account-add-error-message');
      var errorMessage = $('#broker-account-error-content');
      var progress = $("#broker-account-add-progress");
      var AccountTypeId = $('#AccountTypeId');
      var RegistrationType = $("input[name='AccountRegistrationType']:checked");
      var AccountNum = $('#account-input');
      var BrokerId = $('#hdnBrokerId');
      var BrokerName = $('#hdnBrokerName');
      var BrokerUrlSlug = $('#hdnBrokerUrlSlug');
      var Authorisation = $('#cbxAuthorise').prop('checked');
      var TradingPlatform = $('#TradingPlatform');
      _this.ClearError(errorContainer, errorMessage, progress);
      progress.removeClass('hide');
      var submitAccount = true;
      if (RegistrationType.val() == undefined) {
        _this.BreakForError(window.chooseRegistrationTypeError, errorContainer, errorMessage, progress);
        submitAccount = false;
      } else if (rebateOptionRadios && RebateOption.val() === undefined) {
        _this.BreakForError(window.rebateOptionError, errorContainer, errorMessage, progress);
        submitAccount = false;
      } else if (Authorisation === false) {
        _this.BreakForError(window.provideAuthorisation, errorContainer, errorMessage, progress);
        submitAccount = false;
      }
      if (RegistrationType.val() === window.registrationNew) {
        if (AccountTypeId.val() === "") {
          _this.BreakForError(window.chooseAccountTypeError, errorContainer, errorMessage, progress);
          submitAccount = false;
        } else if (AccountNum.val() === "") {
          _this.BreakForError(window.provideAccountNumberError, errorContainer, errorMessage, progress);
          submitAccount = false;
        }
      } else if (RegistrationType.val() === window.registrationTransfer) {
        if (AccountTypeId.val() === "") {
          _this.BreakForError(window.chooseAccountTypeError, errorContainer, errorMessage, progress);
          submitAccount = false;
        } else if (AccountNum.val() === "") {
          _this.BreakForError(window.provideAccountNumberError, errorContainer, errorMessage, progress);
          submitAccount = false;
        }
      }
      $('.input-field-value-required').each(function (index, element) {
        if ($(element).closest("div").is(":visible")) {
          if ($(element).val() === "") {
            $(element).addClass('input-validation-error');
            _this.BreakForError("Please fill out all required fields", errorContainer, errorMessage, progress);
            submitAccount = false;
          }
          ;
        }
      });
      if (submitAccount) {
        var postData = {};
        var inputFields = [];
        $('.input-field-value').each(function (index, element) {
          if ($(element).closest("div").is(":visible")) {
            var item = {};
            item.Name = $(element).attr('name');
            item.Value = $(element).val();
            inputFields.push(item);
          }
        });
        postData["ExternalSignUpRequired"] = false;
        if ($('#external-form-url').length) {
          var _RegistrationType = $("input[name='AccountRegistrationType']:checked");
          var mode = $('#external-form-mode').val();
          if (mode == '0' || mode == "2" && _RegistrationType.val() == 'New' || mode == "1" && _RegistrationType.val() == 'Transfer') {
            postData["ExternalSignUpRequired"] = true;
          }
        }
        postData["InputFields"] = inputFields;
        postData["BrokerId"] = BrokerId.val();
        postData["BrokerName"] = BrokerName.val();
        postData["AccountNumber"] = AccountNum.val();
        postData["AccountTypeId"] = AccountTypeId.val();
        postData["AccountRegistrationType"] = RegistrationType.val();
        postData["AuthorisationGiven"] = Authorisation;
        postData["RebateOptionId"] = RebateOption.val();
        postData["TradingPlatform"] = TradingPlatform.val();
        var clientId = $('#client-profile-id').val();
        if (clientId > 0) {
          $.ajax({
            type: "POST",
            cache: false,
            url: window.submitAccountUrl,
            data: postData,
            async: true,
            success: function success(result) {
              if (result.isError) {
                _this.BreakForError(result.errorMessage, errorContainer, errorMessage, progress);
              } else {
                var modal = $('#messageModal');
                modal.find('#message-title').text(window.accAddedString);
                modal.find('#message-body').text(window.regSuccessString);
                modal.modal('show');
                progress.addClass('hide');
                if (result.requiresNfa) {
                  setTimeout(function () {
                    document.location.href = window.submitNfaUrl;
                  }, 2000);
                } else if (!result.requiresExternalAction) {
                  setTimeout(function () {
                    document.location.href = window.clientPanelUrl + '#' + encodeURIComponent('rebate_acc_added:' + AccountNum.val() + ":" + BrokerId.val() + ":" + TradingPlatform.val() + ":" + BrokerName.val());
                  }, 2000);
                } else {
                  setTimeout(function () {
                    document.location.href = window.clientPanelUrl;
                  }, 1000);
                }
              }
            },
            error: function error(result) {
              this.BreakForError("Unknown error has occurred", errorContainer, errorMessage, progress);
            }
          });
        } else {
          progress.addClass('hide');
          if (window.Access === undefined) {
            alert('You must be logged in with a valid client profile to register a trading account');
          } else {
            var accountData = {};
            if ($('#rebate-radio-buttons').length) {
              accountData.RebateOption = $("input[name='RebateOption']:checked").val();
            } else {
              accountData.RebateOption = $('#hdnRebateOption').val();
            }
            accountData.AccountRegistrationType = $("input[name='AccountRegistrationType']:checked").val();
            accountData.AccountTypeId = $('#AccountTypeId').val();
            accountData.AccountNumber = $('#account-input').val();
            accountData.AuthorisationGiven = $('#cbxAuthorise').prop('checked');
            accountData.BrokerId = BrokerId.val();
            accountData.BrokerName = BrokerName.val();
            accountData.BrokerUrlSlug = BrokerUrlSlug.val();
            var data = JSON.stringify(accountData);
            window.Access.LoginWithPurpose('SubmitAccountPostLogin', 'You must be logged in to perform this action', 'signup', window.TASK_SUBMIT_ACCOUNT_NOTIFY, data);
          }
        }
      }
    }
  }, {
    key: "SubmitAccountPostLogin",
    value: function SubmitAccountPostLogin() {
      if (!($('#ClientProfileId').val() > 0) || $('#ClientProfileId').val() === "0") {
        alert("You must be logged in with a valid client profile to register a trading account");
        location.reload();
      } else {
        window.Access.LoginHideModal();
        window.RebateAccounts.SubmitAccount();
      }
    }
  }, {
    key: "GetRebateOptions",
    value: function GetRebateOptions(accountTypeId) {
      var _this3 = this;
      var postData = {};
      postData.lang = window.CURRENT_LANG;
      postData["AccountTypeId"] = accountTypeId;
      $.ajax({
        type: "POST",
        cache: false,
        url: window.rebateOptionUrl,
        data: postData,
        async: true,
        success: function success(result) {
          $('#RebateOptions').removeClass("hide");
          $('#rebate-options-form-elements').html(result.pageView);
          if ($('#hdnRebateOptionPreset').val() !== undefined) {
            $('#RebateOption_' + $('#hdnRebateOptionPreset').val()).prop('checked', true);
          }
          _this3.SetUpDynamicPopUps();
        }
      });
    }
  }, {
    key: "SetUpDynamicPopUps",
    value: function SetUpDynamicPopUps() {
      $('[data-toggle="pop-rebate-description"]').popover('dispose');
      $('[data-toggle="pop-rebate-description"]').popover({
        content: function content() {
          var id = $(this).data('target-id');
          var out = "<div class=\"rating-popover-content\">" + $('#hidden-description-' + id).html() + "</div>";
          return out;
        }
      });
    }
  }]);
}();
var _default = exports["default"] = RebateAccounts;

},{}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SearchPage = /*#__PURE__*/function () {
  function SearchPage() {
    _classCallCheck(this, SearchPage);
    this.currentQuery = '';
    this.currentCategory = 'all';
    this.currentSortDir = 'latest';
    this.currentPage = 1;
    this.filterOptions = null;
    this.selectedForumCategoryIds = [];
    this.selectedCompanyCategoryIds = [];
    this.selectedEventCountries = [];
  }
  return _createClass(SearchPage, [{
    key: "initializeFromUrl",
    value: function initializeFromUrl() {
      var urlParams = new URLSearchParams(window.location.search);
      var query = urlParams.get('query') || '';
      var categoryParam = urlParams.get('category');
      var category = categoryParam || 'all';
      var sortDir = urlParams.get('sortDir') || 'latest';
      var pageParam = urlParams.get('page');
      var page = pageParam ? parseInt(pageParam, 10) : 1;

      // Parse filter parameters
      var forumCategoryIdsParam = urlParams.get('forumCategoryIds') || '';
      var companyCategoryIdsParam = urlParams.get('companyCategoryIds') || '';
      var eventCountriesParam = urlParams.get('eventCountries') || '';
      this.selectedForumCategoryIds = forumCategoryIdsParam ? forumCategoryIdsParam.split(',').map(function (id) {
        return parseInt(id.trim());
      }).filter(function (id) {
        return !isNaN(id);
      }) : [];
      this.selectedCompanyCategoryIds = companyCategoryIdsParam ? companyCategoryIdsParam.split(',').map(function (id) {
        return parseInt(id.trim());
      }).filter(function (id) {
        return !isNaN(id);
      }) : [];
      this.selectedEventCountries = eventCountriesParam ? eventCountriesParam.split(',').map(function (code) {
        return code.trim();
      }).filter(function (code) {
        return code.length > 0;
      }) : [];

      // Populate search input
      $('#search-query-input').val(query);

      // Update category buttons
      $('.search-category-btn').removeClass('active');
      $('.search-category-btn[data-category="' + category + '"]').addClass('active');

      // Update sort radio buttons
      $('input[name="sortDir"]').prop('checked', false);
      $('input[name="sortDir"][value="' + sortDir + '"]').prop('checked', true);

      // Store current values
      this.currentQuery = query;
      this.currentCategory = category;
      this.currentSortDir = sortDir;
      this.currentPage = page;

      // Load filter options and then update filters
      var self = this;
      this.loadFilterOptions().then(function () {
        self.updateFilterPanel();
        // Only load results if query is not empty
        if (query && query.trim().length > 0) {
          self.loadResults();
        }
      });
    }
  }, {
    key: "updateUrl",
    value: function updateUrl() {
      var params = new URLSearchParams();
      if (this.currentQuery) {
        params.set('query', this.currentQuery);
      }
      if (this.currentCategory && this.currentCategory !== 'all') {
        params.set('category', this.currentCategory);
      }
      if (this.currentSortDir && this.currentSortDir !== 'latest') {
        params.set('sortDir', this.currentSortDir);
      }
      // Only add page parameter when category is not "all"
      if (this.currentCategory !== 'all' && this.currentPage > 1) {
        params.set('page', this.currentPage);
      }

      // Add filter parameters
      if (this.selectedForumCategoryIds.length > 0) {
        params.set('forumCategoryIds', this.selectedForumCategoryIds.join(','));
      }
      if (this.selectedCompanyCategoryIds.length > 0) {
        params.set('companyCategoryIds', this.selectedCompanyCategoryIds.join(','));
      }
      if (this.selectedEventCountries.length > 0) {
        params.set('eventCountries', this.selectedEventCountries.join(','));
      }
      var newUrl = window.location.pathname;
      if (params.toString()) {
        newUrl += '?' + params.toString();
      }
      window.history.pushState({
        path: newUrl
      }, '', newUrl);
    }

    // Render forum topic item
  }, {
    key: "renderForumTopic",
    value: function renderForumTopic(topic) {
      var _topic$Replies, _topic$Replies2, _topic$NumParticipant, _topic$NumParticipant2;
      var template = window.forumTemplates['topicItem'];
      template = template.replace(/{{ForumItemId}}/g, topic.Id);
      template = template.replace("{{ForumItemTitle}}", this.escapeHtml(topic.Title));
      var createdBy = 'Created: ';
      var creationDate = moment.utc(topic.CreationDate).format("MMM DD,YYYY");
      createdBy += creationDate;
      template = template.replace("{{ForumItemTopicStarter}}", createdBy);
      var repliesStr = window.forumStrings && window.forumStrings['_0Replies'] ? window.forumStrings['_0Replies'].replace("{0}", (_topic$Replies = topic.Replies) !== null && _topic$Replies !== void 0 ? _topic$Replies : 0) : ((_topic$Replies2 = topic.Replies) !== null && _topic$Replies2 !== void 0 ? _topic$Replies2 : 0) + ' replies';
      template = template.replace("{{ForumItemReplies}}", repliesStr);
      var participantsStr = window.forumStrings && window.forumStrings['_0Participants'] ? window.forumStrings['_0Participants'].replace("{0}", (_topic$NumParticipant = topic.NumParticipants) !== null && _topic$NumParticipant !== void 0 ? _topic$NumParticipant : 0) : ((_topic$NumParticipant2 = topic.NumParticipants) !== null && _topic$NumParticipant2 !== void 0 ? _topic$NumParticipant2 : 0) + ' participants';
      template = template.replace("{{ForumItemParticipants}}", participantsStr);
      template = template.replace("{{ForumItemLastPostBy}}", this.escapeHtml(topic.LastPostBy || ''));
      template = template.replace("{{ForumItemLastPostBySocialId}}", topic.LastPostBySocialProfileId || 0);
      if (topic.LastPostBy) {
        var myDate = moment.duration(moment.utc(topic.LastUpdateDate).diff(moment().utc())).humanize(true);
        template = template.replace(/{{ForumItemLastPostAt}}/g, myDate);
      } else {
        template = template.replace(/{{ForumItemLastPostAt}}/g, '');
      }
      template = template.replace("{{ForumItemModeratorControls}}", '');
      var itemDiv = $(template);
      if (!topic.LastPostBy) {
        itemDiv.find('.last-post-data').remove();
      }
      return itemDiv;
    }

    // Render news item
  }, {
    key: "renderNewsItem",
    value: function renderNewsItem(news) {
      var logo = '';
      if (!news.Thumbnail) {
        if (!news.ListingType) {
          logo = '/Content/dist/news/images/no-image';
        } else {
          logo = '/Content/dist/images/PageElements/news-' + news.ListingType + '.png';
        }
      } else if (news.ImportedFromThirdParty) {
        logo = news.Thumbnail;
      } else {
        logo = '/Content/dist/news/images/' + news.Thumbnail;
      }
      var publishDate = '';
      if (news.PublishDate) {
        publishDate = moment.duration(moment.utc(news.PublishDate).diff(moment().utc())).humanize(true);
      }
      var tagsHtml = '';
      if (news.Tags && news.Tags.length > 0) {
        news.Tags.forEach(function (tag) {
          if (news.TagLinks && news.TagLinks[tag.toLowerCase()]) {
            tagsHtml += '<a href="' + langSlug + news.TagLinks[tag.toLowerCase()] + '" class="tag"><span>' + this.escapeHtml(tag) + '</span></a>';
          } else {
            tagsHtml += '<div class="tag"><span>' + this.escapeHtml(tag) + '</span></div>';
          }
        }.bind(this));
      }
      var forumCategoryHtml = '';
      if (news.ForumCategoryId) {
        forumCategoryHtml = '<a href="' + langSlug + '/forum?category=' + news.ForumCategoryId + '" class="news-discussion-link ml-0 ml-md-3">' + '<div class="discussion-icon"><icon class="mdi mdi-forum"></icon></div>' + '<span>News Discussion Forum</span></a>';
      }
      var authorHtml = '';
      if (news.AuthorSocialProfileId && news.AuthorSocialProfileId > 0) {
        authorHtml = '<span class="social-profile-navigate text-dotted-underline" data-profile-id="' + news.AuthorSocialProfileId + '">' + this.escapeHtml(news.AuthorName) + '</span>';
      } else {
        authorHtml = '<span>' + this.escapeHtml(news.AuthorName) + '</span>';
      }
      var replyOnclick = '';
      if (news.ForumCategoryId) {
        replyOnclick = 'onclick="window.SocialProfile.AddInlineEntityPost(' + news.ForumCategoryId + ', \'' + (window.ENTITY_TYPE_NEWS_PAGE || 'NewsPage') + '\', ' + news.NewsId + ')"';
      }
      var newsUrl = langSlug + '/news/' + news.NewsSlug + '-' + news.NewsId;
      var html = '<div class="news-item-box">' + '<div class="d-flex flex-column" style="gap: 8px;">' + '<div class="d-flex" style="gap: 16px;">' + '<a class="d-none d-md-block" href="' + newsUrl + '">' + '<img class="thumbnail-image" src="' + logo + '" alt="' + this.escapeHtml(news.Title) + '">' + '</a>' + '<div class="d-flex flex-column flex-grow-1" style="gap: 8px;">' + '<div class="d-flex justify-content-between align-items-md-center flex-column flex-md-row flex-md-row-reverse">' + '<div class="d-flex flex-column align-items-end">' + '<span class="news-date" data-date="' + (news.PublishDate || '') + '">' + publishDate + '</span>' + '</div>' + '<div class="d-flex align-items-center" style="gap: 16px;">' + '<a class="d-block d-md-none" href="' + newsUrl + '">' + '<img class="thumbnail-image" src="' + logo + '" alt="' + this.escapeHtml(news.Title) + '">' + '</a>' + '<div class="d-flex align-items-md-center flex-column flex-md-row flex-md-row-reverse">' + forumCategoryHtml + '<div class="broker mt-2 mt-md-0">' + '<span>By ' + authorHtml + '</span>' + '</div>' + '</div>' + '</div>' + '</div>' + '<a href="' + newsUrl + '"><div class="title">' + this.escapeHtml(news.Title) + '</div></a>' + '<div class="text">' + (news.Summary || '') + '</div>' + '<div class="d-flex justify-content-between flex-md-row flex-column" style="gap: 8px;">' + '<div class="d-flex flex-wrap" style="gap: 8px;">' + tagsHtml + '</div>' + '<div class="d-flex flex-column align-items-end">' + '<a href="javascript:void(0);" ' + replyOnclick + ' class="reply">' + '<i class="reply-to-post"></i>' + '<span>Reply</span>' + '</a>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>';
      var $html = $(html);
      // Update news date dynamically
      if ($html.find('.news-date').length && news.PublishDate) {
        var $newsDate = $html.find('.news-date');
        var now = moment.utc();
        $newsDate.text(moment.duration(moment.utc(news.PublishDate).diff(now)).humanize(true));
      }
      return $html;
    }

    // Render economic event item
  }, {
    key: "renderEconomicEvent",
    value: function renderEconomicEvent(event) {
      var flagHtml = '';
      if (event.CountryCode) {
        var countryName = event.Country || '';
        flagHtml = '<i class="flag flag-' + event.CountryCode.toLowerCase() + '" data-trigger="hover" data-content="' + this.escapeHtml(countryName) + '" data-placement="top" data-toggle="popover-hover"></i>';
      }
      var dateStr = '';
      if (event.Date) {
        // Date is Unix timestamp in seconds
        var eventDate = moment.unix(event.Date);
        dateStr = eventDate.format('MMM DD, YYYY HH:mm');
      }
      var impactIcon = '';
      var impactText = event.Impact || '';
      var impactDisplayText = '';

      // Convert volatility/impact to display format
      if (impactText) {
        var impactUpper = impactText.toUpperCase();
        impactIcon = '<img src="/content/dist/images/icons/impact-' + impactUpper.toLowerCase() + '.png" style="width: 16px; height: 16px;">';
        if (impactUpper === 'HIGH' || impactUpper.includes('HIGH')) {
          impactDisplayText = window.searchResxStrings['HighImpact'];
        } else if (impactUpper === 'MEDIUM' || impactUpper.includes('MEDIUM')) {
          impactDisplayText = window.searchResxStrings['MediumImpact'];
        } else if (impactUpper === 'LOW' || impactUpper.includes('LOW')) {
          impactDisplayText = window.searchResxStrings['LowImpact'];
        } else {
          impactDisplayText = window.searchResxStrings['LowImpact'];
        }
      }
      var html = '<div class="economic-event-item flex-column" style="gap: 4px">' + '<div class="d-flex" style="gap: 16px; align-items: center;">' + '<div style="display: flex; align-items: center; gap: 8px;">' + flagHtml + '<span style="font-weight: 600; color: #0A1F41;">' + (event.CurrencyCode || '') + '</span>' + '</div>' + '<a class="d-none d-sm-block" href="/tools/economic-calendar?time=' + event.Date + '&jumpTo=' + event.CalendarId + '" style="flex: 1; color: #0A1F41;">' + this.escapeHtml(event.Name || '') + '</a>' + '<div style="color: var(--Colors-Text-Text-Tertiary, #68758A); font-size: 14px;">' + dateStr + '</div>' + '<div style="display: flex; align-items: center; gap: 8px;">' + impactIcon + '<span style="color: var(--Colors-Text-Text-Tertiary, #68758A); font-size: 14px;">' + impactDisplayText + '</span>' + '</div>' + '</div>' + '<a class="d-sm-none" href="/tools/economic-calendar?time=' + event.Date + '&jumpTo=' + event.CalendarId + '" style="flex: 1; color: #0A1F41;">' + this.escapeHtml(event.Name || '') + '</a>' + '</div>';
      return $(html);
    }

    // Render tools item
  }, {
    key: "renderToolItem",
    value: function renderToolItem(tool) {
      var toolTitle = tool.Title;
      var toolName = tool.Name;
      var toolPath = tool.Path || '#';
      var toolUrl = langSlug + toolPath;
      var html = '<div class="tool-item">' + '<a href="' + toolUrl + '" style="text-decoration: none; color: inherit;">' + '<div class="tool-item-title">' + this.escapeHtml(toolTitle) + '</div>' + '<div class="tool-item-name">' + this.escapeHtml(toolName) + '</div>' + '</a>' + '</div>';
      return $(html);
    }

    // Helper function to render star rating HTML
  }, {
    key: "renderStarRating",
    value: function renderStarRating(rating, reviewCount, verifiedReviewCount, link) {
      if (!rating || rating === 0) {
        return '<div style="display: flex; align-items: center; gap: 4px;">' + '<span style="color: #68758A; font-size: 14px;">0</span>' + '<div class="star-holder star-rating-sm" style="display: inline-flex; align-items: center;">' + '<span class="typcn outline-stars-5" style="font-size: 18px;"></span>' + '</div>' + '</div>' + '<span style="color: #68758A; font-size: 14px;">0 Reviews</span>';
      }
      var roundedVal = Math.round(rating * 10) / 10;
      var decimalPart = roundedVal % 1;
      var half = decimalPart > 0.001 && decimalPart < 0.5;
      // Round to nearest integer using AwayFromZero (same as C# MidpointRounding.AwayFromZero)
      var stars = Math.round(roundedVal);
      // If we have a half star, adjust: show floor(roundedVal) full stars + 1 half star
      if (half) {
        stars = Math.floor(roundedVal);
      }
      var outlineStars = 5 - stars - (half ? 1 : 0);
      var reviewCountText = reviewCount || 0;
      var verifiedCount = verifiedReviewCount || 0;
      var reviewLink = link || '#';
      var reviewCountHtml = '';
      if (verifiedCount >= 30) {
        reviewCountHtml = '<a href="' + reviewLink + '" class="review-count" style="color: #68758A; font-size: 14px; text-decoration: none;">' + '<span class="text-dotted-underline">' + reviewCountText + '</span> Reviews&nbsp;<img src="/Content/dist/images/icons/small-check-mark-icon.svg" style="width: 12px; height: 12px;" />';
      } else if (reviewCountText > 0) {
        reviewCountHtml = '<a href="' + reviewLink + '" class="review-count" style="color: #68758A; font-size: 14px; text-decoration: none;">' + reviewCountText + ' Reviews</a>';
      } else {
        reviewCountHtml = '<span style="color: #68758A; font-size: 14px;">0 Reviews</span>';
      }
      return '<div style="display: flex; align-items: center;">' + '<span style="color: #68758A; font-size: 14px; font-weight: 600; margin-right: 4px;">' + roundedVal.toFixed(1) + '</span>' + '<div class="star-holder star-rating-sm" style="display: inline-flex; align-items: center;">' + '<span class="typcn stars-' + stars + '" style="font-size: 18px;"></span>' + (half ? '<span class="typcn typcn-star-half-outline" style="font-size: 18px;"></span>' : '') + '<span class="typcn outline-stars-' + outlineStars + '" style="font-size: 18px;"></span>' + '</div>' + '</div>' + reviewCountHtml;
    }

    // Render company item
  }, {
    key: "renderCompanyItem",
    value: function renderCompanyItem(company) {
      var companyName = this.escapeHtml(company.Name || '');
      var logoUrl = '';
      var websiteLink = '';
      var reviewLink = '';
      if (company.EntityType == 'CryptoExchange') {
        logoUrl = company.Logo ? company.Logo : '/Content/dist/brokers/images/no-logo.png';
        websiteLink = langSlug + '/crypto-exchange/' + company.Code + "-review-" + company.BrokerId;
        reviewLink = langSlug + '/crypto-exchange/' + company.Code + '-user-reviews-' + company.BrokerId;
      } else {
        logoUrl = company.Logo ? '/Content/dist/brokers/images/' + company.Logo : '/Content/dist/brokers/images/no-logo.png';
        websiteLink = langSlug + '/brokers/' + company.Code + "-review-" + company.BrokerId;
        reviewLink = langSlug + '/brokers/' + company.Code + '-user-reviews-' + company.BrokerId;
      }
      var ctaLink;
      var ctaLinkName = "Open Account";
      if (company.JoinCTAButtonLink) {
        ctaLink = company.JoinCTAButtonLink;
      } else if (company.CTAButtonLink) {
        ctaLink = company.CTAButtonLink;
      } else {
        ctaLink = company.WebsiteLink;
      }
      var rating = company.UserRating || 0;
      var reviewCount = company.ReviewCount || 0;
      var verifiedReviewCount = company.VerifiedReviewCount || 0;
      var starRatingHtml = this.renderStarRating(rating, reviewCount, verifiedReviewCount, reviewLink);
      var html = '<div class="company-item">' + '<div style="flex-shrink: 0;">' + '<div class="logo">' + '<a href="' + websiteLink + '" style="display: block; width: 100%; height: 100%;">' + '<img src="' + logoUrl + '" alt="' + companyName + '" style="width: 100%; height: 100%; object-fit: contain;" />' + '</a>' + '</div>' + '</div>' + '<div style="flex: 1; display: flex; flex-direction: column; gap: 8px;">' + '<a href="' + websiteLink + '" style="text-decoration: none;">' + '<div class="title">' + companyName + '</div>' + '</a>' + '<div style="display: flex; flex-direction: column; gap: 4px;">' + starRatingHtml + '</div>' + '</div>' + '<div style="flex-shrink: 0; display: flex; flex-direction: column; gap: 8px;">' + '<a href="' + websiteLink + '" class="std-btn small tertiary">See Overview</a>' + (ctaLink ? '<a href="' + ctaLink + '" class="std-btn small green">' + ctaLinkName + '</a>' : "") + '</div>' + '</div>';
      return $(html);
    }

    // Escape HTML to prevent XSS
  }, {
    key: "escapeHtml",
    value: function escapeHtml(text) {
      if (!text) return '';
      var map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      };
      return text.toString().replace(/[&<>"']/g, function (m) {
        return map[m];
      });
    }

    // Render skeleton for forum topic
  }, {
    key: "renderForumTopicSkeleton",
    value: function renderForumTopicSkeleton() {
      var skeletonHtml = '<div class="skeleton-frame forum-item topic" style="width: 100%;">' + '<div class="d-flex align-items-center" style="gap: 16px; align-self: end">' + '<div class="d-md-none"><div class="skeleton skeleton-text" style="width: 80px; height: 16px;"></div></div>' + '</div>' + '<div class="d-flex" style="gap: 16px;">' + '<div class="item-icon">' + '<img src="/Content/dist/images/icons/forum.svg">' + '</div>' + '<div class="item-content" style="flex: 1;">' + '<div class="d-flex flex-column item-title-skeleton" style="gap: 8px;">' + '<div class="skeleton-dark skeleton-text multi-row-text half-line bold"></div>' + '<div class="skeleton skeleton-text multi-row-text half-line"></div>' + '</div>' + '<div class="item-reaction-summary">' + '<div class="d-flex" style="gap: 16px">' + '<div class="d-flex" style="gap: 4px;"><i class="reply-to-post icon"></i><div class="skeleton skeleton-text buffer" style="width: 50px;"></div></div>' + '<div class="d-flex" style="gap: 4px;"><i class="participants-in-thread icon"></i><div class="skeleton skeleton-text buffer" style="width: 80px;"></div></div>' + '</div>' + '<div class="d-flex last-post-data" style="gap: 4px;">' + '<div class="d-flex" style="gap: 4px;">' + '<i class="mdi mdi-clock" style="font-size: 16px; color: #6E7B8F; margin-top: -3px;"></i>' + '<div class="skeleton skeleton-text buffer" style="width: 80px;"></div>' + '</div>' + '<div class="d-flex flex-column">' + '<div class="skeleton skeleton-text buffer" style="width: 100px; margin-bottom: 4px;"></div>' + '<div class="d-none d-md-block skeleton skeleton-text buffer" style="width: 80px;"></div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>';
      return $(skeletonHtml);
    }

    // Render skeleton for news item
  }, {
    key: "renderNewsItemSkeleton",
    value: function renderNewsItemSkeleton() {
      var skeletonHtml = '<div class="news-item-box" style="width: 100%;">' + '<div class="d-flex flex-column" style="gap: 8px;">' + '<div class="d-flex" style="gap: 16px;">' + '<div class="d-none d-md-block">' + '<div class="skeleton skeleton-text" style="width: 120px; height: 80px; border-radius: 4px;"></div>' + '</div>' + '<div class="d-flex flex-column flex-grow-1" style="gap: 8px; width: 100%;">' + '<div class="d-flex justify-content-between align-items-md-center flex-column flex-md-row flex-md-row-reverse">' + '<div class="skeleton skeleton-text buffer" style="width: 80px; height: 16px;"></div>' + '<div class="d-flex align-items-center" style="gap: 16px;">' + '<div class="d-block d-md-none">' + '<div class="skeleton skeleton-text" style="width: 120px; height: 80px; border-radius: 4px;"></div>' + '</div>' + '<div class="skeleton skeleton-text buffer" style="width: 150px; height: 16px;"></div>' + '</div>' + '</div>' + '<div class="skeleton-dark skeleton-text multi-row-text half-line bold"></div>' + '<div class="skeleton skeleton-text multi-row-text"></div>' + '<div class="d-flex justify-content-between flex-md-row flex-column" style="gap: 8px;">' + '<div class="d-flex flex-wrap" style="gap: 8px;">' + '<div class="skeleton skeleton-text buffer" style="width: 60px; height: 24px; border-radius: 4px;"></div>' + '<div class="skeleton skeleton-text buffer" style="width: 80px; height: 24px; border-radius: 4px;"></div>' + '</div>' + '<div class="skeleton skeleton-text buffer" style="width: 60px; height: 24px;"></div>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>';
      return $(skeletonHtml);
    }

    // Render skeleton for tool item
  }, {
    key: "renderToolItemSkeleton",
    value: function renderToolItemSkeleton() {
      var skeletonHtml = '<div class="tool-item" style="width: 100%;">' + '<div class="skeleton-dark skeleton-text multi-row-text half-line bold" style="text-align: center; margin-bottom: 4px;"></div>' + '<div class="skeleton skeleton-text buffer" style="width: 100px; margin: 0 auto;"></div>' + '</div>';
      return $(skeletonHtml);
    }

    // Render skeleton for economic event
  }, {
    key: "renderEconomicEventSkeleton",
    value: function renderEconomicEventSkeleton() {
      var skeletonHtml = '<div class="economic-event-item" style="display: flex; align-items: center; gap: 16px; padding: 12px; background: #f5f5f5; border-radius: 8px; margin-bottom: 8px; width: 100%;">' + '<div style="display: flex; align-items: center; gap: 8px;">' + '<div class="skeleton skeleton-text" style="width: 24px; height: 24px; border-radius: 4px;"></div>' + '<div class="skeleton skeleton-text buffer" style="width: 40px;"></div>' + '</div>' + '<div style="flex: 1;">' + '<div class="skeleton-dark skeleton-text multi-row-text half-line"></div>' + '</div>' + '<div class="skeleton skeleton-text buffer" style="width: 120px;"></div>' + '<div style="display: flex; align-items: center; gap: 8px;">' + '<div class="skeleton skeleton-text" style="width: 12px; height: 12px; border-radius: 2px;"></div>' + '<div class="skeleton skeleton-text buffer" style="width: 80px;"></div>' + '</div>' + '</div>';
      return $(skeletonHtml);
    }

    // Render skeleton for company item
  }, {
    key: "renderCompanyItemSkeleton",
    value: function renderCompanyItemSkeleton() {
      var skeletonHtml = '<div class="company-item" style="display: flex; align-items: center; gap: 16px; padding: 16px; background: #F8F9FA; border-radius: 8px; margin-bottom: 16px; width: 100%;">' + '<div style="flex-shrink: 0;">' + '<div class="skeleton skeleton-text" style="width: 88px; height: 88px; border-radius: 8px; background: white;"></div>' + '</div>' + '<div style="flex: 1; display: flex; flex-direction: column; gap: 8px;">' + '<div class="skeleton-dark skeleton-text multi-row-text half-line bold" style="width: 200px; height: 20px; margin-bottom: 4px;"></div>' + '<div style="display: flex; flex-direction: column; gap: 4px;">' + '<div style="display: flex; align-items: center; gap: 8px;">' + '<div class="skeleton skeleton-text buffer" style="width: 30px; height: 16px;"></div>' + '<div class="skeleton skeleton-text buffer" style="width: 100px; height: 18px;"></div>' + '<div class="skeleton skeleton-text buffer" style="width: 80px; height: 16px;"></div>' + '</div>' + '</div>' + '</div>' + '<div style="flex-shrink: 0; display: flex; flex-direction: column; gap: 8px;">' + '<div class="skeleton skeleton-text buffer" style="width: 100px; height: 36px; border-radius: 4px;"></div>' + '<div class="skeleton skeleton-text buffer" style="width: 100px; height: 36px; border-radius: 4px;"></div>' + '</div>' + '</div>';
      return $(skeletonHtml);
    }

    // Show skeleton loaders
  }, {
    key: "showSkeletons",
    value: function showSkeletons() {
      var $container = $('#search-page-result');
      $container.empty();
      // Clear count while loading
      $('#search-results-count').empty();
      var self = this;
      if (this.currentCategory === 'all') {
        // Show skeletons for all categories with 2 items each

        // Helper function to create skeleton section header
        var createSkeletonSectionHeader = function createSkeletonSectionHeader() {
          return $('<h2 style="margin-bottom: 16px;"><div class="skeleton-dark skeleton-text multi-row-text half-line" style="width: 150px; height: 24px;"></div></h2>');
        };

        // Forum section skeleton
        var $forumSection = $('<div class="search-result-section" style="margin-bottom: 32px;"></div>');
        $forumSection.append(createSkeletonSectionHeader());
        var $forumItems = $('<div class="d-flex flex-column" style="gap: 16px;"></div>');
        for (var i = 0; i < 2; i++) {
          $forumItems.append(self.renderForumTopicSkeleton());
        }
        $forumSection.append($forumItems);
        $container.append($forumSection);

        // News section skeleton
        var $newsSection = $('<div class="search-result-section" style="margin-bottom: 32px;"></div>');
        $newsSection.append(createSkeletonSectionHeader());
        var $newsItems = $('<div class="d-flex flex-column" style="gap: 16px;"></div>');
        for (var i = 0; i < 2; i++) {
          $newsItems.append(self.renderNewsItemSkeleton());
        }
        $newsSection.append($newsItems);
        $container.append($newsSection);

        // Tools section skeleton
        var $toolsSection = $('<div class="search-result-section" style="margin-bottom: 32px;"></div>');
        $toolsSection.append(createSkeletonSectionHeader());
        var $toolsItems = $('<div class="d-flex flex-column" style="gap: 16px;"></div>');
        for (var i = 0; i < 2; i++) {
          $toolsItems.append(self.renderToolItemSkeleton());
        }
        $toolsSection.append($toolsItems);
        $container.append($toolsSection);

        // Economic Events section skeleton
        var $eventsSection = $('<div class="search-result-section" style="margin-bottom: 32px;"></div>');
        $eventsSection.append(createSkeletonSectionHeader());
        var $eventsItems = $('<div class="d-flex flex-column" style="gap: 16px;"></div>');
        for (var i = 0; i < 2; i++) {
          $eventsItems.append(self.renderEconomicEventSkeleton());
        }
        $eventsSection.append($eventsItems);
        $container.append($eventsSection);

        // Companies section skeleton
        var $companiesSection = $('<div class="search-result-section" style="margin-bottom: 32px;"></div>');
        $companiesSection.append(createSkeletonSectionHeader());
        var $companiesItems = $('<div class="d-flex flex-column" style="gap: 16px;"></div>');
        for (var i = 0; i < 2; i++) {
          $companiesItems.append(self.renderCompanyItemSkeleton());
        }
        $companiesSection.append($companiesItems);
        $container.append($companiesSection);
      } else {
        // Show skeletons for specific category with 3 items
        var $items = $('<div class="d-flex flex-column" style="gap: 16px;"></div>');
        if (this.currentCategory === 'forum') {
          for (var i = 0; i < 3; i++) {
            $items.append(self.renderForumTopicSkeleton());
          }
        } else if (this.currentCategory === 'news') {
          for (var i = 0; i < 3; i++) {
            $items.append(self.renderNewsItemSkeleton());
          }
        } else if (this.currentCategory === 'tools') {
          for (var i = 0; i < 3; i++) {
            $items.append(self.renderToolItemSkeleton());
          }
        } else if (this.currentCategory === 'economic-events') {
          for (var i = 0; i < 3; i++) {
            $items.append(self.renderEconomicEventSkeleton());
          }
        } else if (this.currentCategory === 'companies') {
          for (var i = 0; i < 3; i++) {
            $items.append(self.renderCompanyItemSkeleton());
          }
        }
        $container.append($items);
      }
    }

    // Get category display name
  }, {
    key: "getCategoryDisplayName",
    value: function getCategoryDisplayName(category) {
      var categoryMap = {
        'all': window.searchResxStrings['All'],
        'forum': window.searchResxStrings['Forum'],
        'news': window.searchResxStrings['News'],
        'tools': window.searchResxStrings['Tools'],
        'companies': window.searchResxStrings['Companies'],
        'economic-events': window.searchResxStrings['EconomicEvents']
      };
      return categoryMap[category] || category;
    }

    // Calculate total count from search results
  }, {
    key: "calculateTotalCount",
    value: function calculateTotalCount(data, category) {
      var totalCount = 0;
      if (category === 'all') {
        // Sum all category counts
        if (data.TopicsResult && data.TopicsResult.Topics && data.TopicsResult.Topics.Count !== undefined) {
          totalCount += data.TopicsResult.Topics.Count;
        }
        if (data.NewsResult && data.NewsResult.Count !== undefined) {
          totalCount += data.NewsResult.Count;
        }
        if (data.ToolsResult && data.ToolsResult.Count !== undefined) {
          totalCount += data.ToolsResult.Count;
        }
        if (data.CalendarEventsResult && data.CalendarEventsResult.Count !== undefined) {
          totalCount += data.CalendarEventsResult.Count;
        }
        if (data.CompaniesResult && data.CompaniesResult.Count !== undefined) {
          totalCount += data.CompaniesResult.Count;
        }
      } else {
        // Get count for specific category
        if (category === 'forum' && data.TopicsResult && data.TopicsResult.Topics && data.TopicsResult.Topics.Count !== undefined) {
          totalCount = data.TopicsResult.Topics.Count;
        } else if (category === 'news' && data.NewsResult && data.NewsResult.Count !== undefined) {
          totalCount = data.NewsResult.Count;
        } else if (category === 'tools' && data.ToolsResult && data.ToolsResult.Count !== undefined) {
          totalCount = data.ToolsResult.Count;
        } else if (category === 'economic-events' && data.CalendarEventsResult && data.CalendarEventsResult.Count !== undefined) {
          totalCount = data.CalendarEventsResult.Count;
        } else if (category === 'companies' && data.CompaniesResult && data.CompaniesResult.Count !== undefined) {
          totalCount = data.CompaniesResult.Count;
        }
      }
      return totalCount;
    }

    // Render results count header
  }, {
    key: "renderResultsCount",
    value: function renderResultsCount(totalCount, query, category) {
      var categoryDisplayName = this.getCategoryDisplayName(category);
      var escapedQuery = this.escapeHtml(query);
      var countText = totalCount + ' results for "' + escapedQuery + '" in ' + categoryDisplayName;
      return countText;
    }

    // Render all results
  }, {
    key: "renderResults",
    value: function renderResults(data) {
      var $container = $('#search-page-result');
      $container.empty();

      // Calculate and display results count at the top (above filter and results)
      var $countContainer = $('#search-results-count');
      if (this.currentQuery && this.currentQuery.trim().length > 0) {
        var totalCount = this.calculateTotalCount(data, this.currentCategory);
        $countContainer.text(this.renderResultsCount(totalCount, this.currentQuery, this.currentCategory));
      } else {
        $countContainer.empty();
      }
      if (this.currentCategory === 'all') {
        // Render all categories
        var hasResults = false;
        var self = this;

        // Helper function to create section header
        var createSectionHeader = function createSectionHeader(title) {
          return $('<h2 style="color: #0A1F41; font-size: 20px; margin-bottom: 16px; font-weight: 600;">' + title + '</h2>');
        };

        // Helper function to create "View More Results" link
        var createViewMoreLink = function createViewMoreLink(category) {
          return $('<div class="d-flex justify-content-end" style="margin-top: 16px;">' + '<a href="javascript:void(0);" class="view-more-results-link" data-category="' + category + '">' + '<span>View More Results</span>' + '<i class="mdi mdi-arrow-right"></i>' + '</a>' + '</div>');
        };

        // Forum section
        if (data.TopicsResult && data.TopicsResult.Topics && data.TopicsResult.Topics.Data && data.TopicsResult.Topics.Data.length > 0) {
          hasResults = true;
          var $forumSection = $('<div class="search-result-section" style="margin-bottom: 32px;"></div>');
          $forumSection.append(createSectionHeader('Forum'));
          var $forumItems = $('<div class="d-flex flex-column" style="gap: 16px;"></div>');
          data.TopicsResult.Topics.Data.forEach(function (topic) {
            $forumItems.append(this.renderForumTopic(topic));
          }.bind(this));
          $forumSection.append($forumItems);
          $forumSection.append(createViewMoreLink('forum'));
          $container.append($forumSection);
        }

        // News section
        if (data.NewsResult && data.NewsResult.Data && data.NewsResult.Data.length > 0) {
          hasResults = true;
          var $newsSection = $('<div class="search-result-section" style="margin-bottom: 32px;"></div>');
          $newsSection.append(createSectionHeader('News'));
          var $newsItems = $('<div class="d-flex flex-column" style="gap: 16px;"></div>');
          data.NewsResult.Data.forEach(function (news) {
            $newsItems.append(this.renderNewsItem(news));
          }.bind(this));
          $newsSection.append($newsItems);
          $newsSection.append(createViewMoreLink('news'));
          $container.append($newsSection);
        }

        // Tools section
        if (data.ToolsResult && data.ToolsResult.Data && data.ToolsResult.Data.length > 0) {
          hasResults = true;
          var $toolsSection = $('<div class="search-result-section" style="margin-bottom: 32px;"></div>');
          $toolsSection.append(createSectionHeader('Tools'));
          var $toolsItems = $('<div class="d-flex flex-column" style="gap: 16px;"></div>');
          data.ToolsResult.Data.forEach(function (tool) {
            $toolsItems.append(this.renderToolItem(tool));
          }.bind(this));
          $toolsSection.append($toolsItems);
          $toolsSection.append(createViewMoreLink('tools'));
          $container.append($toolsSection);
        }

        // Economic Events section
        if (data.CalendarEventsResult && data.CalendarEventsResult.Data && data.CalendarEventsResult.Data.length > 0) {
          hasResults = true;
          var $eventsSection = $('<div class="search-result-section" style="margin-bottom: 32px;"></div>');
          $eventsSection.append(createSectionHeader('Economic Events'));
          var $eventsItems = $('<div class="d-flex flex-column" style="gap: 16px;"></div>');
          data.CalendarEventsResult.Data.forEach(function (event) {
            $eventsItems.append(this.renderEconomicEvent(event));
          }.bind(this));
          $eventsSection.append($eventsItems);
          $eventsSection.append(createViewMoreLink('economic-events'));
          $container.append($eventsSection);
        }

        // Companies section (placeholder)
        if (data.CompaniesResult && data.CompaniesResult.Data && data.CompaniesResult.Data.length > 0) {
          hasResults = true;
          var $companiesSection = $('<div class="search-result-section" style="margin-bottom: 32px;"></div>');
          $companiesSection.append(createSectionHeader('Companies'));
          var $companiesItems = $('<div class="d-flex flex-column" style="gap: 16px;"></div>');
          data.CompaniesResult.Data.forEach(function (company) {
            $companiesItems.append(this.renderCompanyItem(company));
          }.bind(this));
          $companiesSection.append($companiesItems);
          $companiesSection.append(createViewMoreLink('companies'));
          $container.append($companiesSection);
        }

        // Note: Click handlers for "View More Results" links are attached via event delegation in document.ready

        if (!hasResults) {
          $container.html('<div style="padding: 32px; text-align: center; color: #666;">No results found</div>');
        }
      } else {
        // Render only selected category
        var $items = $('<div class="d-flex flex-column" style="gap: 16px;"></div>');
        var hasResults = false;
        if (this.currentCategory === 'forum' && data.TopicsResult && data.TopicsResult.Topics && data.TopicsResult.Topics.Data) {
          data.TopicsResult.Topics.Data.forEach(function (topic) {
            $items.append(this.renderForumTopic(topic));
            hasResults = true;
          }.bind(this));
        } else if (this.currentCategory === 'news' && data.NewsResult && data.NewsResult.Data) {
          data.NewsResult.Data.forEach(function (news) {
            $items.append(this.renderNewsItem(news));
            hasResults = true;
          }.bind(this));
        } else if (this.currentCategory === 'tools' && data.ToolsResult && data.ToolsResult.Data) {
          data.ToolsResult.Data.forEach(function (tool) {
            $items.append(this.renderToolItem(tool));
            hasResults = true;
          }.bind(this));
        } else if (this.currentCategory === 'economic-events' && data.CalendarEventsResult && data.CalendarEventsResult.Data) {
          data.CalendarEventsResult.Data.forEach(function (event) {
            $items.append(this.renderEconomicEvent(event));
            hasResults = true;
          }.bind(this));
        } else if (this.currentCategory === 'companies' && data.CompaniesResult && data.CompaniesResult.Data) {
          data.CompaniesResult.Data.forEach(function (company) {
            $items.append(this.renderCompanyItem(company));
            hasResults = true;
          }.bind(this));
        }
        if (hasResults) {
          $container.append($items);
        } else {
          $container.html('<div style="padding: 32px; text-align: center; color: #666;">No results found</div>');
        }
      }
    }
  }, {
    key: "loadResults",
    value: function loadResults() {
      // Only call API if query is not empty
      if (!this.currentQuery || this.currentQuery.trim().length === 0) {
        // Clear results section and count if query is empty
        $('#search-page-result').empty();
        $('#search-results-count').empty();
        $('#search-pagination-container').hide().empty();
        return;
      }

      // Show skeletons while loading
      this.showSkeletons();

      // Hide pagination container initially
      $('#search-pagination-container').hide().empty();
      if (this.currentCategory === 'all') {
        // For "all" category, use direct AJAX call with pageSize=2
        var self = this;
        var ajaxData = {
          query: this.currentQuery,
          category: 'all',
          sortDir: this.currentSortDir,
          page: 1,
          pageSize: 2
        };
        $.ajax({
          url: searchResultUrl,
          type: 'GET',
          data: ajaxData,
          cache: false,
          success: function success(response) {
            if (response.success && response.data) {
              self.renderResults(response.data);
            } else {
              $('#search-page-result').html('<div style="padding: 32px; text-align: center; color: #666;">Error loading results</div>');
              $('#search-results-count').empty();
            }
          },
          error: function error(xhr, status, _error) {
            console.error('Error loading search results:', _error);
            $('#search-page-result').html('<div style="padding: 32px; text-align: center; color: #666;">Error loading results</div>');
            $('#search-results-count').empty();
          }
        });
      } else {
        // For specific category, use pagination library
        this.initPagination();
      }
    }
  }, {
    key: "initPagination",
    value: function initPagination() {
      var selector = '#search-pagination-container';
      var self = this;

      // Clear any existing pagination
      $(selector).empty();

      // Get category-specific locator and total locator
      var locator = '';
      var totalLocator = function totalLocator(response) {
        if (!response) return 0;
        // The response structure is { success: true, data: {...} }
        if (!response.data) return 0;
        if (self.currentCategory === 'forum' && response.data.TopicsResult && response.data.TopicsResult.Topics) {
          return response.data.TopicsResult.Topics.Count || 0;
        } else if (self.currentCategory === 'news' && response.data.NewsResult) {
          return response.data.NewsResult.Count || 0;
        } else if (self.currentCategory === 'tools' && response.data.ToolsResult) {
          return response.data.ToolsResult.Count || 0;
        } else if (self.currentCategory === 'economic-events' && response.data.CalendarEventsResult) {
          return response.data.CalendarEventsResult.Count || 0;
        } else if (self.currentCategory === 'companies' && response.data.CompaniesResult) {
          return response.data.CompaniesResult.Count || 0;
        }
        return 0;
      };
      if (this.currentCategory === 'forum') {
        locator = 'data.TopicsResult.Topics.Data';
      } else if (this.currentCategory === 'news') {
        locator = 'data.NewsResult.Data';
      } else if (this.currentCategory === 'tools') {
        locator = 'data.ToolsResult.Data';
      } else if (this.currentCategory === 'economic-events') {
        locator = 'data.CalendarEventsResult.Data';
      } else if (this.currentCategory === 'companies') {
        locator = 'data.CompaniesResult.Data';
      }
      $(selector).pagination({
        dataSource: searchResultUrl,
        locator: locator,
        pageSize: 25,
        pageRange: 1,
        triggerPagingOnInit: self.currentPage == 1,
        className: 'light-pagination',
        ajax: {
          beforeSend: function beforeSend(jqXHR, settings) {
            // Add query parameters
            if (self.currentQuery) {
              settings.url += '&query=' + encodeURIComponent(self.currentQuery);
            }
            if (self.currentCategory) {
              settings.url += '&category=' + encodeURIComponent(self.currentCategory);
            }
            if (self.currentSortDir) {
              settings.url += '&sortDir=' + encodeURIComponent(self.currentSortDir);
            }
            // Add filter parameters
            if (self.selectedForumCategoryIds.length > 0) {
              settings.url += '&forumCategoryIds=' + encodeURIComponent(self.selectedForumCategoryIds.join(','));
            }
            if (self.selectedCompanyCategoryIds.length > 0) {
              settings.url += '&companyCategoryIds=' + encodeURIComponent(self.selectedCompanyCategoryIds.join(','));
            }
            if (self.selectedEventCountries.length > 0) {
              settings.url += '&eventCountries=' + encodeURIComponent(self.selectedEventCountries.join(','));
            }
            return true;
          }
        },
        totalNumberLocator: totalLocator,
        callback: function callback(data, pagination) {
          // Update current page
          self.currentPage = pagination.pageNumber;
          self.updateUrl();

          // The pagination library passes the data array directly (from the locator)
          // Render the results
          self.renderResultsFromPagination(data, pagination);
        }
      });

      // Show pagination container
      $(selector).show();

      // Go to the current page from URL
      if (this.currentPage > 1) {
        $(selector).pagination(this.currentPage);
      }
    }
  }, {
    key: "renderResultsFromPagination",
    value: function renderResultsFromPagination(data, pagination) {
      // The pagination library passes the data array directly
      // We need to render it based on the current category
      var $container = $('#search-page-result');
      $container.empty();

      // Calculate and display results count
      var $countContainer = $('#search-results-count');
      if (this.currentQuery && this.currentQuery.trim().length > 0) {
        var totalCount = pagination.totalNumber || 0;
        $countContainer.text(this.renderResultsCount(totalCount, this.currentQuery, this.currentCategory));
      } else {
        $countContainer.empty();
      }

      // Render items based on category
      var $items = $('<div class="d-flex flex-column" style="gap: 16px;"></div>');
      var hasResults = false;
      if (data && data.length > 0) {
        hasResults = true;
        var self = this;
        if (this.currentCategory === 'forum') {
          data.forEach(function (topic) {
            $items.append(self.renderForumTopic(topic));
          });
        } else if (this.currentCategory === 'news') {
          data.forEach(function (news) {
            $items.append(self.renderNewsItem(news));
          });
        } else if (this.currentCategory === 'tools') {
          data.forEach(function (tool) {
            $items.append(self.renderToolItem(tool));
          });
        } else if (this.currentCategory === 'economic-events') {
          data.forEach(function (event) {
            $items.append(self.renderEconomicEvent(event));
          });
        } else if (this.currentCategory === 'companies') {
          data.forEach(function (company) {
            $items.append(self.renderCompanyItem(company));
          });
        }
      }
      if (hasResults) {
        $container.append($items);
      } else {
        $container.html('<div style="padding: 32px; text-align: center; color: #666;">No results found</div>');
      }
    }
  }, {
    key: "handleSearchButtonClick",
    value: function handleSearchButtonClick() {
      this.currentQuery = $('#search-query-input').val().trim();
      this.currentPage = 1; // Reset to page 1 on new search
      this.updateUrl();
      this.loadResults();
    }
  }, {
    key: "loadFilterOptions",
    value: function loadFilterOptions() {
      var self = this;
      if (this.filterOptions) {
        return Promise.resolve(this.filterOptions);
      }
      return $.ajax({
        url: filterOptionsUrl,
        type: 'GET',
        cache: false
      }).then(function (response) {
        if (response.success && response.data) {
          self.filterOptions = response.data;
          return response.data;
        }
        return null;
      });
    }
  }, {
    key: "updateFilterPanel",
    value: function updateFilterPanel() {
      // Hide all filter groups first
      $('#sort-by-group').hide();
      $('#sort-by-tools-group').hide();
      $('#additional-filters-forum').hide();
      $('#additional-filters-companies').hide();
      $('#additional-filters-calendar').hide();
      if (this.currentCategory === 'all') {
        // Show only sort by options
        $('#sort-by-group').show();
      } else if (this.currentCategory === 'forum') {
        $('#sort-by-group').show();
        this.renderForumFilters();
      } else if (this.currentCategory === 'news') {
        $('#sort-by-group').show();
        // No additional filters for news
      } else if (this.currentCategory === 'tools') {
        $('#sort-by-tools-group').show();
        // Change sort options to ascending/descending
      } else if (this.currentCategory === 'companies') {
        // No sort by options for companies
        this.renderCompanyFilters();
      } else if (this.currentCategory === 'economic-events') {
        $('#sort-by-group').show();
        this.renderCountryFilters();
      }
    }
  }, {
    key: "renderForumFilters",
    value: function renderForumFilters() {
      if (!this.filterOptions || !this.filterOptions.ForumCategories || this.filterOptions.ForumCategories.length === 0) return;
      var $container = $('#forum-categories-list');
      $container.empty();
      var self = this;
      var categories = this.filterOptions.ForumCategories;

      // Add "All" checkbox
      var allChecked = this.selectedForumCategoryIds.length === 0 || this.selectedForumCategoryIds.length === categories.length;
      var $allCheckbox = $('<div class="filter-checkbox form-check">' + '<input class="form-check-input" type="checkbox" id="forum-category-all" ' + (allChecked ? 'checked' : '') + ' />' + '<label class="form-check-label" for="forum-category-all">All</label>' + '</div>');
      $container.append($allCheckbox);

      // Add category checkboxes
      categories.forEach(function (category) {
        var categoryId = parseInt(category.Id);
        var isChecked = self.selectedForumCategoryIds.indexOf(categoryId) !== -1;
        var $checkbox = $('<div class="filter-checkbox form-check">' + '<input class="forum-category-checkbox form-check-input" type="checkbox" id="forum-category-' + category.Id + '" value="' + category.Id + '" ' + (isChecked ? 'checked' : '') + ' />' + '<label class="form-check-label" for="forum-category-' + category.Id + '">' + self.escapeHtml(category.Name) + '</label>' + '</div>');
        $container.append($checkbox);
      });
      $('#additional-filters-forum').show();
    }
  }, {
    key: "renderCompanyFilters",
    value: function renderCompanyFilters() {
      if (!this.filterOptions || !this.filterOptions.CompanyCategories) return;
      var $container = $('#company-categories-list');
      $container.empty();
      var self = this;
      var categories = this.filterOptions.CompanyCategories;

      // Add "All" checkbox
      var allChecked = this.selectedCompanyCategoryIds.length === 0 || this.selectedCompanyCategoryIds.length === categories.length;
      var $allCheckbox = $('<div class="filter-checkbox form-check">' + '<input class="form-check-input" type="checkbox" id="company-category-all" ' + (allChecked ? 'checked' : '') + ' />' + '<label class="form-check-label" for="company-category-all">All</label>' + '</div>');
      $container.append($allCheckbox);

      // Add category checkboxes
      categories.forEach(function (category) {
        var categoryId = parseInt(category.Id);
        var isChecked = self.selectedCompanyCategoryIds.indexOf(categoryId) !== -1;
        var $checkbox = $('<div class="filter-checkbox form-check">' + '<input class="company-category-checkbox form-check-input" type="checkbox" id="company-category-' + category.Id + '" value="' + category.Id + '" ' + (isChecked ? 'checked' : '') + ' />' + '<label class="form-check-label" for="company-category-' + category.Id + '">' + self.escapeHtml(category.Name) + '</label>' + '</div>');
        $container.append($checkbox);
      });
      $('#additional-filters-companies').show();
    }
  }, {
    key: "renderCountryFilters",
    value: function renderCountryFilters() {
      if (!this.filterOptions || !this.filterOptions.Countries) return;
      var $container = $('#countries-list');
      $container.empty();
      var self = this;
      var countries = this.filterOptions.Countries;

      // Add "All" checkbox
      var allChecked = this.selectedEventCountries.length === 0 || this.selectedEventCountries.length === countries.length;
      var $allCheckbox = $('<div class="filter-checkbox form-check">' + '<input class="form-check-input" type="checkbox" id="country-all" ' + (allChecked ? 'checked' : '') + ' />' + '<label class="form-check-label" for="country-all">All</label>' + '</div>');
      $container.append($allCheckbox);

      // Add country checkboxes
      countries.forEach(function (country) {
        var countryCode = country.Id;
        var isChecked = self.selectedEventCountries.indexOf(countryCode) !== -1;
        var $checkbox = $('<div class="filter-checkbox form-check">' + '<div class="country-checkbox-item">' + '<input class="country-checkbox form-check-input" type="checkbox" id="country-' + countryCode + '" value="' + countryCode + '" ' + (isChecked ? 'checked' : '') + ' />' + '<label class="form-check-label" for="country-' + countryCode + '">' + '<i class="flag flag-' + countryCode.toLowerCase() + '"></i>' + self.escapeHtml(country.Name) + '</label>' + '</div>' + '</div>');
        $container.append($checkbox);
      });
      $('#additional-filters-calendar').show();
    }
  }, {
    key: "handleCategoryChange",
    value: function handleCategoryChange(category) {
      this.currentCategory = category;
      this.currentPage = 1; // Reset to page 1 on category change
      $('.search-category-btn').removeClass('active');
      $('.search-category-btn[data-category="' + category + '"]').addClass('active');
      this.updateFilterPanel();
      this.updateUrl();
      // Only load results if query is not empty
      if (this.currentQuery && this.currentQuery.trim().length > 0) {
        this.loadResults();
      } else {
        // Clear results section and count if query is empty
        $('#search-page-result').empty();
        $('#search-results-count').empty();
        $('#search-pagination-container').hide().empty();
      }
    }
  }, {
    key: "handleSortChange",
    value: function handleSortChange(sortDir) {
      this.currentSortDir = sortDir;
      this.currentPage = 1; // Reset to page 1 on sort change
      this.updateUrl();
      // Only load results if query is not empty
      if (this.currentQuery && this.currentQuery.trim().length > 0) {
        this.loadResults();
      } else {
        // Clear results section and count if query is empty
        $('#search-page-result').empty();
        $('#search-results-count').empty();
        $('#search-pagination-container').hide().empty();
      }
    }
  }]);
}();
var _default = exports["default"] = SearchPage;

},{}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Site = /*#__PURE__*/function () {
  function Site() {
    _classCallCheck(this, Site);
    //Close the side Nav if resized to large screen
    $(window).on('resize', function () {
      if (window.innerWidth > 949 && $('#customSideNavOverlay').length) {
        window.Site.closeSideNav();
      }
    });
    window.AjaxLoading = function () {
      $.LoadingOverlay("show");
    };
    window.AjaxComplete = function () {
      $.LoadingOverlay("hide");
    };
    window.Profile = function () {
      $('#profile-dropdown').show();
    };
    $(function () {
      // SideNav Button Initialization
      $(".button-collapse").sideNav({});
      // SideNav Scrollbar Initialization
      var sideNavScrollbar = document.querySelector('.custom-scrollbar');
      //  Ps.initialize(sideNavScrollbar);

      //$('.liveChatNow').on("click", function (e) {
      //    var random = Math.floor(Math.random() * 1001);
      //    var random2 = Math.floor(Math.random() * 1001);
      //    window.open("http://supportfx.kayako.com/visitor/index.php?/LiveChat/Chat/Request/_sessionID=" + random + "/_proactive=0/_filterDepartmentID=15%2C9%2C86%2C21%2C122%2C87%2C57%2C123%2C85%2C118/_randomNumber=" + random2 + "/_fullName=/_email=/_promptType=chat", "yyyyy", "width=480,height=580,resizable=yes,toolbar=no,menubar=no,location=no,status=no");
      //    return false;
      //});

      $("#scroll-top").click(function () {
        $("html, body").animate({
          scrollTop: 0
        }, "medium");
        return false;
      });
      $(".nav-top").click(function () {
        $("html, body").animate({
          scrollTop: 0
        }, "medium");
        return false;
      });
      $(document).on('click', '.enableToggle', function () {
        var _this2 = this;
        var url;
        var callback;
        if ($(this).data('targeturl') != undefined) {
          url = $(this).data('targeturl');
        } else {
          url = $('#enableUrl').val();
        }
        if ($(this).data('callback') != undefined) {
          callback = $(this).data('callback');
        }
        $.ajax({
          type: "POST",
          url: url,
          data: {
            id: $(this).data('id'),
            state: this.checked,
            name: this.name
          },
          success: function success(result) {
            if (callback !== undefined) {
              window[callback](_this2);
            }
          }
        });
      });
      $(document).on('click', '.tableHide', function () {
        if ($(".hideTableRow").is(":hidden")) {
          $(".hideTableRow").slideDown("slow");
        } else {
          $(".hideTableRow").hide();
        }
      });
      $(document).on('click', '.toggle-child-ul', function () {
        $(this).children('ul').toggle();
      });
    });

    //$('.mdb-select').material_select('destroy');

    //$('.mdb-select').material_select();

    // set all heading's id
    var headings = $(":header:not([id])");
    for (var i = 0; i < headings.length; i++) headings[i].id = "runtime-added-id-" + i;
  }
  return _createClass(Site, [{
    key: "closeSideNav",
    value: function closeSideNav() {
      $("#customSideNavOverlay").trigger('click');
    }
  }, {
    key: "InitAuthorPopovers",
    value: function InitAuthorPopovers() {
      var selector = '[data-toggle="popover-author"]';
      /*
      if (window.matchMedia("(max-width: 767px)").matches) {
          selector = 'a[data-toggle="popover-author"]';
      }
      */

      $(selector).popover({
        content: function content() {
          var targetId = $(this).data('target-id');
          return $(targetId).html();
        },
        html: true,
        trigger: "manual",
        placement: 'auto',
        container: 'body'
      }).on("mouseenter", function () {
        var _this = this;
        $(this).popover("show");
        $(".popover").on("mouseleave", function () {
          $(_this).popover('hide');
        });
      }).on("mouseleave", function () {
        var _this = this;
        setTimeout(function () {
          if (!$(".popover:hover").length) {
            $(_this).popover("hide");
          }
        }, 100);
      });
    }
  }, {
    key: "UpdateLastUpdatedDate",
    value: function UpdateLastUpdatedDate() {
      $('span[data-everydayupdate="True"]').each(function (i, element) {
        var date = new Date();
        var dateStr = '';
        if ($(element).data('display') == 'short') {
          dateStr = date.toLocaleString(window.CURRENT_CULTURE, {
            day: undefined,
            month: 'long',
            year: 'numeric'
          });
        } else {
          dateStr = date.toLocaleString(window.CURRENT_CULTURE, {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
          });
        }
        $(element).text(dateStr);
      });
    }
  }]);
}();
var _default = exports["default"] = Site;

},{}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _TencentCaptcha = _interopRequireDefault(require("./TencentCaptcha.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Support = /*#__PURE__*/function () {
  function Support(datepicker) {
    _classCallCheck(this, Support);
    this.datepicker = datepicker;
    $('.form-control').on('focus', function () {
      $(this).removeClass("form-control-danger").closest(".form-group").removeClass("has-danger");
      $(this).parent().find('.form-control-feedback').hide();
    });
  }
  return _createClass(Support, [{
    key: "LoadRecaptcha",
    value: function LoadRecaptcha(callback) {
      var _this = this;
      if (!$('#recptcha-script').length) {
        var script = document.createElement('script');
        script.id = "recptcha-script";
        script.onload = function () {
          if (callback != undefined) {
            callback(_this);
          }
        };
        script.src = "https://www.recaptcha.net/recaptcha/api.js?render=" + window.CAPTCHA_KEY;
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        if (callback != undefined) {
          callback(this);
        }
      }
    }
  }, {
    key: "LoadTimezone",
    value: function LoadTimezone() {
      var today = new Date();
      var _short = today.toLocaleDateString(undefined);
      var full = today.toLocaleDateString(undefined, {
        timeZoneName: 'long'
      });

      // Trying to remove date from the string in a locale-agnostic way
      var shortIndex = full.indexOf(_short);
      if (shortIndex >= 0) {
        var trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + _short.length);

        // by this time `trimmed` should be the timezone's name with some punctuation -
        // trim it from both sides
        return trimmed.replace(/^[\s,.\-:;]+|[\s,.\-:;]+$/g, '');
      } else {
        // in some magic case when short representation of date is not present in the long one, just return the long one as a fallback, since it should contain the timezone's name
        return full;
      }
    }
  }, {
    key: "SendContactRequest",
    value: function SendContactRequest(business) {
      var prefix = "";
      if (business == true) {
        prefix = '#business-contact-container ';
      }
      var send = true;
      if ($(prefix + '#ContactEmail').val() === "") {
        $(prefix + '#ContactEmail').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
        send = false;
      }
      if ($(prefix + '#ContactName').val() === "") {
        $(prefix + '#ContactName').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
        send = false;
      }
      if ($(prefix + '#ContactSubject').val() === "") {
        $(prefix + '#ContactSubject').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
        send = false;
      }
      if ($(prefix + '#ContactMessage').val() === "") {
        $(prefix + '#ContactMessage').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
        send = false;
      }
      if (send) {
        if (window.tencentCaptchaAppId) {
          var tc = new _TencentCaptcha["default"]();
          tc.Show(function (ticket, randstr) {
            $(prefix + '#tencent-contact-ticket').val(ticket);
            $(prefix + '#tencent-contact-randstr').val(randstr);
            $(prefix + '#contact-progress').removeClass('hide');
            $(prefix + '#ContactEmail').closest("form").submit();
          });
        } else {
          // Load reCAPTCHA script before attempting to use it
          this.LoadRecaptcha(function () {
            if (typeof grecaptcha === 'undefined') {
              console.error('reCAPTCHA library failed to load');
              $(prefix + '#contact-progress').addClass('hide');
              return;
            }
            grecaptcha.ready(function () {
              grecaptcha.execute(window.captchaKey, {
                action: 'SubmitContact'
              }).then(function (token) {
                // Set `token` in a hidden form input.
                $(prefix + "#captcha").val(token);
                //And finally submit the form by firing
                //off the HTTP POST over the wire at this
                //exact moment in time here.
                $(prefix + '#contact-progress').removeClass('hide');
                $(prefix + '#ContactEmail').closest("form").submit();
              })["catch"](function (error) {
                console.error('reCAPTCHA error:', error);
                $(prefix + '#contact-progress').addClass('hide');
              });
            });
          });
        }
      }
      return false;
    }
  }, {
    key: "SubmitFoundAnError",
    value: function SubmitFoundAnError() {
      $('#FoundAnErrorDetail').parent().removeClass('has-danger');
      if ($('#FoundAnErrorDetail').val() === "") {
        $('#FoundAnErrorDetail').parent().addClass('has-danger');
      } else {
        $('#submit-error-progress').show();
        var postData = {};
        postData.FoundAnErrorDetail = $('#FoundAnErrorDetail').val();
        if (typeof grecaptcha === 'undefined') {
          console.error('reCAPTCHA library not loaded. Please ensure LoadRecaptcha was called first.');
          $('#submit-error-progress').hide();
          return;
        }
        grecaptcha.ready(function () {
          grecaptcha.execute(window.captchaKey, {
            action: 'SubmitFoundAnError'
          }).then(function (token) {
            // Set `token` in a hidden form input.
            postData.Captcha = token;
            $.ajax({
              url: window.foundAnErrorUrl,
              type: 'POST',
              data: postData,
              cache: false,
              success: function success(result) {
                if (result.isError !== true) {
                  $('#submit-error-success-message').show();
                  $('#submit-error-progress').hide();
                  $('#FoundAnErrorInputDiv').hide();
                  setTimeout(function () {
                    $('#dialog-submit-error').modal('hide');
                  }, 2000);
                } else {
                  alert(result.message);
                }
              },
              error: function error(result) {
                $('#submit-error-progress').hide();
                alert("there was an error");
              }
            });
          })["catch"](function (error) {
            console.error('reCAPTCHA error:', error);
            $('#submit-error-progress').hide();
          });
        });
      }
    }
  }, {
    key: "CancelFoundAnError",
    value: function CancelFoundAnError() {
      $('#dialog-submit-error').modal('hide');
      $('#FoundAnErrorDetail').val('');
    }
  }, {
    key: "OpenFoundAnError",
    value: function OpenFoundAnError() {
      this.LoadRecaptcha();
      $('#submit-error-progress').hide();
      $('#submit-error-success-message').hide();
      $('#FoundAnErrorDetail').parent().removeClass('has-danger');
      $('#FoundAnErrorDetail').val('');
      $('#submit-error-progress').hide();
      $('#FoundAnErrorInputDiv').show();
      $('#dialog-submit-error').modal('show');
    }
  }, {
    key: "SendNfaRequest",
    value: function SendNfaRequest() {
      var send = true;
      var dob = $('#nfa-date-of-birth').val();
      if (dob === "") {
        $('#nfa-date-of-birth').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
        send = false;
      } else {
        if (!this.datepicker.IsDate(dob)) {
          $('#nfa-date-of-birth').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
          send = false;
        }
      }
      if ($('#nfa-annual-income').val() === "") {
        $('#nfa-annual-income').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
        send = false;
      }
      if ($('#nfa-employment-status').val() === "") {
        $('#nfa-employment-status').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
        send = false;
      }
      if ($('#nfa-net-worth').val() === "") {
        $('#nfa-net-worth').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
        send = false;
      }
      if ($('#nfa-occupation').val() === "") {
        $('#nfa-occupation').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
        send = false;
      }
      if ($('#nfa-trading-experience').val() === "") {
        $('#nfa-trading-experience').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
        send = false;
      }
      if ($('#Nfa_Address').val() === "") {
        $('#Nfa_Address').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
        send = false;
      }
      if (send) {
        grecaptcha.ready(function () {
          grecaptcha.execute(window.captchaKey, {
            action: 'SubmitNfaRequest'
          }).then(function (token) {
            // Set `token` in a hidden form input.
            $("#nfa-captcha").val(token);

            //And finally submit the form by firing
            //off the HTTP POST over the wire at this
            //exact moment in time here.
            $('#nfa-progress').removeClass('hide');
            $('#nfa-date-of-birth').closest("form").submit();
          });
        });
      }
      return false;
    }
  }, {
    key: "SendBetterRatesRequest",
    value: function SendBetterRatesRequest() {
      var send = true;
      if ($('#BetterRatesEmail').val() === "") {
        $('#BetterRatesEmail').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
        send = false;
      }
      if ($('#BetterRatesName').val() === "") {
        $('#BetterRatesName').addClass("form-control-danger").closest(".form-group").addClass("has-danger");
        send = false;
      }
      if (send) {
        if (window.tencentCaptchaAppId) {
          var tc = new _TencentCaptcha["default"]();
          tc.Show(function (ticket, randstr) {
            $('#tencent-betterrates-ticket').val(ticket);
            $('#tencent-betterrates-randstr').val(randstr);
            $('#contact-progress').removeClass('hide');
            $('#BetterRatesEmail').closest("form").submit();
          });
        } else {
          this.LoadRecaptcha(function () {
            if (typeof grecaptcha === 'undefined') {
              console.error('reCAPTCHA library failed to load');
              $('#contact-progress').removeClass('hide');
              return;
            }
            grecaptcha.ready(function () {
              grecaptcha.execute(window.captchaKey, {
                action: 'SubmitBetterRate'
              }).then(function (token) {
                // Set `token` in a hidden form input.
                $("#captcha").val(token);
                //And finally submit the form by firing
                //off the HTTP POST over the wire at this
                //exact moment in time here.
                $('#contact-progress').removeClass('hide');
                $('#BetterRatesEmail').closest("form").submit();
              })["catch"](function (error) {
                console.error('reCAPTCHA error:', error);
              });
            });
          });
        }
      }
      return false;
    }
  }, {
    key: "PopCallBack",
    value: function PopCallBack() {
      $('#model-callback-request').modal('show');
      this.LoadRecaptcha();
      $('#Timezone-Callback option[value="' + Intl.DateTimeFormat().resolvedOptions().timeZone + '"]').prop('selected', true);
    }
  }, {
    key: "RequestCallback",
    value: function RequestCallback() {
      //$('#FullName-Callback').removeClass('frn-override-danger');
      //$('#Phone-Callback').removeClass('frn-override-danger');

      //if ($('#FullName-Callback').val() === "" || $('#Phone-Callback').val() === "") {

      //    if ($('#FullName-Callback').val() === "") {
      //        $('#FullName-Callback').addClass('frn-override-danger');
      //    }

      //    if ($('#Phone-Callback').val() === "") {
      //        $('#Phone-Callback').addClass('frn-override-danger');
      //    }

      //} else {
      $('#callback-request-progress').removeClass('hide');
      var postData = {};
      postData.DisplayName = $('#FullName-Callback').val();
      postData.Email = $('#Email-Address-Callback').val();
      postData.Phone = $('#Phone-Callback').val();
      postData.Timezone = $('#Timezone-Callback').val();
      postData.Message = $('#Message-Callback').val();
      postData.ClientId = $('#CallbackUserId').val();
      postData.LogType = $('#LogType-Callback').val();
      grecaptcha.ready(function () {
        grecaptcha.execute(window.captchaKey, {
          action: 'SubmitCallbackRequest'
        }).then(function (token) {
          // Set `token` in a hidden form input.
          postData.Captcha = token;
          $.ajax({
            url: window.requestCallbackUrl,
            type: 'POST',
            data: postData,
            cache: false,
            success: function success(result) {
              if (result.IsError) {
                $('#CallbackPayload').html(result.pageView);
                $('#callback-request-progress').addClass('hide');
              } else {
                window.location.reload();
              }
            },
            error: function error(result) {
              $('#callback-request-progress').addClass('hide');
              alert("there was an error");
            }
          });
          ////And finally submit the form by firing
          ////off the HTTP POST over the wire at this
          ////exact moment in time here.
          //$('#contact-progress').removeClass('hide');
          //$('#ContactEmail').closest("form").submit();
        });
      });
      //}
    }
  }, {
    key: "PopEmailRequest",
    value: function PopEmailRequest() {
      $('#model-email-us').modal('show');
    }
  }, {
    key: "SendEmail",
    value: function SendEmail() {
      $('#email-us-progress').removeClass('hide');
      var postData = {};
      postData.DisplayName = $('#FullName-Email').val();
      postData.Email = $('#Email-Address-Email').val();
      postData.CountryOfResidenceId = $('#CountryOfResidenceId-Email').val();
      postData.CountryOfResidenceName = $('#CountryOfResidenceId-Email').find(":selected").text();
      postData.Message = $('#Message-Email').val();
      postData.ClientId = $('#EmailUserId').val();
      postData.LogType = $('#LogType-Email').val();
      grecaptcha.ready(function () {
        grecaptcha.execute(window.captchaKey, {
          action: 'SubmitEmail'
        }).then(function (token) {
          // Set `token` in a hidden form input.
          postData.Captcha = token;
          $.ajax({
            url: window.emailUsUrl,
            type: 'POST',
            data: postData,
            cache: false,
            success: function success(result) {
              if (result.IsError) {
                $('#EmailUsPayload').html(result.pageView);
                $('#email-us-progress').addClass('hide');
              } else {
                window.location.reload();
              }
            },
            error: function error(result) {
              $('#email-us-progress').addClass('hide');
              alert("there was an error");
            }
          });
        });
      });
    }
  }, {
    key: "PopLiveChat",
    value: function PopLiveChat() {
      if (window.kayako.visibility() === 'minimized') {
        window.kayako.maximize();
      } else {
        window.kayako.minimize();
      }
    }
  }, {
    key: "OpenAffiliateDialog",
    value: function OpenAffiliateDialog() {
      var clientId = $("#client-profile-id").val();
      var verified = $("#client-verified").val();
      if (clientId == 0) {
        this.SignupFromAffiliateDialog();
      } else {
        $("#affiliate-content").html(window.affiliateAuthenticatedLink);
        var affiliateLink = window.location.href.split('#')[0] + "#aid_" + clientId;
        $("#affiliate-link").html(affiliateLink);
        if (verified == 0) {
          $("#affiliate-content").append(window.affiliateNeedEmailVerify);
        }
        $("#dialog-affiliate").modal("show");
      }
    }
  }, {
    key: "SignupFromAffiliateDialog",
    value: function SignupFromAffiliateDialog() {
      $("#dialog-affiliate").modal("hide");
      window.Access.LoginWithPurpose('OpenAffiliateDialogAfterSignup', '', 'signup', '', '');
    }
  }, {
    key: "CopyAffiliateLink",
    value: function CopyAffiliateLink() {
      navigator.clipboard.writeText($("#affiliate-link").text()).then(function () {
        window.toastr.success("Copied!");
      });
    }
  }, {
    key: "CopyShareLink",
    value: function CopyShareLink() {
      navigator.clipboard.writeText(window.location.href).then(function () {
        window.toastr.success("Copied! " + window.location.href);
      });
    }
  }, {
    key: "AuthenticatedPage",
    value: function AuthenticatedPage(page) {
      var clientId = $("#client-profile-id").val();
      if (clientId == 0) {
        window.Access.LoginForDestination(page);
      } else {
        document.location.href = page;
      }
    }
  }, {
    key: "OpenFeedbackDialog",
    value: function OpenFeedbackDialog() {
      this.LoadRecaptcha();
      if (!window.cookieStateValues || window.cookieStateValues.logged != '1') $("#feedback-submit-dialog [name=feedbackEmail]").attr('placeholder', 'Email');else $("#feedback-submit-dialog [name=feedbackEmail]").attr('placeholder', 'Email (optional)');
      $("#feedback-submit-dialog [name=feedbackEmail]").val('');
      $("#feedback-submit-dialog [name=feedbackText]").val('');
      $("#feedback-submit-progress").hide();
      $("#feedback-submit-dialog").modal('show');
    }
  }, {
    key: "SubmitBugsAndFeedback",
    value: function SubmitBugsAndFeedback() {
      $("#feedback-submit-dialog [name=feedbackText]").parent().removeClass('has-danger');
      $("#feedback-submit-dialog [name=feedbackEmail]").parent().removeClass('has-danger');
      if ((!window.cookieStateValues || window.cookieStateValues.logged != '1') && $("#feedback-submit-dialog [name=feedbackEmail]").val() == '') {
        $("#feedback-submit-dialog [name=feedbackEmail]").parent().addClass('has-danger');
      } else if ($("#feedback-submit-dialog [name=feedbackText]").val() == '') {
        $("#feedback-submit-dialog [name=feedbackText]").parent().addClass('has-danger');
      } else {
        var postData = {};
        postData.Message = $("#feedback-submit-dialog [name=feedbackText]").val();
        postData.Email = $("#feedback-submit-dialog [name=feedbackEmail]").val();
        postData.PageUrl = window.location.href;
        $("#feedback-submit-progress").show();
        if (window.bypassReCaptcha) {
          $.ajax({
            url: window.bugsAndFeedbackUrl,
            type: 'POST',
            data: postData,
            cache: false,
            success: function success(result) {
              if (result.isError !== true) {
                toastr.success("Thanks for your feedback");
                $('#feedback-submit-dialog').modal('hide');
              } else {
                toastr.error(result.message);
              }
            },
            error: function error(result) {
              toastr.error(result.message);
            }
          });
        } else {
          grecaptcha.ready(function () {
            grecaptcha.execute(window.captchaKey, {
              action: 'SubmitFeedback'
            }).then(function (token) {
              // Set `token` in a hidden form input.
              postData.Captcha = token;
              $.ajax({
                url: window.bugsAndFeedbackUrl,
                type: 'POST',
                data: postData,
                cache: false,
                success: function success(result) {
                  if (result.isError !== true) {
                    toastr.success("Thanks for your feedback");
                    $('#feedback-submit-dialog').modal('hide');
                  } else {
                    toastr.error(result.message);
                  }
                },
                error: function error(result) {
                  toastr.error(result.message);
                }
              });
            });
          });
        }
      }
    }
  }]);
}();
var _default = exports["default"] = Support;

},{"./TencentCaptcha.js":15}],14:[function(require,module,exports){
'use strict';

/*
 * Config Options:
 *  localStoreName - specify local storage name to preserve state when user navigates from page
 *  postRenderCallback - Callback to call when content of ajax tab has been rendered to page
 *  compactOnResize - specify if tabs are to collapse to select list drop down on small screen
 *  preLoadCallback - callback executed before Ajax page is loaded, or after tab is clicked on non Ajax loading tabs
 *  haltInitLoad - prevent Ajax load on first initialisation of tabs
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _templateObject, _templateObject2;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Tabs = /*#__PURE__*/function () {
  function Tabs() {
    var _this = this;
    _classCallCheck(this, Tabs);
    var shortCuts;
    this.hash = document.location.hash;
    if (this.hash && this.hash.includes("tab-") && $(this.hash).length) {
      this.SwitchTab(this.hash.replace("#", ""));
    } else if ($('#active-tab').length) {
      var activeTab = $('#active-tab').val();
      activeTab = "tab-" + activeTab.substr(0, 3);
      this.SwitchTab(activeTab);
    } else {
      this.shortCuts = localStorage.getItem('_tabShortCuts');
      if (!(this.shortCuts == undefined || this.shortCuts === "")) {
        // inflate string to data object
        this.shortCuts = JSON.parse(this.shortCuts);
        var localShortCuts = this.shortCuts;
        if (_typeof(this.shortCuts) == 'object') {
          // valid shortcuts object found in local storage, 
          // check for URL parameters looking to select tabs on page
          var vars = this.GetParameters();
          var BreakException = {};
          if (vars.tab != undefined) {
            vars.tab.forEach(function (value) {
              for (var storedTabsId in localShortCuts) {
                if (Array.isArray(_this.shortCuts[storedTabsId])) {
                  try {
                    localShortCuts[storedTabsId].forEach(function (vle) {
                      if (vle === "tab-" + value) {
                        // set the local storage for this tab
                        localStorage.setItem(storedTabsId + "-current-tab", "tab-" + value);
                        // exclude this storedTabs Id from any subsequent search of query vars
                        localShortCuts[storedTabsId] = undefined;
                        // throw exception to break the loop
                        throw BreakException;
                      }
                    });
                  } catch (e) {
                    if (e !== BreakException) throw e;
                  }
                } else {
                  if (_this.shortCuts[storedTabsId] === undefined) {}
                }
              }
            });
          }
          ;
        }
      }
    }
  }
  return _createClass(Tabs, [{
    key: "WhatHash",
    value: function WhatHash() {
      alert("from what hash " + this.hash);
    }
  }, {
    key: "InitTabs",
    value: function InitTabs(frame, config) {
      if ($(frame).hasClass('tab-frame')) {
        return;
      }
      var localStoreName = null;
      var locallyStoredCurrentTab = null;
      var currentTab = null;
      var currentTabId = null;
      var manipulateUrl = true;
      if (config != undefined) {
        if (config.manipulateUrl == undefined) {
          config.manipulateUrl = manipulateUrl;
        }
        localStoreName = config.localStoreName;
        $(frame).data('tab-config', config);
      }
      if (config && config.ignoreHash === true) {
        this.hash = '';
      }
      $(frame).addClass('tab-frame');
      $(frame + " .frn-tab:not(.no-tab) > a").each(function () {
        if (!$(this).data('click-bound')) {
          $(this).data('click-bound', true).on('click', function (e) {
            e.preventDefault();
            window.Tabs.LoadTab(this);
          });
        }
      });
      if (config && config.compactOnResize !== undefined && config.compactOnResize !== null && config.compactOnResize === true) {
        $(frame + "-compact").on('change', function (e) {
          window.Tabs.LoadTab(this);
        });
      }
      var mythis = this;
      if (config && config.setTabLink === true) {
        $(frame + " .frn-tab:not(.no-tab) > a").each(function (i, e) {
          var basePath = window.location.pathname;
          var vars = mythis.GetParameters();
          for (var key in vars) {
            if (vars.hasOwnProperty(key)) {
              if (key !== 'tab') {
                if (!basePath.includes('?')) {
                  basePath += "?" + key + "=" + vars[key];
                } else {
                  basePath += "&" + key + "=" + vars[key];
                }
              }
            }
          }
          var tabId = $(e).closest("div.frn-tab").prop('id');
          if (basePath.includes('?')) basePath += '&tab=' + tabId.substr(4);else basePath += '?tab=' + tabId.substr(4);
          $(e).attr('href', basePath);
        });
      }
      if (localStoreName !== null) {
        $(frame).data('tab-cache', localStoreName);
        locallyStoredCurrentTab = localStorage.getItem(localStoreName + "-current-tab");
      }
      $(frame + ' .tab-box').hide();

      // consider defaultTag from config
      var defaultTab = config.defaultTab;

      // if defaultTag is not configured, read from tab cache
      if (!defaultTab) defaultTab = locallyStoredCurrentTab;
      if (defaultTab && $('#' + defaultTab).length > 0 && $('#' + defaultTab).is(':visible')) {
        currentTabId = defaultTab;
        currentTab = $('#' + currentTabId);
      } else {
        // Get First tab
        currentTab = $(frame + " .frn-tab:first");
        currentTabId = currentTab.prop('id');
      }
      if (localStoreName !== null) {
        // local storage should have an object of all tab shortcuts(tab ids)
        // this is used for creating direct links to pages with tabs and having specific tabs opened

        if (this.shortCuts == null || this.shortCuts == undefined || !(_typeof(this.shortCuts) == 'object')) {
          // if the shortcut string could not be converted to object
          // start again with new object
          this.shortCuts = new Object();
        }

        // if we have not already recorded the Ids for current tabs in the 
        // localstorage shortcut object, we do so now
        if (this.shortCuts[localStoreName] === undefined) {
          var shortcutIds = [];
          $(frame + " .frn-tab").each(function (key, value) {
            // add the ID of each tab to an array
            shortcutIds.push($(value).prop('id'));
          });
          // save tabIds in for this tab  in the shortcut object
          this.shortCuts[localStoreName] = shortcutIds;
          // commit to local storage
          localStorage.setItem('_tabShortCuts', JSON.stringify(this.shortCuts));
        }

        // record this tab as the current Tab for localStorage
        // (when page is refreshed it will default to this tab rather than first tab on page)
        localStorage.setItem(localStoreName + "-current-tab", currentTabId);
      }
      if (config.haltInitLoad === true) {
        this.SetTabToLoadedState(currentTab.find("a"));
      } else {
        this.LoadTab(currentTab.find("a"));
      }
    }

    /*
     * Set the state of a tab to loaded, without actually loading any data
     */
  }, {
    key: "SetTabToLoadedState",
    value: function SetTabToLoadedState(e) {
      var tabFrame = $(e).closest("div.tab-frame"); // The outer most surrounding box.
      var menuFrame = $(e).closest("div.frn-tabs"); // Frame that holds the menus
      var tabFrameId = $(tabFrame).prop('id'); // Id of the frame menu
      var tab = $(e).closest("div"); // The tab that was clicked
      var tabConfig = $(tabFrame).data('tab-config'); // Tab config data attached to this instance of tabs
      var id = $(tab).prop('id');
      var cache = tabFrame.data('tabCache');
      var progressBar = $('#' + tabFrameId + '-progress');
      var progressBarExists = progressBar.length > 0;
      if (cache != undefined) {
        localStorage.setItem(cache + "-current-tab", id);
      }
      menuFrame.children().removeClass('frn-tab-active');
      $(e).closest("div.frn-tab").addClass('frn-tab-active');
      if (progressBarExists) {
        progressBar.hide();
      }
      if (tabConfig && tabConfig.manipulateUrl === true) {
        this.ManipulateUrl();
      }
    }
  }, {
    key: "LoadTab",
    value: function LoadTab(e) {
      var _this2 = this;
      var tabFrame = $(e).closest("div.tab-frame"); // The outer most surrounding box.
      var tabConfig = $(tabFrame).data('tab-config'); // Tab config data attached to this instance of tabs
      if (tabConfig === undefined) {
        tabConfig = {};
      }
      var menuFrame = $(e).closest("div.frn-tabs"); // Frame that holds the menus
      var tabFrameId = $(tabFrame).prop('id');
      // Id of the frame menu
      var triggerId;
      var url; // the url for ajax call
      var Post; // any data that needs to be sent to ajax call
      var preLoadCallback; // check to see is there a pre-process callback required for this tab ( to be run before page load )    
      var postProcessorCallback; // check to see is there a post-process callback required for this tab ( to be run after page load )
      var postRenderCallback; // check to see is there a post-render callback required for this tab ( to be run after page load )

      // determine if input was from tab link or select list drop down
      var isLink = true;
      var isSelect = false;
      var linkElement; // the link that contains config into

      if (tabConfig && tabConfig.compactOnResize !== undefined && tabConfig.compactOnResize !== null && tabConfig.compactOnResize && $(e).is("select")) {
        isSelect = true;
        isLink = false;
      }
      if (isLink) {
        var trigger = $(e).closest("div"); // The tab that was clicked
        triggerId = $(trigger).prop('id');
        linkElement = e;
      }
      if (isSelect) {
        triggerId = $('#' + tabFrameId + "-compact option:selected").val();
        linkElement = $('#' + triggerId + " > a");
      }
      url = $(linkElement).data('url');
      Post = $(linkElement).data('post');
      preLoadCallback = $(linkElement).data('preload-callback');
      postProcessorCallback = $(linkElement).data('postprocessor-callback');
      postRenderCallback = $(linkElement).data('post-render-callback');
      var cache = tabFrame.data('tabCache');
      var dynamicData = {};
      var progressBar = $('#' + tabFrameId + '-progress');
      var progressBarExists = progressBar.length > 0;

      // Tab Specific pre load callback. 
      // checks to see if the callback returns a data object, and if so stores it 
      // to send with PostData 
      if (preLoadCallback !== undefined) {
        var data;
        var tabInstancePreCallback = preLoadCallback;
        if (typeof tabInstancePreCallback == "string") {
          data = window[tabInstancePreCallback](linkElement);
        } else {
          data = tabInstancePreCallback(linkElement);
        }
        if (_typeof(data) == "object") {
          dynamicData = data;
        }
      }

      // Generic pre load callback (applies to all tabs)
      if (tabConfig && tabConfig.preLoadCallback !== undefined) {
        var callback = tabConfig.preLoadCallback;
        if (typeof callback == "string") {
          dynamicData = window[callback](linkElement);
        } else {
          dynamicData = callback(linkElement);
        }
      }
      if (cache != undefined) {
        localStorage.setItem(cache + "-current-tab", triggerId);
      }
      menuFrame.children().removeClass('frn-tab-active');
      $(e).closest("div.frn-tab").addClass('frn-tab-active');
      if (tabConfig && tabConfig.compactOnResize !== undefined && tabConfig.compactOnResize !== null && tabConfig.compactOnResize) {
        // This tabs instance uses selectlist when small instead of tabs, we need to make sure it matches the current tab
        $('#' + tabFrameId + "-compact").val(triggerId);
      }
      if ($('#' + triggerId + "-box").length) {
        $('#' + tabFrameId + ' .tab-box').hide();
        $('#' + triggerId + "-box").show();
        if (progressBarExists) {
          progressBar.hide();
        }
        if (postRenderCallback !== undefined) {
          window[postRenderCallback]();
        } else {
          // Generic post render callback (applies to all tabs)
          if (tabConfig && tabConfig.postRenderCallback !== undefined) {
            var genericPostRenderCallback = tabConfig.postRenderCallback;
            if (typeof genericPostRenderCallback == "string") {
              window[genericPostRenderCallback]();
            } else {
              genericPostRenderCallback();
            }
          }
        }
        if (tabConfig && tabConfig.manipulateUrl === true) {
          this.ManipulateUrl();
        }
      } else {
        if (progressBarExists) {
          progressBar.show();
        }
        var fullPost = Object.assign({}, Post, dynamicData);
        $.ajax({
          url: url,
          type: 'POST',
          data: fullPost,
          success: function success(result) {
            var renderResult = true;
            var resultProcessed;

            // Call any post-data callbacks specified in tab config
            // Tab Specific post load callback, pass the result object as argument
            if (postProcessorCallback !== undefined) {
              var tabInstancePostCallback = postProcessorCallback;
              if (typeof tabInstancePostCallback == "string") {
                resultProcessed = window[tabInstancePostCallback](result);
              } else {
                resultProcessed = tabInstancePostCallback(result);
              }
            }
            // Generic post load callback (applies to all tabs)
            if (tabConfig && tabConfig.postLoadCallback !== undefined) {
              var callback = tabConfig.postLoadCallback;
              if (typeof callback == "string") {
                resultProcessed = window[callback](result);
              } else {
                resultProcessed = callback(result);
              }
            }

            // postProcessorCallback can halt the render process by return object
            // with bool field haltRendering = true
            if (_typeof(resultProcessed) == "object") {
              if (resultProcessed.hasOwnProperty("HaltRender")) {
                renderResult = false;
              }
            }

            // Render the tab if any data-post-processor-callback has not specified that 
            // rendering should be cancelled
            if (renderResult === true) {
              $('#tab-live-' + tabFrameId).remove();
              var dom = '<div class="tab-box" id="tab-live-' + tabFrameId + '">' + result + '</div>';
              $(tabFrame).append(dom);
            }
            if (progressBarExists) {
              progressBar.hide();
            }

            // Call any post-render callbacks specified in tab config

            // Tab Specific post render callback, pass the result object as argument
            if (postRenderCallback !== undefined) {
              var tabInstancePostRenderCallback = postRenderCallback;
              if (typeof tabInstancePostRenderCallback == "string") {
                window[tabInstancePostRenderCallback](result);
              } else {
                tabInstancePostRenderCallback(result);
              }
            }
            // Generic post render callback (applies to all tabs)
            if (tabConfig && tabConfig.postRenderCallback !== undefined) {
              var genericPostRenderCallback = tabConfig.postRenderCallback;
              if (typeof genericPostRenderCallback == "string") {
                window[genericPostRenderCallback]();
              } else {
                genericPostRenderCallback();
              }
            }
            if (tabConfig && tabConfig.manipulateUrl === true) {
              _this2.ManipulateUrl();
            }
          }
        });
      }
    }

    /*
     * Set the Browser bar URL to reflect current state of tabs on page
     */
  }, {
    key: "ManipulateUrl",
    value: function ManipulateUrl() {
      var vars = this.GetParameters();
      var out = "";
      for (var key in vars) {
        if (vars.hasOwnProperty(key)) {
          if (key !== 'tab') {
            if (out === "") {
              out += "?" + key + "=" + vars[key];
            } else {
              out += "&" + key + "=" + vars[key];
            }
          }
        }
      }

      // look for every active tab on the page (there is one per tabset)
      $('.frn-tab.frn-tab-active').each(function (index, element) {
        // get the parent frame and tabconfig data object for current active tab that we are checking
        var config = $(element).closest('.tab-frame').data('tab-config');
        // if a tab config oject is found
        if (config != undefined) {
          // if tab config for currently checking tabs has manipulateURL set to true 
          // (i.e. we want to incude this tab set in URL manipulation)
          if (config.manipulateUrl) {
            // Get the current URL parameters
            if (out === "") {
              out += "?tab=" + element.id.replace("tab-", "");
            } else {
              out += "&tab=" + element.id.replace("tab-", "");
            }
          }
        }
      });
      if (out !== "") {
        if (this.hash !== "" && this.hash != undefined) {
          out = out + this.hash;
        }
        window.history.pushState("", "", out);
      }
    }

    /*
     * Get the Id for the current Tab in a tabframe
     * IF stored locally, get that value, if not then return first tab
     */
  }, {
    key: "GetCurrentTab",
    value: function GetCurrentTab(frame) {
      var config = $(frame).data('tab-config');
      var localStoreName = config.localStoreName;
      var locallyStoredCurrentTab;
      var currentTab;
      var currentTabId;
      if (localStoreName !== null) {
        locallyStoredCurrentTab = localStorage.getItem(localStoreName + "-current-tab");
      }
      if (locallyStoredCurrentTab == null) {
        // Get First tab
        currentTab = $(frame + " .frn-tab:first");
        currentTabId = currentTab.prop('id');
      } else {
        currentTabId = locallyStoredCurrentTab;
      }
      return currentTabId;
    }
  }, {
    key: "SwitchSubTab",
    value: function SwitchSubTab(id, subTabId, callback) {
      var whitecard = $('.white-card.tab-' + subTabId + '-box').first();
      whitecard.removeClass(function (index, className) {
        return (className.match(/(^|\s)switch-class-\S+/g) || []).join(' ');
      });
      whitecard.addClass('switch-class-' + id);
      $('.frn-tab-' + subTabId).removeClass('frn-tab-active');
      $('#tab-' + id).parent().addClass('frn-tab-active');
      $('.sub-tab-' + subTabId).addClass('hide');
      $('.' + id).removeClass('hide');
      if (callback) {
        if (typeof callback == "string") {
          window[callback]();
        } else {
          callback();
        }
      }
    }
  }, {
    key: "SwitchTabSel",
    value: function SwitchTabSel() {
      var id = $('#tabSelect').val();
      $('.frn-tab').removeClass('frn-tab-active');
      $('#' + id).closest('div').addClass('frn-tab-active');
      $('.white-card').css('display', 'none');
      $('#' + id + '-box').css('display', 'block');
      $('.white-card.' + id + '-box').css('display', 'block');
      if (id === "tab-ref") {
        $('#referrals-filter').css('display', 'flex');
        $('#btnholder').css('display', 'block');
      } else {
        $('#referrals-filter').css('display', 'none');
        $('#btnholder').css('display', 'none');
      }
    }
  }, {
    key: "SwitchTab",
    value: function SwitchTab(id) {
      $('.frn-tab').removeClass('frn-tab-active');
      $('#' + id).parent().addClass('frn-tab-active');
      $('.tab-box').css('display', 'none');
      $('.' + id + '-box').css('display', 'block');
      if (id === "tab-ref") {
        $('#referrals-filter').css('display', 'flex');
        $('#btnholder').css('display', 'block');
      } else {
        $('#referrals-filter').css('display', 'none');
        $('#btnholder').css('display', 'none');
      }
      $('#tabSelect').val(id);
    }
  }, {
    key: "SwitchSignUpTabs",
    value: function SwitchSignUpTabs(tab, companyRep) {
      // CBF only: a client signup funnels into the onboarding flow rather than
      // the in-modal signup form. Company-rep signup keeps its own flow.
      if (tab === 'signup' && companyRep !== true && window.authSignupUrl) {
        window.location.href = window.authSignupUrl;
        return;
      }
      if (window.Access && window.Access.turnstile) {
        window.Access.turnstile.Reset();
      }
      if (window.Access && window.Access.tencentCaptcha) {
        window.Access.tencentCaptcha.Reset();
      }

      // Clear any existing Turnstile containers to prevent duplicates
      $('.cf-turnstile').remove();
      $('#loginModal .frn-tab').removeClass('frn-tab-active');
      if (tab == 'signup' && companyRep === true) {
        $("#sign-up-as-companyrep").prop('checked', true);
        $("#socialLoginList").hide();
        $("#socialLoginList~.or-wrap").hide();
      } else {
        $("#sign-up-as-companyrep").prop('checked', false);
        $("#socialLoginList").show();
        $("#socialLoginList~.or-wrap").show();
      }
      if (tab === "forgotten") {
        $('#login-tab').addClass('frn-tab-active');
        $('#forgot').hide();
      } else {
        $('#forgot').show();
        $('#' + tab + "-tab").addClass('frn-tab-active');
      }
      $('.signup-content').addClass('hide');
      $('#' + tab + "-payload").removeClass('hide');

      // Now render captcha for the active tab
      if (window.tencentCaptchaAppId && window.Access && window.Access.tencentCaptcha) {
        // CBFCN: pre-render Tencent captcha widget in the container
        window.Access.tencentCaptcha.Render(tab + '-tencent-container');
      } else if (window.Access && window.Access.turnstile) {
        // Other portals: load and render Turnstile in the container
        var turnstileContainerId = '#' + tab + '-turnstile-container';
        if ($(turnstileContainerId).length) {
          window.Access.turnstile.LoadTurnstile().then(function () {
            var token = window.Access.turnstile.GetToken();
            if (!token) {
              window.Access.turnstile.Render(turnstileContainerId, function (token) {
                console.log('Turnstile verified for ' + tab);
              });
            }
          })["catch"](function (err) {
            console.error('Failed to load Turnstile for ' + tab + ':', err);
          });
        }
      }
    }
  }, {
    key: "GetParameters",
    value: function GetParameters() {
      var qd = {};
      if (location.search) location.search.substr(1).split(_templateObject || (_templateObject = _taggedTemplateLiteral(["&"]))).forEach(function (item) {
        var _ref = item.split(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["="]))),
          _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];
        v = v && decodeURIComponent(v);
        (qd[k] = qd[k] || []).push(v);
      });
      return qd;
    }
  }]);
}();
var _default = exports["default"] = Tabs;

},{}],16:[function(require,module,exports){
'use strict';

// Top Menu Search Functionality
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var TopMenuSearch = /*#__PURE__*/function () {
  function TopMenuSearch() {
    var isMobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    _classCallCheck(this, TopMenuSearch);
    this.currentQuery = '';
    this.currentCategory = 'all';
    this.searchTimeout = null;
    this.maxResultsPerCategory = 10;
    this.isMobile = isMobile;
    this.currentRequest = null; // Store current AJAX request
    this.requestId = 0; // Track request sequence

    // Set element IDs based on mobile or desktop
    if (isMobile) {
      this.searchInputId = '#mobile-search-input';
      this.searchClearId = '#mobile-search-clear';
      this.searchDropdownId = '#mobile-search-popup';
      this.searchResultsId = '#mobile-search-results';
      this.searchFullResultsId = '#mobile-search-full-results';
      this.searchFullResultsLinkId = '#mobile-search-full-results-link';
      this.searchCategoryBtnClass = '.mobile-search-category-btn';
    } else {
      this.searchInputId = '#top-menu-search-input';
      this.searchClearId = '#top-menu-search-clear';
      this.searchDropdownId = '#top-menu-search-dropdown';
      this.searchResultsId = '#top-menu-search-results';
      this.searchFullResultsId = '#top-menu-search-full-results';
      this.searchFullResultsLinkId = '#top-menu-search-full-results-link';
      this.searchCategoryBtnClass = '.top-menu-search-category-btn';
    }
  }

  // Escape HTML to prevent XSS
  return _createClass(TopMenuSearch, [{
    key: "escapeHtml",
    value: function escapeHtml(text) {
      if (!text) return '';
      var map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      };
      return text.toString().replace(/[&<>"']/g, function (m) {
        return map[m];
      });
    }

    // Render simplified result item for dropdown
  }, {
    key: "renderDropdownResultItem",
    value: function renderDropdownResultItem(item, category) {
      var tag = category.charAt(0).toUpperCase() + category.slice(1);
      if (category === 'economic-events') {
        tag = 'Events';
      }
      var title = '';
      var url = '';
      var type = '';
      var html = '';
      if (category === 'forum' || category === 'all') {
        title = item.Title || '';
        url = langSlug + '/forum?discussion=' + item.Id;
        type = 'forum';
      } else if (category === 'news' || category === 'all') {
        title = item.Title || '';
        url = langSlug + '/news/' + item.NewsSlug + '-' + item.NewsId;
        type = 'news';
      } else if (category === 'tools' || category === 'all') {
        title = item.Title || '';
        url = langSlug + (item.Path || '#');
        type = 'tools';
        tag = "Tools";
        // Check if it's a chart (check both Title and Name)
        if (item.Path.includes("/chart")) {
          tag = 'Chart';
        }
      } else if (category === 'companies' || category === 'all') {
        title = item.Name || '';
        if (item.EntityType == 'CryptoExchange') {
          url = langSlug + '/crypto-exchange/' + item.Code + '-review-' + item.BrokerId;
        } else {
          url = langSlug + '/brokers/' + item.Code + '-review-' + item.BrokerId;
        }
        type = 'companies';
      } else if (category === 'economic-events' || category === 'all') {
        title = item.Name || '';
        url = langSlug + '/tools/economic-calendar?time=' + item.Date + '&jumpTo=' + item.CalendarId;
        type = 'events';
      }
      if (!title) return null;

      // Render based on type
      if (type === 'companies') {
        // Company result with logo, name, rating, stars, and reviews

        var logoUrl = '';
        if (item.EntityType == 'CryptoExchange') {
          logoUrl = item.Logo ? item.Logo : '/Content/dist/brokers/images/no-logo.png';
        } else {
          logoUrl = item.Logo ? '/Content/dist/brokers/images/' + item.Logo : '/Content/dist/brokers/images/no-logo.png';
        }
        var rating = item.UserRating || 0;
        var reviewCount = item.ReviewCount || 0;
        var roundedRating = rating > 0 ? Math.round(rating * 10) / 10 : 0;
        var stars = Math.round(rating);
        var outlineStars = 5 - stars;
        var starHtml = '';
        if (rating > 0) {
          starHtml = '<span class="typcn stars-' + stars + '" style="font-size: 14px;"></span>';
          if (outlineStars > 0) {
            starHtml += '<span class="typcn outline-stars-' + outlineStars + '" style="font-size: 14px;"></span>';
          }
        } else {
          starHtml = '<span class="typcn outline-stars-5" style="font-size: 14px;"></span>';
        }
        var reviewText = reviewCount > 0 ? reviewCount + ' Reviews' : '0 Reviews';
        html = '<div class="top-menu-search-result-item" data-type="' + type + '" data-url="' + url + '">' + '<span class="top-menu-search-result-tag">' + tag + '</span>' + '<div class="top-menu-search-result-content">' + '<div class="top-menu-search-company-content">' + '<div class="top-menu-search-company-logo">' + '<img src="' + logoUrl + '" alt="' + this.escapeHtml(title) + '" />' + '</div>' + '<div class="top-menu-search-company-info">' + '<div class="top-menu-search-company-name">' + this.escapeHtml(title) + '</div>' + '<div class="top-menu-search-company-rating">' + '<span style="font-weight:600;">' + roundedRating.toFixed(1) + '</span>' + '<div class="star-holder" style="display: inline-flex; align-items: center;">' + starHtml + '</div>' + '<span>' + reviewText + '</span>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>';
      } else if (type === 'events') {
        // Event result with flag, impact, and date
        var flagHtml = '';
        if (item.CountryCode) {
          var countryName = item.Country || '';
          flagHtml = '<i class="flag flag-' + item.CountryCode.toLowerCase() + '"></i>';
        }
        var dateStr = '';
        if (item.Date) {
          var eventDate = moment.unix(item.Date);
          dateStr = eventDate.format('MMM DD, YYYY HH:mm');
        }
        var impactText = item.Impact || '';
        var impactDisplayText = '';
        var impactIcon = '';
        if (impactText) {
          var impactUpper = impactText.toUpperCase();
          if (impactUpper === 'HIGH' || impactUpper.includes('HIGH')) {
            impactDisplayText = window.searchResxStrings['HighImpact'];
            impactIcon = 'impact-high.png';
          } else if (impactUpper === 'MEDIUM' || impactUpper.includes('MEDIUM')) {
            impactDisplayText = window.searchResxStrings['MediumImpact'];
            impactIcon = 'impact-medium.png';
          } else {
            impactDisplayText = window.searchResxStrings['LowImpact'];
            impactIcon = 'impact-low.png';
          }
        }
        html = '<div class="top-menu-search-result-item" data-type="' + type + '" data-url="' + url + '">' + '<span class="top-menu-search-result-tag">' + tag + '</span>' + '<div class="top-menu-search-result-content">' + '<div class="top-menu-search-result-title">' + flagHtml + this.escapeHtml(title) + '</div>' + '<div class="top-menu-search-event-details">' + '<div class="top-menu-search-event-impact">' + '<img src="/content/dist/images/icons/' + impactIcon + '" style="width: 16px; height: 16px;" >' + '<span>' + impactDisplayText + '</span>' + '</div>' + '<span>' + dateStr + '</span>' + '</div>' + '</div>' + '</div>';
      } else {
        // Simple result for News, Forum, Tools, Chart
        html = '<div class="top-menu-search-result-item" data-type="' + type + '" data-url="' + url + '">' + '<span class="top-menu-search-result-tag">' + tag + '</span>' + '<div class="top-menu-search-result-content">' + '<div class="top-menu-search-result-title">' + this.escapeHtml(title) + '</div>' + '</div>' + '</div>';
      }
      return $(html);
    }

    // Show loading indicator
  }, {
    key: "showLoading",
    value: function showLoading() {
      var $container = $(this.searchResultsId);
      $container.html('<div style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 48px 32px; min-height: 200px;">' + '<img src="/Content/dist/images/PageElements/ajax-loader.gif" alt="Loading..."/>' + '</div>');
      $(this.searchFullResultsId).hide();
    }

    // Render results for dropdown
  }, {
    key: "renderDropdownResults",
    value: function renderDropdownResults(data) {
      var $container = $(this.searchResultsId);
      $container.empty();
      if (!this.currentQuery || this.currentQuery.trim().length === 0) {
        $(this.searchFullResultsId).hide();
        return;
      }
      var hasResults = false;
      var self = this;
      if (this.currentCategory === 'all') {
        // Show results from all categories, limited per category
        var resultsHtml = '';

        // Forum results
        if (data.TopicsResult && data.TopicsResult.Topics && data.TopicsResult.Topics.Data && data.TopicsResult.Topics.Data.length > 0) {
          hasResults = true;
          var forumItems = data.TopicsResult.Topics.Data.slice(0, this.maxResultsPerCategory);
          forumItems.forEach(function (item) {
            var $item = self.renderDropdownResultItem(item, 'forum');
            if ($item) {
              resultsHtml += $('<div>').append($item).html();
            }
          });
        }

        // News results
        if (data.NewsResult && data.NewsResult.Data && data.NewsResult.Data.length > 0) {
          hasResults = true;
          var newsItems = data.NewsResult.Data.slice(0, this.maxResultsPerCategory);
          newsItems.forEach(function (item) {
            var $item = self.renderDropdownResultItem(item, 'news');
            if ($item) {
              resultsHtml += $('<div>').append($item).html();
            }
          });
        }

        // Tools results
        if (data.ToolsResult && data.ToolsResult.Data && data.ToolsResult.Data.length > 0) {
          hasResults = true;
          var toolsItems = data.ToolsResult.Data.slice(0, this.maxResultsPerCategory);
          toolsItems.forEach(function (item) {
            var $item = self.renderDropdownResultItem(item, 'tools');
            if ($item) {
              resultsHtml += $('<div>').append($item).html();
            }
          });
        }

        // Companies results
        if (data.CompaniesResult && data.CompaniesResult.Data && data.CompaniesResult.Data.length > 0) {
          hasResults = true;
          var companiesItems = data.CompaniesResult.Data.slice(0, this.maxResultsPerCategory);
          companiesItems.forEach(function (item) {
            var $item = self.renderDropdownResultItem(item, 'companies');
            if ($item) {
              resultsHtml += $('<div>').append($item).html();
            }
          });
        }

        // Economic Events results
        if (data.CalendarEventsResult && data.CalendarEventsResult.Data && data.CalendarEventsResult.Data.length > 0) {
          hasResults = true;
          var eventsItems = data.CalendarEventsResult.Data.slice(0, this.maxResultsPerCategory);
          eventsItems.forEach(function (item) {
            var $item = self.renderDropdownResultItem(item, 'economic-events');
            if ($item) {
              resultsHtml += $('<div>').append($item).html();
            }
          });
        }
        $container.html(resultsHtml);
      } else {
        // Show results for specific category
        var resultsHtml = '';
        var items = [];
        if (this.currentCategory === 'forum' && data.TopicsResult && data.TopicsResult.Topics && data.TopicsResult.Topics.Data) {
          items = data.TopicsResult.Topics.Data.slice(0, this.maxResultsPerCategory);
        } else if (this.currentCategory === 'news' && data.NewsResult && data.NewsResult.Data) {
          items = data.NewsResult.Data.slice(0, this.maxResultsPerCategory);
        } else if (this.currentCategory === 'tools' && data.ToolsResult && data.ToolsResult.Data) {
          items = data.ToolsResult.Data.slice(0, this.maxResultsPerCategory);
        } else if (this.currentCategory === 'companies' && data.CompaniesResult && data.CompaniesResult.Data) {
          items = data.CompaniesResult.Data.slice(0, this.maxResultsPerCategory);
        } else if (this.currentCategory === 'economic-events' && data.CalendarEventsResult && data.CalendarEventsResult.Data) {
          items = data.CalendarEventsResult.Data.slice(0, this.maxResultsPerCategory);
        }
        if (items.length > 0) {
          hasResults = true;
          items.forEach(function (item) {
            var $item = self.renderDropdownResultItem(item, self.currentCategory);
            if ($item) {
              resultsHtml += $('<div>').append($item).html();
            }
          });
        }
        $container.html(resultsHtml);
      }
      if (!hasResults) {
        $container.html('<div style="padding: 32px; text-align: center; color: #666;">No results found</div>');
      }

      // Show full results link
      var fullResultsUrl = langSlug + '/search?query=' + encodeURIComponent(this.currentQuery) + '&category=' + this.currentCategory;
      $(this.searchFullResultsLinkId).attr('href', fullResultsUrl);
      $(this.searchFullResultsId).show();
    }

    // Load search results
  }, {
    key: "loadResults",
    value: function loadResults() {
      if (!this.currentQuery || this.currentQuery.trim().length === 0) {
        $(this.searchResultsId).html('<div style="padding: 32px; text-align: center; color: #666;">Start typing to search...</div>');
        $(this.searchFullResultsId).hide();
        return;
      }

      // Cancel previous request if it exists
      if (this.currentRequest) {
        this.currentRequest.abort();
        this.currentRequest = null;
      }

      // Increment request ID to track the latest request
      this.requestId++;
      var currentRequestId = this.requestId;
      var currentQuery = this.currentQuery;
      var currentCategory = this.currentCategory;

      // Show loading indicator
      this.showLoading();
      var self = this;
      var ajaxData = {
        query: this.currentQuery,
        category: this.currentCategory === 'all' ? 'all' : this.currentCategory,
        sortDir: 'latest',
        page: 1,
        pageSize: this.currentCategory === 'all' ? 1 : this.maxResultsPerCategory
      };

      // Store the jqXHR object so we can cancel it
      this.currentRequest = $.ajax({
        url: searchResultUrl,
        type: 'GET',
        data: ajaxData,
        cache: false,
        success: function success(response) {
          // Only render if this is still the latest request and query hasn't changed
          if (currentRequestId === self.requestId && currentQuery === self.currentQuery && currentCategory === self.currentCategory) {
            if (response.success && response.data) {
              self.renderDropdownResults(response.data);
            } else {
              $(self.searchResultsId).html('<div style="padding: 32px; text-align: center; color: #666;">Error loading results</div>');
              $(self.searchFullResultsId).hide();
            }
          }
          // Clear the request reference if this was the current one
          if (self.currentRequest && currentRequestId === self.requestId) {
            self.currentRequest = null;
          }
        },
        error: function error(xhr, status, _error) {
          // Only show error if this is still the latest request and it wasn't aborted
          if (currentRequestId === self.requestId && currentQuery === self.currentQuery && currentCategory === self.currentCategory && status !== 'abort') {
            console.error('Error loading top menu search results:', _error);
            $(self.searchResultsId).html('<div style="padding: 32px; text-align: center; color: #666;">Error loading results</div>');
            $(self.searchFullResultsId).hide();
          }
          // Clear the request reference if this was the current one
          if (self.currentRequest && currentRequestId === self.requestId) {
            self.currentRequest = null;
          }
        }
      });
    }

    // Handle category change
  }, {
    key: "handleCategoryChange",
    value: function handleCategoryChange(category) {
      // Only change category if it's different
      if (this.currentCategory === category) {
        return;
      }
      this.currentCategory = category;
      $(this.searchCategoryBtnClass).removeClass('active');
      $(this.searchCategoryBtnClass + '[data-category="' + category + '"]').addClass('active');

      // Only load results if there's a query
      if (this.currentQuery && this.currentQuery.trim().length > 0) {
        this.loadResults();
      } else {
        // Clear results if no query
        $(this.searchResultsId).html('<div style="padding: 32px; text-align: center; color: #666;">Start typing to search...</div>');
        $(this.searchFullResultsId).hide();
      }
    }

    // Show dropdown
  }, {
    key: "showDropdown",
    value: function showDropdown() {
      $(this.searchDropdownId).show();
      if (this.isMobile) {
        // Disable body scroll when mobile popup is open
        $('body').css('overflow', 'hidden');
      }
    }

    // Hide dropdown
  }, {
    key: "hideDropdown",
    value: function hideDropdown() {
      $(this.searchDropdownId).hide();
      if (this.isMobile) {
        // Re-enable body scroll when mobile popup is closed
        $('body').css('overflow', '');
        // Clear search
        $(this.searchInputId).val('');
        $(this.searchClearId).hide();
        this.currentQuery = '';
        $(this.searchResultsId).html('<div style="padding: 32px; text-align: center; color: #666;">Start typing to search...</div>');
        $(this.searchFullResultsId).hide();
      }
    }

    // Reset search state
  }, {
    key: "reset",
    value: function reset() {
      // Cancel any pending request
      if (this.currentRequest) {
        this.currentRequest.abort();
        this.currentRequest = null;
      }
      this.currentQuery = '';
      this.currentCategory = 'all';
      $(this.searchInputId).val('');
      $(this.searchClearId).hide();
      $(this.searchCategoryBtnClass).removeClass('active');
      $(this.searchCategoryBtnClass + '[data-category="all"]').addClass('active');
      $(this.searchResultsId).html('<div style="padding: 32px; text-align: center; color: #666;">Start typing to search...</div>');
      $(this.searchFullResultsId).hide();
    }
  }]);
}();
var _default = exports["default"] = TopMenuSearch;

},{}],17:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Tracker = /*#__PURE__*/function () {
  function Tracker(cookie) {
    _classCallCheck(this, Tracker);
    this.Cookie = cookie;
    this.trackerCode = null;

    // Check for the presence of hash paramater
    var lochash = location.hash.substr(1);
    if (lochash !== "" && lochash != undefined) {
      // Check to see if hash is an tid (Tracking ID) value
      var t = lochash.split("tid_");
      if (t[1] !== undefined) {
        this.trackerCode = t[1].split("#")[0];
      }
      this.send = false;
    }
    if (lochash === "loginforum_rkfx") {
      if (!$('#recptcha-script').length) {
        var script = document.createElement('script');
        script.id = "recptcha-script";
        script.src = "https://www.recaptcha.net/recaptcha/api.js?render=" + window.CAPTCHA_KEY;
        document.getElementsByTagName('head')[0].appendChild(script);
      }
      $('#loginModal').data('GoToUrl', 'https://rkfx.talktrading.io/login');
      $('#loginModal').find('#signup-payload').hide();
      $('#loginModal').find('#forgotten-payload').hide();
      $('#loginModal').find('#forgot').hide();
      $('#loginModal').find('#signup-tab').hide();
      $('#loginModal').modal('show');
      $('#login-screen-progress').addClass('hide');
      $('#login-error-summary').remove();
    }
    var postData = {};
    if (this.trackerCode != undefined && this.trackerCode !== "") {
      // Valid promo code
      // check to see if the hidden TID field is on page (found in the registration form)
      if ($('#PromoCode').length) {
        // if yes, assign aid value
        $('#PromoCode').val(this.trackerCode);
      }
      this.Cookie.SetCookie("promoCode", this.trackerCode, 90);
    }
  }
  return _createClass(Tracker, [{
    key: "RecordSocialActivity",
    value: function RecordSocialActivity(activities) {
      var data = {};
      data.Activities = activities;
      var formattedData = $.param(data);
      $.ajax({
        url: '/api/social-profile/activity',
        type: 'POST',
        cache: false,
        data: formattedData,
        async: true,
        success: function success() {}
      });
    }
  }]);
}();
var _default = exports["default"] = Tracker;

},{}],19:[function(require,module,exports){
"use strict";

var _Cookie = _interopRequireDefault(require("../../includes/Cookie.js"));
var _CacheBuster = _interopRequireDefault(require("../../includes/CacheBuster.js"));
var _Access = _interopRequireDefault(require("../../includes/Access.js"));
var _Language = _interopRequireDefault(require("../../includes/Language.js"));
var _Tabs = _interopRequireDefault(require("../../includes/Tabs.js"));
var _RebateAccounts = _interopRequireDefault(require("../../includes/RebateAccounts.js"));
var _Support = _interopRequireDefault(require("../../includes/Support.js"));
var _Site = _interopRequireDefault(require("../../includes/Site.js"));
var _DatePicker = _interopRequireDefault(require("../../includes/DatePicker.js"));
var _Tracker = _interopRequireDefault(require("../../includes/Tracker.js"));
var _FauxSelect = _interopRequireDefault(require("../../includes/FauxSelect.js"));
var _Ads = _interopRequireDefault(require("../../includes/Ads.js"));
var _APIHelper = _interopRequireDefault(require("../../includes/APIHelper.js"));
var _SearchPage = _interopRequireDefault(require("../../includes/SearchPage.js"));
var _TopMenuSearch = _interopRequireDefault(require("../../includes/TopMenuSearch.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
require('../../includes/CustomAutoComplete.js');
window.SearchPage = _SearchPage["default"];
window.TopMenuSearch = _TopMenuSearch["default"];
$(function () {
  var cookieInstance = new _Cookie["default"]();
  window.Tracker = new _Tracker["default"](cookieInstance);
  window.Tabs = new _Tabs["default"]();
  window.Access = new _Access["default"](cookieInstance);
  window.Promotion = new _Ads["default"](cookieInstance);
  window.Language = new _Language["default"](cookieInstance);
  window.RebateAccounts = new _RebateAccounts["default"]();
  window.Support = new _Support["default"](new _DatePicker["default"]());
  window.Site = new _Site["default"]();
  window.FauxSelect = new _FauxSelect["default"]();
  window.FauxSelect.Initialise();
  window.CacheBuster = new _CacheBuster["default"](cookieInstance);
  window.APIHelper = new _APIHelper["default"]();
  setTimeout(function () {
    window.CacheBuster.Refresh();
  }, 500);
  window.Site.UpdateLastUpdatedDate();
  window.Site.InitAuthorPopovers();
});

},{"../../includes/APIHelper.js":1,"../../includes/Access.js":2,"../../includes/Ads.js":3,"../../includes/CacheBuster.js":4,"../../includes/Cookie.js":5,"../../includes/CustomAutoComplete.js":6,"../../includes/DatePicker.js":7,"../../includes/FauxSelect.js":8,"../../includes/Language.js":9,"../../includes/RebateAccounts.js":10,"../../includes/SearchPage.js":11,"../../includes/Site.js":12,"../../includes/Support.js":13,"../../includes/Tabs.js":14,"../../includes/TopMenuSearch.js":16,"../../includes/Tracker.js":17}]},{},[19]);

/***************************************************************************************************
LoadingOverlay - A flexible loading overlay jQuery plugin
    Author          : Gaspare Sganga
    Version         : 1.5.3
    License         : MIT
    Documentation   : http://gasparesganga.com/labs/jquery-loading-overlay/
****************************************************************************************************/
!function(A,B){function C(C,g){C=A(C);var E=C.is("body"),I=C.data("LoadingOverlayCount");if(I===B&&(I=0),0==I){var o=A("<div>",{class:"loadingoverlay",css:{"background-color":g.color,position:"relative",display:"flex","flex-direction":"column","align-items":"center","justify-content":"center"}});if(g.zIndex!==B&&o.css("z-index",g.zIndex),g.image&&o.css({"background-image":"url("+g.image+")","background-position":g.imagePosition,"background-repeat":"no-repeat"}),g.fontawesome&&A("<div>",{class:"loadingoverlay_fontawesome "+g.fontawesome}).appendTo(o),g.custom&&A(g.custom).appendTo(o),E?o.css({position:"fixed",top:0,left:0,width:"100%",height:"100%"}):o.css("position","fixed"==C.css("position")?"fixed":"absolute"),Q(C,o,g,E),g.resizeInterval>0){var w=setInterval(function(){Q(C,o,g,E)},g.resizeInterval);C.data("LoadingOverlayResizeIntervalId",w)}g.fade?g.fade===!0?g.fade=[400,200]:"string"!=typeof g.fade&&"number"!=typeof g.fade||(g.fade=[g.fade,g.fade]):g.fade=[0,0],C.data({LoadingOverlay:o,LoadingOverlayFadeOutDuration:g.fade[1]}),o.hide().appendTo("body").fadeIn(g.fade[0])}I++,C.data("LoadingOverlayCount",I)}function g(C,g){C=A(C);var Q=C.data("LoadingOverlayCount");if(Q!==B)if(Q--,g||Q<=0){var E=C.data("LoadingOverlayResizeIntervalId");E&&clearInterval(E),C.data("LoadingOverlay").fadeOut(C.data("LoadingOverlayFadeOutDuration"),function(){A(this).remove()}),C.removeData(["LoadingOverlay","LoadingOverlayCount","LoadingOverlayFadeOutDuration","LoadingOverlayResizeIntervalId"])}else C.data("LoadingOverlayCount",Q)}function Q(B,C,g,Q){if(!Q){var E="fixed"==B.css("position")?B.position():B.offset();C.css({top:E.top+parseInt(B.css("border-top-width"),10),left:E.left+parseInt(B.css("border-left-width"),10),width:B.innerWidth(),height:B.innerHeight()})}var I=Q?A(window):B,o="auto";g.size&&"auto"!=g.size&&(o=Math.min(I.innerWidth(),I.innerHeight())*parseFloat(g.size)/100,g.maxSize&&o>parseInt(g.maxSize,10)&&(o=parseInt(g.maxSize,10)+"px"),g.minSize&&o<parseInt(g.minSize,10)&&(o=parseInt(g.minSize,10)+"px")),C.css("background-size",o),C.children(".loadingoverlay_fontawesome").css("font-size",o)}var E={color:"rgba(255, 255, 255, 0.8)",custom:"",fade:!0,fontawesome:"",image:"data:image/gif;base64,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",imagePosition:"center center",maxSize:"100px",minSize:"20px",resizeInterval:50,size:"50%",zIndex:9999};A.LoadingOverlaySetup=function(B){A.extend(!0,E,B)},A.LoadingOverlay=function(B,Q){switch(B.toLowerCase()){case"show":var I=A.extend(!0,{},E,Q);C("body",I);break;case"hide":g("body",Q)}},A.fn.LoadingOverlay=function(B,Q){switch(B.toLowerCase()){case"show":var I=A.extend(!0,{},E,Q);return this.each(function(){C(this,I)});case"hide":return this.each(function(){g(this,Q)})}}}(jQuery);
/*
 * pagination.js 2.6.0
 * A jQuery plugin to provide simple yet fully customisable pagination.
 * https://github.com/superRaytin/paginationjs
 *
 * Homepage: http://pagination.js.org
 *
 * Copyright 2014-2100, superRaytin
 * Released under the MIT license.
 */

(function (global, $) {

  if (typeof $ === 'undefined') {
    throwError('Pagination requires jQuery.');
  }

  var pluginName = 'pagination';

  var pluginHookMethod = 'addHook';

  var eventPrefix = '__pagination-';

  if ($.fn.pagination) {
    throwError('plugin conflicted, the name "pagination" has been taken by another jQuery plugin.');
  }

  $.fn[pluginName] = function (options) {

    if (typeof options === 'undefined') {
      return this;
    }

    var container = $(this);

    var attributes = $.extend({}, $.fn[pluginName].defaults, options);

    var pagination = {

      initialize: function () {
        var self = this;

        // Cache data for current instance
        if (!container.data('pagination')) {
          container.data('pagination', {});
        }

        if (self.callHook('beforeInit') === false) return;

        // Pagination has been initialized, destroy it
        if (container.data('pagination').initialized) {
          $('.paginationjs', container).remove();
        }

        // Whether to disable Pagination at the initialization
        self.disabled = !!attributes.disabled;

        // Model will be passed to the callback function
        var model = self.model = {
          pageRange: attributes.pageRange,
          pageSize: attributes.pageSize
        };

        // Parse dataSource to find available paging data
        self.parseDataSource(attributes.dataSource, function (dataSource) {

          // Asynchronous mode
          self.isAsync = Helpers.isString(dataSource);
          if (Helpers.isArray(dataSource)) {
            model.totalNumber = attributes.totalNumber = dataSource.length;
          }

          // Asynchronous mode and a 'totalNumberLocator' has been specified
          self.isDynamicTotalNumber = self.isAsync && attributes.totalNumberLocator;

          var el = self.render(true);

          // Add extra className to the pagination element
          if (attributes.className) {
            el.addClass(attributes.className);
          }

          model.el = el;

          // Append / prepend pagination element to the container
          container[attributes.position === 'bottom' ? 'append' : 'prepend'](el);

          // Bind events
          self.observer();

          // Mark pagination has been initialized
          container.data('pagination').initialized = true;

          // Call hook after initialization
          self.callHook('afterInit', el);
        });
      },

      render: function (isBoot) {
        var self = this;
        var model = self.model;
        var el = model.el || $('<div class="paginationjs"></div>');
        var isForced = isBoot !== true;

        self.callHook('beforeRender', isForced);

        var currentPage = model.pageNumber || attributes.pageNumber;
        var pageRange = attributes.pageRange || 0;
        var totalPage = self.getTotalPage();

        var rangeStart = currentPage - pageRange;
        var rangeEnd = currentPage + pageRange;

        if (rangeEnd > totalPage) {
          rangeEnd = totalPage;
          rangeStart = totalPage - pageRange * 2;
          rangeStart = rangeStart < 1 ? 1 : rangeStart;
        }

        if (rangeStart <= 1) {
          rangeStart = 1;
          rangeEnd = Math.min(pageRange * 2 + 1, totalPage);
        }

        el.html(self.generateHTML({
          currentPage: currentPage,
          pageRange: pageRange,
          rangeStart: rangeStart,
          rangeEnd: rangeEnd
        }));

        // Whether to hide pagination when there is only one page
        if (attributes.hideOnlyOnePage) {
          el[totalPage <= 1 ? 'hide' : 'show']();
        }

        self.callHook('afterRender', isForced);

        return el;
      },

      getPageLinkTag: function (index) {
        var pageLink = attributes.pageLink;
        return pageLink ? '<a href="' + pageLink + '">' + index + '</a>' : '<a>' + index + '</a>';
      },

      // Generate HTML for page numbers
      generatePageNumbersHTML: function (args) {
        var self = this;
        var currentPage = args.currentPage;
        var totalPage = self.getTotalPage();
        var getPageLinkTag = self.getPageLinkTag;
        var rangeStart = args.rangeStart;
        var rangeEnd = args.rangeEnd;
        var html = '';
        var i;

        var ellipsisText = attributes.ellipsisText;

        var classPrefix = attributes.classPrefix;
        var pageClassName = attributes.pageClassName || '';
        var activeClassName = attributes.activeClassName || '';
        var disableClassName = attributes.disableClassName || '';

        // Display all page numbers if page range disabled
        if (attributes.pageRange === null) {
          for (i = 1; i <= totalPage; i++) {
            if (i == currentPage) {
              html += '<li class="' + classPrefix + '-page J-paginationjs-page ' + pageClassName + ' ' + activeClassName + '" data-num="' + i + '"><a>' + i + '</a></li>';
            } else {
              html += '<li class="' + classPrefix + '-page J-paginationjs-page ' + pageClassName + '" data-num="' + i + '">' + getPageLinkTag(i) + '</li>';
            }
          }
          return html;
        }

        if (rangeStart <= 3) {
          for (i = 1; i < rangeStart; i++) {
            if (i == currentPage) {
              html += '<li class="' + classPrefix + '-page J-paginationjs-page ' + pageClassName + ' ' + activeClassName + '" data-num="' + i + '"><a>' + i + '</a></li>';
            } else {
              html += '<li class="' + classPrefix + '-page J-paginationjs-page ' + pageClassName + '" data-num="' + i + '">' + getPageLinkTag(i) + '</li>';
            }
          }
        } else {
          if (!attributes.hideFirstOnEllipsisShow) {
            html += '<li class="' + classPrefix + '-page ' + classPrefix + '-first J-paginationjs-page ' + pageClassName + '" data-num="1">' + getPageLinkTag(1) + '</li>';
          }
          html += '<li class="' + classPrefix + '-ellipsis ' + disableClassName + '"><a>' + ellipsisText + '</a></li>';
        }

        for (i = rangeStart; i <= rangeEnd; i++) {
          if (i == currentPage) {
            html += '<li class="' + classPrefix + '-page J-paginationjs-page ' + pageClassName + ' ' + activeClassName + '" data-num="' + i + '"><a>' + i + '</a></li>';
          } else {
            html += '<li class="' + classPrefix + '-page J-paginationjs-page ' + pageClassName + '" data-num="' + i + '">' + getPageLinkTag(i) + '</li>';
          }
        }

        if (rangeEnd >= totalPage - 2) {
          for (i = rangeEnd + 1; i <= totalPage; i++) {
            html += '<li class="' + classPrefix + '-page J-paginationjs-page ' + pageClassName + '" data-num="' + i + '">' + getPageLinkTag(i) + '</li>';
          }
        } else {
          html += '<li class="' + classPrefix + '-ellipsis ' + disableClassName + '"><a>' + ellipsisText + '</a></li>';

          if (!attributes.hideLastOnEllipsisShow) {
            html += '<li class="' + classPrefix + '-page ' + classPrefix + '-last J-paginationjs-page ' + pageClassName + '" data-num="' + totalPage + '">' + getPageLinkTag(totalPage) + '</li>';
          }
        }

        return html;
      },

      // Generate HTML content
      generateHTML: function (args) {
        var self = this;
        var currentPage = args.currentPage;
        var totalPage = self.getTotalPage();
        var getPageLinkTag = self.getPageLinkTag;

        var totalNumber = self.getTotalNumber();

        var pageSize = attributes.pageSize;
        var showPrevious = attributes.showPrevious;
        var showNext = attributes.showNext;
        var showPageNumbers = attributes.showPageNumbers;
        var showNavigator = attributes.showNavigator;
        var showSizeChanger = attributes.showSizeChanger;
        var sizeChangerOptions = attributes.sizeChangerOptions;
        var showGoInput = attributes.showGoInput;
        var showGoButton = attributes.showGoButton;

        var prevText = attributes.prevText;
        var nextText = attributes.nextText;
        var goButtonText = attributes.goButtonText;

        var classPrefix = attributes.classPrefix;
        var disableClassName = attributes.disableClassName || '';
        var ulClassName = attributes.ulClassName || '';
        var prevClassName = attributes.prevClassName || '';
        var nextClassName = attributes.nextClassName || '';

        var html = '';
        var sizeSelect = '<select class="J-paginationjs-size-select">';
        var goInput = '<input type="text" class="J-paginationjs-go-pagenumber">';
        var goButton = '<input type="button" class="J-paginationjs-go-button" value="' + goButtonText + '">';
        var formattedString;

        var formatSizeChanger = typeof attributes.formatSizeChanger === 'function' ? attributes.formatSizeChanger(currentPage, totalPage, totalNumber) : attributes.formatSizeChanger;
        var formatNavigator = typeof attributes.formatNavigator === 'function' ? attributes.formatNavigator(currentPage, totalPage, totalNumber) : attributes.formatNavigator;
        var formatGoInput = typeof attributes.formatGoInput === 'function' ? attributes.formatGoInput(goInput, currentPage, totalPage, totalNumber) : attributes.formatGoInput;
        var formatGoButton = typeof attributes.formatGoButton === 'function' ? attributes.formatGoButton(goButton, currentPage, totalPage, totalNumber) : attributes.formatGoButton;

        var autoHidePrevious = typeof attributes.autoHidePrevious === 'function' ? attributes.autoHidePrevious() : attributes.autoHidePrevious;
        var autoHideNext = typeof attributes.autoHideNext === 'function' ? attributes.autoHideNext() : attributes.autoHideNext;

        var header = typeof attributes.header === 'function' ? attributes.header(currentPage, totalPage, totalNumber) : attributes.header;
        var footer = typeof attributes.footer === 'function' ? attributes.footer(currentPage, totalPage, totalNumber) : attributes.footer;

        // Prepend extra contents to the pagination buttons
        if (header) {
          formattedString = self.replaceVariables(header, {
            currentPage: currentPage,
            totalPage: totalPage,
            totalNumber: totalNumber
          });
          html += formattedString;
        }

        // Whether to display navigator
        if (showNavigator) {
          if (formatNavigator) {
            formattedString = self.replaceVariables(formatNavigator, {
              currentPage: currentPage,
              totalPage: totalPage,
              totalNumber: totalNumber,
              rangeStart: (currentPage - 1) * pageSize + 1,
              rangeEnd: Math.min(currentPage * pageSize, totalNumber)
            });
            html += '<div class="' + classPrefix + '-nav J-paginationjs-nav">' + formattedString + '</div>';
          }
        }

        if (showPrevious || showPageNumbers || showNext) {
          html += '<div class="paginationjs-pages">';

          if (ulClassName) {
            html += '<ul class="' + ulClassName + '">';
          } else {
            html += '<ul>';
          }

          // Whether to display Previous button
          if (showPrevious) {
            if (currentPage <= 1) {
              if (!autoHidePrevious) {
                html += '<li class="' + classPrefix + '-prev ' + disableClassName + ' ' + prevClassName + '"><a>' + prevText + '</a></li>';
              }
            } else {
              html += '<li class="' + classPrefix + '-prev J-paginationjs-previous ' + prevClassName + '" data-num="' + (currentPage - 1) + '" title="Previous page">' + getPageLinkTag(prevText) + '</li>';
            }
          }

          // Whether to display page numbers
          if (showPageNumbers) {
            html += self.generatePageNumbersHTML(args);
          }

          // Whether to display Next button
          if (showNext) {
            if (currentPage >= totalPage) {
              if (!autoHideNext) {
                html += '<li class="' + classPrefix + '-next ' + disableClassName + ' ' + nextClassName + '"><a>' + nextText + '</a></li>';
              }
            } else {
              html += '<li class="' + classPrefix + '-next J-paginationjs-next ' + nextClassName + '" data-num="' + (currentPage + 1) + '" title="Next page">' + getPageLinkTag(nextText) + '</li>';
            }
          }
          html += '</ul></div>';
        }

        if (showSizeChanger) {
          if (Helpers.isArray(sizeChangerOptions)) {
            if (sizeChangerOptions.indexOf(pageSize) === -1) {
              sizeChangerOptions.unshift(pageSize);
                sizeChangerOptions.sort(function (a, b) { return a - b; });
            }
            for (var ii = 0; ii < sizeChangerOptions.length; ii++) {
              sizeSelect += '<option value="' + sizeChangerOptions[ii] + '"' + (sizeChangerOptions[ii] === pageSize ? ' selected' : '') + '>' + sizeChangerOptions[ii] + ' / page</option>';
            }
            sizeSelect += '</select>';
            formattedString = sizeSelect;

            if (formatSizeChanger) {
              formattedString = self.replaceVariables(formatSizeChanger, {
                length: sizeSelect,
                total: totalNumber
              });
            }
            html += '<div class="paginationjs-size-changer">' + formattedString + '</div>';
          }
        }

        // Whether to display Go input
        if (showGoInput) {
          if (formatGoInput) {
            formattedString = self.replaceVariables(formatGoInput, {
              currentPage: currentPage,
              totalPage: totalPage,
              totalNumber: totalNumber,
              input: goInput
            });
            html += '<div class="' + classPrefix + '-go-input">' + formattedString + '</div>';
          }
        }

        // Whether to display Go button
        if (showGoButton) {
          if (formatGoButton) {
            formattedString = self.replaceVariables(formatGoButton, {
              currentPage: currentPage,
              totalPage: totalPage,
              totalNumber: totalNumber,
              button: goButton
            });
            html += '<div class="' + classPrefix + '-go-button">' + formattedString + '</div>';
          }
        }

        // Append extra contents to the pagination buttons
        if (footer) {
          formattedString = self.replaceVariables(footer, {
            currentPage: currentPage,
            totalPage: totalPage,
            totalNumber: totalNumber
          });
          html += formattedString;
        }

        return html;
      },

      // dataSource is a request URL and a 'totalNumberLocator' function specified
      // execute it to find out 'totalNumber' from the response
      findTotalNumberFromRemoteResponse: function (response) {
        var self = this;
        self.model.totalNumber = attributes.totalNumberLocator(response);
      },

      // Go to the specified page
      go: function (number, callback) {
        var self = this;
        var model = self.model;

        if (self.disabled) return;

        var pageNumber = number;
        pageNumber = parseInt(pageNumber);

        if (!pageNumber || pageNumber < 1) return;

        var pageSize = attributes.pageSize;
        var totalNumber = self.getTotalNumber();
        var totalPage = self.getTotalPage();

        if (totalNumber > 0 && pageNumber > totalPage) return;

        // Pick paging data in synchronous mode
        if (!self.isAsync) {
          render(self.getPagingData(pageNumber));
          return;
        }

        var postData = {};
        var alias = attributes.alias || {};
        var pageSizeName = alias.pageSize ? alias.pageSize : 'pageSize';
        var pageNumberName = alias.pageNumber ? alias.pageNumber : 'pageNumber';
        postData[pageSizeName] = pageSize;
        postData[pageNumberName] = pageNumber;

        var ajaxParams = typeof attributes.ajax === 'function' ? attributes.ajax() : attributes.ajax;

        // If the pageNumber's value starts with 0 via Ajax
        if (ajaxParams && ajaxParams.pageNumberStartWithZero) {
          postData[pageNumberName] = pageNumber - 1;
        }

        var formatAjaxParams = {
          type: 'get',
          cache: false,
          data: {},
          contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
          dataType: 'json',
          async: true
        };

        $.extend(true, formatAjaxParams, ajaxParams);
        $.extend(formatAjaxParams.data, postData);

        formatAjaxParams.url = attributes.dataSource;
        formatAjaxParams.success = function (response) {
          try {
            self.model.originalResponse = response;
            if (self.isDynamicTotalNumber) {
              self.findTotalNumberFromRemoteResponse(response);
            } else {
              self.model.totalNumber = attributes.totalNumber;
            }

            var finalData = self.filterDataWithLocator(response);
            render(finalData);
          } catch (e) {
            if (typeof attributes.onError === 'function') {
              attributes.onError(e, 'ajaxSuccessHandlerError');
            } else {
              throw e;
            }
          }
        };
        formatAjaxParams.error = function (jqXHR, textStatus, errorThrown) {
          attributes.formatAjaxError && attributes.formatAjaxError(jqXHR, textStatus, errorThrown);
          self.enable();
        };

        self.disable();

        if (attributes.ajaxFunction) {
          attributes.ajaxFunction(formatAjaxParams);
        } else {
          $.ajax(formatAjaxParams);
        }

        function render(data) {
          if (self.callHook('beforePaging', pageNumber) === false) return false;

          // Pagination direction
          model.direction = typeof model.pageNumber === 'undefined' ? 0 : (pageNumber > model.pageNumber ? 1 : -1);

          model.pageNumber = pageNumber;

          self.render();

          if (self.disabled && self.isAsync) {
            // enable pagination
            self.enable();
          }

          // cache model data
          container.data('pagination').model = model;

          // format result data before callback invoked
          if (attributes.formatResult) {
            var cloneData = $.extend(true, [], data);
            if (!Helpers.isArray(data = attributes.formatResult(cloneData))) {
              data = cloneData;
            }
          }

          container.data('pagination').currentPageData = data;

          self.doCallback(data, callback);

          self.callHook('afterPaging', pageNumber);

          if (pageNumber == 1) {
            self.callHook('afterIsFirstPage');
          } else if (pageNumber == self.getTotalPage()) {
            self.callHook('afterIsLastPage');
          }
        }
      },

      doCallback: function (data, customCallback) {
        var self = this;
        var model = self.model;

        if (typeof customCallback === 'function') {
          customCallback(data, model);
        } else if (typeof attributes.callback === 'function') {
          attributes.callback(data, model);
        }
      },

      destroy: function () {
        if (this.callHook('beforeDestroy') === false) return;

        this.model.el.remove();
        container.off();

        // Remove style element
        $('#paginationjs-style').remove();

        this.callHook('afterDestroy');
      },

      previous: function (callback) {
        this.go(this.model.pageNumber - 1, callback);
      },

      next: function (callback) {
        this.go(this.model.pageNumber + 1, callback);
      },

      disable: function () {
        var self = this;
        var source = self.isAsync ? 'async' : 'sync';

        if (self.callHook('beforeDisable', source) === false) return;

        self.disabled = true;
        self.model.disabled = true;

        self.callHook('afterDisable', source);
      },

      enable: function () {
        var self = this;
        var source = self.isAsync ? 'async' : 'sync';

        if (self.callHook('beforeEnable', source) === false) return;

        self.disabled = false;
        self.model.disabled = false;

        self.callHook('afterEnable', source);
      },

      refresh: function (callback) {
        this.go(this.model.pageNumber, callback);
      },

      show: function () {
        var self = this;

        if (self.model.el.is(':visible')) return;

        self.model.el.show();
      },

      hide: function () {
        var self = this;

        if (!self.model.el.is(':visible')) return;

        self.model.el.hide();
      },

      // Replace variables for template string
      replaceVariables: function (template, variables) {
        var formattedString;

        for (var key in variables) {
          var value = variables[key];
          var regexp = new RegExp('<%=\\s*' + key + '\\s*%>', 'img');

          formattedString = (formattedString || template).replace(regexp, value);
        }

        return formattedString;
      },

      getPagingData: function (number) {
        var pageSize = attributes.pageSize;
        var dataSource = attributes.dataSource;
        var totalNumber = this.getTotalNumber();

        var start = pageSize * (number - 1) + 1;
        var end = Math.min(number * pageSize, totalNumber);

        return dataSource.slice(start - 1, end);
      },

      getTotalNumber: function () {
        return this.model.totalNumber || attributes.totalNumber || 0;
      },

      getTotalPage: function () {
        return Math.ceil(this.getTotalNumber() / attributes.pageSize);
      },

      getLocator: function (locator) {
        var result;

        if (typeof locator === 'string') {
          result = locator;
        } else if (typeof locator === 'function') {
          result = locator();
        } else {
          throwError('"locator" is incorrect. Expect string or function type.');
        }

        return result;
      },

      // Filter data with "locator"
      filterDataWithLocator: function (dataSource) {
        var locator = this.getLocator(attributes.locator);
        var filteredData;

        // Datasource is an Object, use "locator" to locate available data
        if (Helpers.isObject(dataSource)) {
          try {
            $.each(locator.split('.'), function (index, item) {
              filteredData = (filteredData ? filteredData : dataSource)[item];
            });
          }
          catch (e) {
            // ignore
          }

          if (!filteredData) {
            throwError('dataSource.' + locator + ' is undefined.');
          } else if (!Helpers.isArray(filteredData)) {
            throwError('dataSource.' + locator + ' should be an Array.');
          }
        }

        return filteredData || dataSource;
      },

      parseDataSource: function (dataSource, callback) {
        var self = this;

        if (Helpers.isObject(dataSource)) {
          callback(attributes.dataSource = self.filterDataWithLocator(dataSource));
        } else if (Helpers.isArray(dataSource)) {
          callback(attributes.dataSource = dataSource);
        } else if (typeof dataSource === 'function') {
          attributes.dataSource(function (data) {
            if (!Helpers.isArray(data)) {
              throwError('The parameter of "done" Function should be an Array.');
            }
            self.parseDataSource.call(self, data, callback);
          });
        } else if (typeof dataSource === 'string') {
          if (/^https?|file:/.test(dataSource)) {
            attributes.ajaxDataType = 'jsonp';
          }
          callback(dataSource);
        } else {
          throwError('Unexpected dataSource type');
        }
      },

      callHook: function (hook) {
        var paginationData = container.data('pagination') || {};
        var result;

        var args = Array.prototype.slice.apply(arguments);
        args.shift();

        if (attributes[hook] && typeof attributes[hook] === 'function') {
          if (attributes[hook].apply(global, args) === false) {
            result = false;
          }
        }

        if (paginationData.hooks && paginationData.hooks[hook]) {
          $.each(paginationData.hooks[hook], function (index, item) {
            if (item.apply(global, args) === false) {
              result = false;
            }
          });
        }

        return result !== false;
      },

      observer: function () {
        var self = this;
        var el = self.model.el;

        // Go to specified page number
        container.on(eventPrefix + 'go', function (event, pageNumber, done) {
          if (typeof pageNumber === 'string') {
            pageNumber = parseInt(pageNumber.trim());
          }

          if (!pageNumber) return;

          if (typeof pageNumber !== 'number') {
            throwError('"pageNumber" is incorrect. (Number)');
          }

          self.go(pageNumber, done);
        });

        // Page number button click listener
        el.on('click', '.J-paginationjs-page', function (event) {
          var current = $(event.currentTarget);
          var pageNumber = current.attr('data-num').trim();

          if (!pageNumber || current.hasClass(attributes.disableClassName) || current.hasClass(attributes.activeClassName)) return;

          if (self.callHook('beforePageOnClick', event, pageNumber) === false) return false;

          self.go(pageNumber);

          self.callHook('afterPageOnClick', event, pageNumber);

          if (!attributes.pageLink) return false;
        });

        // Previous button click listener
        el.on('click', '.J-paginationjs-previous', function (event) {
          var current = $(event.currentTarget);
          var pageNumber = current.attr('data-num').trim();

          if (!pageNumber || current.hasClass(attributes.disableClassName)) return;

          if (self.callHook('beforePreviousOnClick', event, pageNumber) === false) return false;

          self.go(pageNumber);

          self.callHook('afterPreviousOnClick', event, pageNumber);

          if (!attributes.pageLink) return false;
        });

        // Next button click listener
        el.on('click', '.J-paginationjs-next', function (event) {
          var current = $(event.currentTarget);
          var pageNumber = current.attr('data-num').trim();

          if (!pageNumber || current.hasClass(attributes.disableClassName)) return;

          if (self.callHook('beforeNextOnClick', event, pageNumber) === false) return false;

          self.go(pageNumber);

          self.callHook('afterNextOnClick', event, pageNumber);

          if (!attributes.pageLink) return false;
        });

        // Go button click listener
        el.on('click', '.J-paginationjs-go-button', function (event) {
          var pageNumber = $('.J-paginationjs-go-pagenumber', el).val();

          if (self.callHook('beforeGoButtonOnClick', event, pageNumber) === false) return false;

          container.trigger(eventPrefix + 'go', pageNumber);

          self.callHook('afterGoButtonOnClick', event, pageNumber);
        });

        // go input enter keyup listener
        el.on('keyup', '.J-paginationjs-go-pagenumber', function (event) {
          if (event.which === 13) {
            var pageNumber = $(event.currentTarget).val();

            if (self.callHook('beforeGoInputOnEnter', event, pageNumber) === false) return false;

            container.trigger(eventPrefix + 'go', pageNumber);

            // Maintain the cursor
            $('.J-paginationjs-go-pagenumber', el).focus();

            self.callHook('afterGoInputOnEnter', event, pageNumber);
          }
        });

        el.on('change', '.J-paginationjs-size-select', function (event) {
          var current = $(event.currentTarget);
          var size = parseInt(current.val());
          var currentPage = self.model.pageNumber || attributes.pageNumber;

          if (typeof size !== 'number') return;

          if (self.callHook('beforeSizeSelectorChange', event, size) === false) return false;

          attributes.pageSize = size;
          self.model.pageSize = size;
          self.model.totalPage = self.getTotalPage();
          if (currentPage > self.model.totalPage) {
            currentPage = self.model.totalPage;
          }
          self.go(currentPage);

          self.callHook('afterSizeSelectorChange', event, size);

          if (!attributes.pageLink) return false;
        });

        // Previous page
        container.on(eventPrefix + 'previous', function (event, done) {
          self.previous(done);
        });

        // Next page
        container.on(eventPrefix + 'next', function (event, done) {
          self.next(done);
        });

        // Disable
        container.on(eventPrefix + 'disable', function () {
          self.disable();
        });

        // Enable
        container.on(eventPrefix + 'enable', function () {
          self.enable();
        });

        // Refresh
        container.on(eventPrefix + 'refresh', function (event, done) {
          self.refresh(done);
        });

        // Show
        container.on(eventPrefix + 'show', function () {
          self.show();
        });

        // Hide
        container.on(eventPrefix + 'hide', function () {
          self.hide();
        });

        // Destroy
        container.on(eventPrefix + 'destroy', function () {
          self.destroy();
        });

        // Whether to load the default page
        var validTotalPage = Math.max(self.getTotalPage(), 1)
        var defaultPageNumber = attributes.pageNumber;

        // Default pageNumber should be 1 when totalNumber is dynamic
        if (self.isDynamicTotalNumber) {
          if (attributes.resetPageNumberOnInit) defaultPageNumber = 1;
        }

        if (attributes.triggerPagingOnInit) {
          container.trigger(eventPrefix + 'go', Math.min(defaultPageNumber, validTotalPage));
        }
      }
    };

    // Pagination has been initialized
    if (container.data('pagination') && container.data('pagination').initialized === true) {
      // Handle events
      if (isNumeric(options)) {
        // eg: container.pagination(5)
        container.trigger.call(this, eventPrefix + 'go', options, arguments[1]);
        return this;
      } else if (typeof options === 'string') {
        var args = Array.prototype.slice.apply(arguments);
        args[0] = eventPrefix + args[0];

        switch (options) {
          case 'previous':
          case 'next':
          case 'go':
          case 'disable':
          case 'enable':
          case 'refresh':
          case 'show':
          case 'hide':
          case 'destroy':
            container.trigger.apply(this, args);
            break;
          case 'getSelectedPageNum':
          case 'getCurrentPageNum':
            if (container.data('pagination').model) {
              return container.data('pagination').model.pageNumber;
            } else {
              return container.data('pagination').attributes.pageNumber;
            }
          case 'getTotalPage':
            return Math.ceil(container.data('pagination').model.totalNumber / container.data('pagination').model.pageSize);
          case 'getSelectedPageData':
          case 'getCurrentPageData':
            return container.data('pagination').currentPageData;
          // Whether pagination has been disabled
          case 'isDisabled':
            return container.data('pagination').model.disabled === true;
          default:
            throwError('Unknown action: ' + options);
        }
        return this;
      } else {
        // Uninstall the old instance before initializing a new one
        uninstallPlugin(container);
      }
    } else {
      if (!Helpers.isObject(options)) throwError('Illegal options');
    }

    // Check parameters
    parameterChecker(attributes);

    pagination.initialize();

    return this;
  };

  // Instance defaults
  $.fn[pluginName].defaults = {

    // Data source
    // Array | String | Function | Object
    //dataSource: '',

    // String | Function
    //locator: 'data',

    // Function
    //totalNumberLocator: function() {},

    // Total number of data items
    totalNumber: 0,

    // Default page number
    pageNumber: 1,

    // Number of data items per page
    pageSize: 10,

    // Page range (pages around current page)
    pageRange: 2,

    // Whether to display the 'Previous' button
    showPrevious: true,

    // Whether to display the 'Next' button
    showNext: true,

    // Whether to display the page buttons
    showPageNumbers: true,

    showNavigator: false,

    // Whether to display the 'Go' input
    showGoInput: false,

    // Whether to display the 'Go' button
    showGoButton: false,

    showSizeChanger: false,

    sizeChangerOptions: [10, 20, 50, 100],

    // Page link
    pageLink: '',

    // 'Previous' text
    prevText: '&lsaquo;',

    // 'Next' text
    nextText: '&rsaquo;',

    // Ellipsis text
    ellipsisText: '...',

    // 'Go' button text
    goButtonText: 'Go',

    // Additional class name(s) for the Pagination container
    //className: '',

    classPrefix: 'paginationjs',

    activeClassName: 'active',

    // class name when disabled
    disableClassName: 'disabled',

    //ulClassName: '',

    //pageClassName: '',

    //prevClassName: '',

    //nextClassName: '',

    formatNavigator: 'Total <%= totalNumber %> items',

    formatGoInput: '<%= input %>',

    formatGoButton: '<%= button %>',

    // position in the container
    position: 'bottom',

    // Auto hide previous button when current page is the first
    autoHidePrevious: false,

    // Auto hide next button when current page is the last
    autoHideNext: false,

    //header: '',

    //footer: '',

    //alias: {},

    // Whether to trigger pagination at initialization
    triggerPagingOnInit: true,

    // Whether to reset page number at initialization, it works only if dataSource is a URL and totalNumberLocator is specified
    resetPageNumberOnInit: true,

    // Whether to hide pagination when less than one page
    hideOnlyOnePage: false,

    hideFirstOnEllipsisShow: false,

    hideLastOnEllipsisShow: false,

    // Customize item's innerHTML
    callback: function () { }
  };

  // Hook register
  $.fn[pluginHookMethod] = function (hook, callback) {
    if (arguments.length < 2) {
      throwError('Expect 2 arguments at least.');
    }

    if (typeof callback !== 'function') {
      throwError('callback should be a function.');
    }

    var container = $(this);
    var paginationData = container.data('pagination');

    if (!paginationData) {
      container.data('pagination', {});
      paginationData = container.data('pagination');
    }

    !paginationData.hooks && (paginationData.hooks = {});

    //paginationData.hooks[hook] = callback;
    paginationData.hooks[hook] = paginationData.hooks[hook] || [];
    paginationData.hooks[hook].push(callback);

  };

  // Static method
  $[pluginName] = function (selector, options) {
    if (arguments.length < 2) {
      throwError('Requires two parameters.');
    }

    var container;

    // 'selector' is a jQuery object
    if (typeof selector !== 'string' && selector instanceof jQuery) {
      container = selector;
    } else {
      container = $(selector);
    }

    if (!container.length) return;

    container.pagination(options);

    return container;
  };

  // ============================================================
  // helpers
  // ============================================================

  var Helpers = {};

  // Throw error
  function throwError(content) {
    throw new Error('Pagination: ' + content);
  }

  // Check parameters
  function parameterChecker(args) {
    if (!args.dataSource) {
      throwError('"dataSource" is required.');
    }

    if (typeof args.dataSource === 'string') {
      if (args.totalNumberLocator === undefined) {
        if (args.totalNumber === undefined) {
          throwError('"totalNumber" is required.');
        } else if (!isNumeric(args.totalNumber)) {
          throwError('"totalNumber" is incorrect. Expect numberic type');
        }
      } else {
        if (typeof args.totalNumberLocator !== 'function') {
          throwError('"totalNumberLocator" should be a Function.');
        }
      }
    } else if (Helpers.isObject(args.dataSource)) {
      if (typeof args.locator === 'undefined') {
        throwError('"dataSource" is an Object, please specify a "locator".');
      } else if (typeof args.locator !== 'string' && typeof args.locator !== 'function') {
        throwError('' + args.locator + ' is incorrect. Expect string or function type');
      }
    }

    if (args.formatResult !== undefined && typeof args.formatResult !== 'function') {
      throwError('"formatResult" should be a Function.');
    }

    if (args.onError !== undefined && typeof args.onError !== 'function') {
      throwError('"onError" should be a Function.');
    }
  }

  // uninstall plugin
  function uninstallPlugin(target) {
    var events = ['go', 'previous', 'next', 'disable', 'enable', 'refresh', 'show', 'hide', 'destroy'];

    // off all events
    $.each(events, function (index, value) {
      target.off(eventPrefix + value);
    });

    // reset pagination data
    target.data('pagination', {});

    // remove pagination element
    $('.paginationjs', target).remove();
  }

  // Object type detection
  function getObjectType(object, tmp) {
    return ((tmp = typeof (object)) == "object" ? object == null && "null" || Object.prototype.toString.call(object).slice(8, -1) : tmp).toLowerCase();
  }

  function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  $.each(['Object', 'Array', 'String'], function (index, name) {
    Helpers['is' + name] = function (object) {
      return getObjectType(object) === name.toLowerCase();
    };
  });

  /*
   * export via AMD or CommonJS
   * */
  if (typeof define === 'function' && define.amd) {
    define(function () {
      return $;
    });
  }

})(this, window.jQuery);
function SetScrollTableShadowStyle(obj) {

    var wrapper = obj;
    var scrollLeft = wrapper.scrollLeft;

    if ($('html').attr("dir") == "rtl" && scrollLeft != 0) {
        scrollLeft = -scrollLeft + 1;
    }

    if (scrollLeft + wrapper.offsetWidth < wrapper.scrollWidth) {
        wrapper.parentElement.classList.add('shadow-right');
    } else {
        wrapper.parentElement.classList.remove('shadow-right');
    }

    if (scrollLeft > 0) {
        if ($('.fixed-column').length == 0) { wrapper.parentElement.classList.add('shadow-left'); }
        $('.spreads-table.clone .fixed-column').addClass('shadow-left');
        $('.broker-spread-table.clone .fixed-column').addClass('shadow-left');
        $('.crypto-payouts-table-div .clone .fixed-column').addClass('shadow-effect-left');
    } else {
        wrapper.parentElement.classList.remove('shadow-left');
        $('.spreads-table.clone .fixed-column').removeClass('shadow-left');
        $('.broker-spread-table.clone .fixed-column').removeClass('shadow-left');
        $('.crypto-payouts-table-div .clone .fixed-column').removeClass('shadow-effect-left');
    }
}
function checkOverflow(elem) {
    const elemWidth = elem.getBoundingClientRect().width
    const parentWidth = elem.parentElement.getBoundingClientRect().width

    return elemWidth > parentWidth
}
function InitializeScrollTable(selectQuery) {
    
    $(selectQuery).each(function (index, elem) {
        if (!elem.parentElement.classList.contains("tablescroll-wrap")) {
            $(elem).wrap('<div class="tablescroll">').wrap('<div class="tablescroll-wrap">');
        }
    })

    $(".tablescroll-wrap").off('scroll').on('scroll', function (e) {
        SetScrollTableShadowStyle(this);
        var that = this;
        if ($('.fixed-header')) {
            $('.scroll-fixed-header').scrollLeft(that.scrollLeft);
        }
    });
    $(".tablescroll-wrap").trigger('scroll');
    $(".tablescroll-wrap").off('mousedown').on('mousedown', function (e) {
        var prev = { x: e.clientX, y: e.clientY };
        this.style.userSelect = 'none';
        var that = this;
        function mouseMoveHandler(me) {
            var delta = prev.x - me.clientX;
            prev.x = me.clientX;

            that.scrollLeft += delta;
            $(that).trigger('scroll');
            if ($('.fixed-header')) {
                var scLeft = $('.scroll-fixed-header').scrollLeft();
                $('.scroll-fixed-header').scrollLeft(scLeft + delta)
            }


        }
        function mouseUpHandler(me) {
            $(document).off('mousemove', mouseMoveHandler);
            $(document).off('mouseup', mouseUpHandler);
            that.style.userSelect = 'initial';
        }

        $(document).mousemove(mouseMoveHandler);
        $(document).mouseup(mouseUpHandler);
    });
    $(".tablescroll-wrap").off('touchstart').on('touchstart', function (e) {
        var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
        var prev = { x: touch.pageX, y: touch.pageY };
        var that = this;
        function touchMoveHandler(me) {
            var mytouch = me.originalEvent.touches[0] || me.originalEvent.changedTouches[0];
            var delta = prev.x - mytouch.pageX;
            prev.x = mytouch.pageX;
            that.scrollLeft += delta;
            $(that).trigger('scroll');
            if ($('.fixed-header')) {
                var scLeft = $('.scroll-fixed-header').scrollLeft();
                $('.scroll-fixed-header').scrollLeft(scLeft + delta);
            }


        }
        function touchUpHandler(me) {
            $(document).off('touchmove', touchMoveHandler);
            $(document).off('touchend', touchUpHandler);
        }

        $(document).on('touchmove', touchMoveHandler);
        $(document).on('touchend', touchUpHandler);
    });
}
/*
 * Toastr
 * Copyright 2012-2015
 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
 * All Rights Reserved.
 * Use, reproduction, distribution, and modification of this code is subject to the terms and
 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
 *
 * ARIA Support: Greta Krafsig
 *
 * Project: https://github.com/CodeSeven/toastr
 */
/* global define */
; (function (define) {
    define(['jquery'], function ($) {
        return (function () {
            var $container;
            var listener;
            var toastId = 0;
            var toastType = {
                error: 'error',
                info: 'info',
                success: 'success',
                warning: 'warning'
            };

            var toastr = {
                clear: clear,
                remove: remove,
                error: error,
                getContainer: getContainer,
                info: info,
                options: {},
                subscribe: subscribe,
                success: success,
                version: '2.1.1',
                warning: warning
            };

            var previousToast;

            return toastr;

            ////////////////

            function error(message, title, optionsOverride) {
                return notify({
                    type: toastType.error,
                    iconClass: getOptions().iconClasses.error,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function getContainer(options, create) {
                if (!options) { options = getOptions(); }
                $container = $('#' + options.containerId);
                if ($container.length) {
                    return $container;
                }
                if (create) {
                    $container = createContainer(options);
                }
                return $container;
            }

            function info(message, title, optionsOverride) {
                return notify({
                    type: toastType.info,
                    iconClass: getOptions().iconClasses.info,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function subscribe(callback) {
                listener = callback;
            }

            function success(message, title, optionsOverride) {
                return notify({
                    type: toastType.success,
                    iconClass: getOptions().iconClasses.success,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function warning(message, title, optionsOverride) {
                return notify({
                    type: toastType.warning,
                    iconClass: getOptions().iconClasses.warning,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function clear($toastElement, clearOptions) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if (!clearToast($toastElement, options, clearOptions)) {
                    clearContainer(options);
                }
            }

            function remove($toastElement) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if ($toastElement && $(':focus', $toastElement).length === 0) {
                    removeToast($toastElement);
                    return;
                }
                if ($container.children().length) {
                    $container.remove();
                }
            }

            // internal functions

            function clearContainer (options) {
                var toastsToClear = $container.children();
                for (var i = toastsToClear.length - 1; i >= 0; i--) {
                    clearToast($(toastsToClear[i]), options);
                }
            }

            function clearToast ($toastElement, options, clearOptions) {
                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
                    $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function () { removeToast($toastElement); }
                    });
                    return true;
                }
                return false;
            }

            function createContainer(options) {
                $container = $('<div/>')
                    .attr('id', options.containerId)
                    .addClass(options.positionClass)
                    .attr('aria-live', 'polite')
                    .attr('role', 'alert');

                $container.appendTo($(options.target));
                return $container;
            }

            function getDefaults() {
                return {
                    tapToDismiss: true,
                    toastClass: 'toast',
                    containerId: 'toast-container',
                    debug: false,

                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
                    showDuration: 300,
                    showEasing: 'swing', //swing and linear are built into jQuery
                    onShown: undefined,
                    hideMethod: 'fadeOut',
                    hideDuration: 1000,
                    hideEasing: 'swing',
                    onHidden: undefined,

                    extendedTimeOut: 1000,
                    iconClasses: {
                        error: 'toast-error',
                        info: 'toast-info',
                        success: 'toast-success',
                        warning: 'toast-warning'
                    },
                    iconClass: 'toast-info',
                    positionClass: 'toast-top-right',
                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
                    titleClass: 'toast-title',
                    messageClass: 'toast-message',
                    target: 'body',
                    closeHtml: '<button type="button">&times;</button>',
                    newestOnTop: true,
                    preventDuplicates: false,
                    progressBar: false
                };
            }

            function publish(args) {
                if (!listener) { return; }
                listener(args);
            }

            function notify(map) {
                var options = getOptions();
                var iconClass = map.iconClass || options.iconClass;

                if (typeof (map.optionsOverride) !== 'undefined') {
                    options = $.extend(options, map.optionsOverride);
                    iconClass = map.optionsOverride.iconClass || iconClass;
                }

                if (shouldExit(options, map)) { return; }

                toastId++;

                $container = getContainer(options, true);

                var intervalId = null;
                var $toastElement = $('<div/>');
                var $titleElement = $('<div/>');
                var $messageElement = $('<div/>');
                var $progressElement = $('<div/>');
                var $closeElement = $(options.closeHtml);
                var progressBar = {
                    intervalId: null,
                    hideEta: null,
                    maxHideTime: null
                };
                var response = {
                    toastId: toastId,
                    state: 'visible',
                    startTime: new Date(),
                    options: options,
                    map: map
                };

                personalizeToast();

                displayToast();

                handleEvents();

                publish(response);

                if (options.debug && console) {
                    console.log(response);
                }

                return $toastElement;

                function personalizeToast() {
                    setIcon();
                    setTitle();
                    setMessage();
                    setCloseButton();
                    setProgressBar();
                    setSequence();
                }

                function handleEvents() {
                    $toastElement.hover(stickAround, delayedHideToast);
                    if (!options.onclick && options.tapToDismiss) {
                        $toastElement.click(hideToast);
                    }

                    if (options.closeButton && $closeElement) {
                        $closeElement.click(function (event) {
                            if (event.stopPropagation) {
                                event.stopPropagation();
                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
                                event.cancelBubble = true;
                            }
                            hideToast(true);
                        });
                    }

                    if (options.onclick) {
                        $toastElement.click(function () {
                            options.onclick();
                            hideToast();
                        });
                    }
                }

                function displayToast() {
                    $toastElement.hide();

                    $toastElement[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
                    );

                    if (options.timeOut > 0) {
                        intervalId = setTimeout(hideToast, options.timeOut);
                        progressBar.maxHideTime = parseFloat(options.timeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                        if (options.progressBar) {
                            progressBar.intervalId = setInterval(updateProgress, 10);
                        }
                    }
                }

                function setIcon() {
                    if (map.iconClass) {
                        $toastElement.addClass(options.toastClass).addClass(iconClass);
                    }
                }

                function setSequence() {
                    if (options.newestOnTop) {
                        $container.prepend($toastElement);
                    } else {
                        $container.append($toastElement);
                    }
                }

                function setTitle() {
                    if (map.title) {
                        $titleElement.append(map.title).addClass(options.titleClass);
                        $toastElement.append($titleElement);
                    }
                }

                function setMessage() {
                    if (map.message) {
                        $messageElement.append(map.message).addClass(options.messageClass);
                        $toastElement.append($messageElement);
                    }
                }

                function setCloseButton() {
                    if (options.closeButton) {
                        $closeElement.addClass('toast-close-button').attr('role', 'button');
                        $toastElement.prepend($closeElement);
                    }
                }

                function setProgressBar() {
                    if (options.progressBar) {
                        $progressElement.addClass('toast-progress');
                        $toastElement.prepend($progressElement);
                    }
                }

                function shouldExit(options, map) {
                    if (options.preventDuplicates) {
                        if (map.message === previousToast) {
                            return true;
                        } else {
                            previousToast = map.message;
                        }
                    }
                    return false;
                }

                function hideToast(override) {
                    if ($(':focus', $toastElement).length && !override) {
                        return;
                    }
                    clearTimeout(progressBar.intervalId);
                    return $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function () {
                            removeToast($toastElement);
                            if (options.onHidden && response.state !== 'hidden') {
                                options.onHidden();
                            }
                            response.state = 'hidden';
                            response.endTime = new Date();
                            publish(response);
                        }
                    });
                }

                function delayedHideToast() {
                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                    }
                }

                function stickAround() {
                    clearTimeout(intervalId);
                    progressBar.hideEta = 0;
                    $toastElement.stop(true, true)[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing}
                    );
                }

                function updateProgress() {
                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
                    $progressElement.width(percentage + '%');
                }
            }

            function getOptions() {
                return $.extend({}, getDefaults(), toastr.options);
            }

            function removeToast($toastElement) {
                if (!$container) { $container = getContainer(); }
                if ($toastElement.is(':visible')) {
                    return;
                }
                $toastElement.remove();
                $toastElement = null;
                if ($container.children().length === 0) {
                    $container.remove();
                    previousToast = undefined;
                }
            }

        })();
    });
}(typeof define === 'function' && define.amd ? define : function (deps, factory) {
    window['toastr'] = factory(window['jQuery']);
}));
